// @ts-nocheck
/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The built-in `Decimal` scalar type. */
  Decimal: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: { input: any; output: any; }
  UUID: { input: string; output: string; }
};

export type Aggregate = {
  __typename?: 'Aggregate';
  cypherCode: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  logic?: Maybe<AggregationLogic>;
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  output?: Maybe<Output>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type AggregatedData = {
  __typename?: 'AggregatedData';
  aggregatedDataScoreInfo: AggregatedDataScoreInfo;
  gap: Scalars['Int']['output'];
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueCount: Scalars['Float']['output'];
  valueMax: Scalars['Float']['output'];
  valueMin: Scalars['Float']['output'];
};

export type AggregatedDataScoreInfo = {
  __typename?: 'AggregatedDataScoreInfo';
  hexColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  positionPercentage: Scalars['Float']['output'];
};

export type AggregatedRmotData = {
  __typename?: 'AggregatedRmotData';
  aggregatedDataScoreInfo: AggregatedDataScoreInfo;
  rmot: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  valueCount: Scalars['Float']['output'];
  valueMax: Scalars['Float']['output'];
  valueMin: Scalars['Float']['output'];
};

export enum AggregatedStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Partial = 'PARTIAL'
}

export enum AggregationIntervals {
  D_01 = 'D_01',
  D_07 = 'D_07',
  D_30 = 'D_30',
  H_01 = 'H_01',
  H_06 = 'H_06',
  M_15 = 'M_15',
  M_30 = 'M_30',
  None = 'NONE'
}

export type AggregationLogic = {
  __typename?: 'AggregationLogic';
  aggregationLogicType: AggregationLogicType;
  buildInAggregationLogic?: Maybe<BuildInAggregationLogic>;
  cypherCode: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isValid: Scalars['Boolean']['output'];
  logic?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  timeWindow?: Maybe<TimeWindow>;
  variables: Array<Variable>;
};

export enum AggregationLogicType {
  AnlogToBinary = 'ANLOG_TO_BINARY',
  AnlogToBinaryLevel = 'ANLOG_TO_BINARY_LEVEL',
  Custom = 'CUSTOM',
  EnergyMeterConsumption = 'ENERGY_METER_CONSUMPTION',
  EnergyMeterCosts = 'ENERGY_METER_COSTS',
  EnergyMeterEmissionsCo2 = 'ENERGY_METER_EMISSIONS_CO2',
  EnergyMeterFactorCo2 = 'ENERGY_METER_FACTOR_CO2',
  EnergyMeterFactorCosts = 'ENERGY_METER_FACTOR_COSTS',
  OperatingSecounds = 'OPERATING_SECOUNDS',
  OutsideAirTemperatureTwAvg = 'OUTSIDE_AIR_TEMPERATURE_TW_AVG',
  OutsideAirTemperatureTwAvg_24H = 'OUTSIDE_AIR_TEMPERATURE_TW_AVG_24H',
  OutsideAirTemperatureTwAvgRmot = 'OUTSIDE_AIR_TEMPERATURE_TW_AVG_RMOT',
  RoomAirDeviation = 'ROOM_AIR_DEVIATION',
  RoomAirDeviationReal = 'ROOM_AIR_DEVIATION_REAL',
  RoomAirDeviationSetPt = 'ROOM_AIR_DEVIATION_SET_PT',
  RoomAirDeviationSetPtReal = 'ROOM_AIR_DEVIATION_SET_PT_REAL',
  RoomAirTwAvgDeviation = 'ROOM_AIR_TW_AVG_DEVIATION',
  RoomAirTwAvgDeviationOccupied = 'ROOM_AIR_TW_AVG_DEVIATION_OCCUPIED',
  RoomAirTwAvgDeviationOccupiedClassA = 'ROOM_AIR_TW_AVG_DEVIATION_OCCUPIED_CLASS_A',
  RoomAirTwAvgDeviationOccupiedClassB = 'ROOM_AIR_TW_AVG_DEVIATION_OCCUPIED_CLASS_B',
  RoomAirTwAvgDeviationOccupiedClassC = 'ROOM_AIR_TW_AVG_DEVIATION_OCCUPIED_CLASS_C',
  RoomAirTwAvgDeviationReal = 'ROOM_AIR_TW_AVG_DEVIATION_REAL',
  RoomAirTwAvgDeviationRealOccupied = 'ROOM_AIR_TW_AVG_DEVIATION_REAL_OCCUPIED',
  RoomAirTwAvgDeviationRealUnoccupied = 'ROOM_AIR_TW_AVG_DEVIATION_REAL_UNOCCUPIED',
  RoomAirTwAvgDeviationSetPt = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT',
  RoomAirTwAvgDeviationSetPtOccupied = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_OCCUPIED',
  RoomAirTwAvgDeviationSetPtOccupiedClassH = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_H',
  RoomAirTwAvgDeviationSetPtOccupiedClassL = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_L',
  RoomAirTwAvgDeviationSetPtOccupiedClassM = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_M',
  RoomAirTwAvgDeviationSetPtReal = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_REAL',
  RoomAirTwAvgDeviationSetPtRealOccupied = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_REAL_OCCUPIED',
  RoomAirTwAvgDeviationSetPtRealUnoccupied = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_REAL_UNOCCUPIED',
  RoomAirTwAvgDeviationSetPtUnoccupied = 'ROOM_AIR_TW_AVG_DEVIATION_SET_PT_UNOCCUPIED',
  RoomAirTwAvgDeviationUnoccupied = 'ROOM_AIR_TW_AVG_DEVIATION_UNOCCUPIED',
  RoomAirTwAvgPpm = 'ROOM_AIR_TW_AVG_PPM',
  RoomAirTwAvgPpmOccupied = 'ROOM_AIR_TW_AVG_PPM_OCCUPIED',
  RoomAirTwAvgPpmUnoccupied = 'ROOM_AIR_TW_AVG_PPM_UNOCCUPIED',
  RoomHumidityDeviation = 'ROOM_HUMIDITY_DEVIATION',
  RoomHumidityDeviationReal = 'ROOM_HUMIDITY_DEVIATION_REAL',
  RoomHumidityDeviationSetPt = 'ROOM_HUMIDITY_DEVIATION_SET_PT',
  RoomHumidityDeviationSetPtReal = 'ROOM_HUMIDITY_DEVIATION_SET_PT_REAL',
  RoomHumidityTwAvgDeviation = 'ROOM_HUMIDITY_TW_AVG_DEVIATION',
  RoomHumidityTwAvgDeviationOccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_OCCUPIED',
  RoomHumidityTwAvgDeviationOccupiedClassA = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_OCCUPIED_CLASS_A',
  RoomHumidityTwAvgDeviationOccupiedClassB = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_OCCUPIED_CLASS_B',
  RoomHumidityTwAvgDeviationOccupiedClassC = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_OCCUPIED_CLASS_C',
  RoomHumidityTwAvgDeviationReal = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_REAL',
  RoomHumidityTwAvgDeviationRealOccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_REAL_OCCUPIED',
  RoomHumidityTwAvgDeviationRealUnoccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_REAL_UNOCCUPIED',
  RoomHumidityTwAvgDeviationSetPt = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT',
  RoomHumidityTwAvgDeviationSetPtOccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_OCCUPIED',
  RoomHumidityTwAvgDeviationSetPtOccupiedClassH = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_H',
  RoomHumidityTwAvgDeviationSetPtOccupiedClassL = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_L',
  RoomHumidityTwAvgDeviationSetPtOccupiedClassM = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_M',
  RoomHumidityTwAvgDeviationSetPtReal = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_REAL',
  RoomHumidityTwAvgDeviationSetPtRealOccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_REAL_OCCUPIED',
  RoomHumidityTwAvgDeviationSetPtRealUnoccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_REAL_UNOCCUPIED',
  RoomHumidityTwAvgDeviationSetPtUnoccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_SET_PT_UNOCCUPIED',
  RoomHumidityTwAvgDeviationUnoccupied = 'ROOM_HUMIDITY_TW_AVG_DEVIATION_UNOCCUPIED',
  RoomHumidityTwAvgHumidity = 'ROOM_HUMIDITY_TW_AVG_HUMIDITY',
  RoomHumidityTwAvgHumidityOccupied = 'ROOM_HUMIDITY_TW_AVG_HUMIDITY_OCCUPIED',
  RoomHumidityTwAvgHumidityUnoccupied = 'ROOM_HUMIDITY_TW_AVG_HUMIDITY_UNOCCUPIED',
  RoomOccupanyState = 'ROOM_OCCUPANY_STATE',
  RoomTempDeviation = 'ROOM_TEMP_DEVIATION',
  RoomTempDeviationReal = 'ROOM_TEMP_DEVIATION_REAL',
  RoomTempDeviationSetPt = 'ROOM_TEMP_DEVIATION_SET_PT',
  RoomTempDeviationSetPtReal = 'ROOM_TEMP_DEVIATION_SET_PT_REAL',
  RoomTempTwAvgDeviation = 'ROOM_TEMP_TW_AVG_DEVIATION',
  RoomTempTwAvgDeviationOccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_OCCUPIED',
  RoomTempTwAvgDeviationOccupiedClassA = 'ROOM_TEMP_TW_AVG_DEVIATION_OCCUPIED_CLASS_A',
  RoomTempTwAvgDeviationOccupiedClassB = 'ROOM_TEMP_TW_AVG_DEVIATION_OCCUPIED_CLASS_B',
  RoomTempTwAvgDeviationOccupiedClassC = 'ROOM_TEMP_TW_AVG_DEVIATION_OCCUPIED_CLASS_C',
  RoomTempTwAvgDeviationReal = 'ROOM_TEMP_TW_AVG_DEVIATION_REAL',
  RoomTempTwAvgDeviationRealOccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_REAL_OCCUPIED',
  RoomTempTwAvgDeviationRealUnoccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_REAL_UNOCCUPIED',
  RoomTempTwAvgDeviationSetPt = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT',
  RoomTempTwAvgDeviationSetPtOccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_OCCUPIED',
  RoomTempTwAvgDeviationSetPtOccupiedClassH = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_H',
  RoomTempTwAvgDeviationSetPtOccupiedClassL = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_L',
  RoomTempTwAvgDeviationSetPtOccupiedClassM = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_OCCUPIED_CLASS_M',
  RoomTempTwAvgDeviationSetPtReal = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_REAL',
  RoomTempTwAvgDeviationSetPtRealOccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_REAL_OCCUPIED',
  RoomTempTwAvgDeviationSetPtRealUnoccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_REAL_UNOCCUPIED',
  RoomTempTwAvgDeviationSetPtUnoccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_SET_PT_UNOCCUPIED',
  RoomTempTwAvgDeviationUnoccupied = 'ROOM_TEMP_TW_AVG_DEVIATION_UNOCCUPIED',
  RoomTempTwAvgTemp = 'ROOM_TEMP_TW_AVG_TEMP',
  RoomTempTwAvgTempOccupied = 'ROOM_TEMP_TW_AVG_TEMP_OCCUPIED',
  RoomTempTwAvgTempUnoccupied = 'ROOM_TEMP_TW_AVG_TEMP_UNOCCUPIED',
  SensorStabilityDeviation = 'SENSOR_STABILITY_DEVIATION',
  SensorStabilityTwAvgDeviation = 'SENSOR_STABILITY_TW_AVG_DEVIATION',
  StartStopCount = 'START_STOP_COUNT',
  StartStopStability = 'START_STOP_STABILITY',
  SystemPerformanceDeviation = 'SYSTEM_PERFORMANCE_DEVIATION',
  SystemPerformanceTwAvgDeviation = 'SYSTEM_PERFORMANCE_TW_AVG_DEVIATION',
  SystemScore = 'SYSTEM_SCORE'
}

export enum AggregationTypes {
  Avg = 'AVG',
  Sum = 'SUM'
}

/** Represents an alarm triggered by a specific rule */
export type Alarm = {
  __typename?: 'Alarm';
  /** Whether the alarm is currently active */
  activeState: Scalars['Boolean']['output'];
  /** The timestamp when the alarm was created */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier of the alarm */
  id?: Maybe<Scalars['String']['output']>;
  /** The most accurate timestamp from the timeseries data */
  mostAccurateTimeseriesTimestamp: Scalars['DateTime']['output'];
  /** The timestamp when the rule was fired */
  ruleFireTimestamp: Scalars['DateTime']['output'];
  /** The identifier of the rule that triggered this alarm */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** The original sensor value that triggered the alarm */
  sensorOriginalValue: Scalars['Float']['output'];
  /** The severity level of the alarm */
  severity: AlarmSeverity;
  tenantId: TenantId;
  /** The timestamp when the alarm was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type AlarmCountInput = {
  dataFilter?: InputMaybe<DataQueryFiltersInput>;
  spaceId: Scalars['String']['input'];
  spaceType: SpaceType;
};

export type AlarmCountResult = {
  __typename?: 'AlarmCountResult';
  active: AlarmStateCount;
  inactive: AlarmStateCount;
};

export type AlarmDataFilterInput = {
  hasFindings?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  ruleLogicCategories?: InputMaybe<Array<RuleLogicCategoryType>>;
  ruleLogicTypes?: InputMaybe<Array<RuleLogicType>>;
  severities?: InputMaybe<Array<Severity>>;
  systems?: InputMaybe<Array<SystemsType>>;
  types?: InputMaybe<Array<AlarmType>>;
};

/** Input filters for querying alarms */
export type AlarmFilterInput = {
  /** Filter by active state */
  activeState?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit the number of results returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Start date for reading data */
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** End date for reading data */
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter by rule IDs */
  ruleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Filter by alarm severities */
  severities?: InputMaybe<Array<InputMaybe<AlarmSeverity>>>;
  /** The number of items to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export enum AlarmGroupBy {
  Location = 'LOCATION',
  Subsystem = 'SUBSYSTEM',
  System = 'SYSTEM'
}

export type AlarmGroupDetails = {
  __typename?: 'AlarmGroupDetails';
  group: AlarmGroupNode;
  logicTypeGroups: Array<AlarmLogicTypeGroup>;
};

export type AlarmGroupNode = {
  __typename?: 'AlarmGroupNode';
  alarmCount: Scalars['Int']['output'];
  depth: Scalars['Int']['output'];
  groupBy: AlarmGroupBy;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  lastTriggered?: Maybe<Scalars['DateTime']['output']>;
  path: Array<Scalars['String']['output']>;
  timelineStatistics: TimelineStatisticsResult;
  totalActiveDurationMinutes: Scalars['Float']['output'];
  totalAlertCount: Scalars['Int']['output'];
};

export type AlarmGroupedTimelineResponse = {
  __typename?: 'AlarmGroupedTimelineResponse';
  endDate: Scalars['DateTime']['output'];
  groups: Array<AlarmGroupNode>;
  spaceAlarmCounts: Array<SpaceAlarmCount>;
  startDate: Scalars['DateTime']['output'];
};

export type AlarmId = {
  __typename?: 'AlarmId';
  value: Scalars['UUID']['output'];
};

export type AlarmListItem = {
  __typename?: 'AlarmListItem';
  date: Scalars['DateTime']['output'];
  hasFindings: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  installations: Array<AlarmSystemHierarchy>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['UUID']['output'];
  ruleLogicCategory?: Maybe<RuleLogicCategoryType>;
  ruleLogicType?: Maybe<RuleLogicType>;
  severity: Severity;
  spaces: Array<Space>;
  system?: Maybe<SystemsType>;
  type: AlarmType;
};

export type AlarmLogicTypeGroup = {
  __typename?: 'AlarmLogicTypeGroup';
  alarmCount: Scalars['Int']['output'];
  alarms: Array<AlarmWithTimelineResult>;
  id: Scalars['String']['output'];
  logicType: Scalars['String']['output'];
  timelineStatistics?: Maybe<TimelineStatisticsResult>;
  totalActiveDurationMinutes: Scalars['Float']['output'];
  totalAlertCount: Scalars['Int']['output'];
};

/** Alarm notification object */
export type AlarmNotificationInput = {
  /** Alert time */
  alertTime: Scalars['DateTime']['input'];
  /** Description of the alarm notification */
  description: Scalars['String']['input'];
  /** Finding */
  finding?: InputMaybe<Scalars['String']['input']>;
  /** Link to alert */
  linkToAlert: Scalars['String']['input'];
  /** Roles of users that should receive notifications */
  roles: Array<Scalars['String']['input']>;
  /** Severity */
  severity: Scalars['String']['input'];
  /** Space */
  space?: InputMaybe<Scalars['String']['input']>;
  /** State */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Alarm notification title */
  title: Scalars['String']['input'];
};

/** Represents the severity level of an alarm */
export enum AlarmSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum AlarmState {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type AlarmStateCount = {
  __typename?: 'AlarmStateCount';
  count: Scalars['Int']['output'];
  findings: Scalars['Int']['output'];
};

export type AlarmStateHistoryItem = {
  __typename?: 'AlarmStateHistoryItem';
  state: AlarmState;
  timestamp: Scalars['DateTime']['output'];
};

export type AlarmStatisticsData = {
  __typename?: 'AlarmStatisticsData';
  count: Scalars['Int']['output'];
  duration: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type AlarmStatisticsInput = {
  alarmId?: InputMaybe<Scalars['String']['input']>;
  dataFilter?: InputMaybe<DataQueryFiltersInput>;
};

export type AlarmStatisticsOrderByInput = {
  count?: InputMaybe<SortDirection>;
  duration?: InputMaybe<SortDirection>;
  lastTriggered?: InputMaybe<SortDirection>;
};

export type AlarmSystemHierarchy = {
  __typename?: 'AlarmSystemHierarchy';
  category: Scalars['String']['output'];
  controlLoop?: Maybe<Point>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AlarmTimelineStatisticsResponse = {
  __typename?: 'AlarmTimelineStatisticsResponse';
  alarms: Array<AlarmWithTimelineResult>;
  endDate: Scalars['DateTime']['output'];
  spaceAlarmCounts: Array<SpaceAlarmCount>;
  startDate: Scalars['DateTime']['output'];
};

export enum AlarmType {
  Alarm = 'ALARM',
  SystemError = 'SYSTEM_ERROR',
  Unhealthy = 'UNHEALTHY',
  Warning = 'WARNING'
}

export type AlarmWithTimelineResult = {
  __typename?: 'AlarmWithTimelineResult';
  date: Scalars['DateTime']['output'];
  hasFindings: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  installations: Array<AlarmSystemHierarchy>;
  isActive: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['UUID']['output'];
  ruleLogicCategory?: Maybe<RuleLogicCategoryType>;
  ruleLogicType?: Maybe<RuleLogicType>;
  severity: Severity;
  spaces: Array<Space>;
  system?: Maybe<SystemsType>;
  timelineStatistics?: Maybe<TimelineStatisticsResult>;
  type: AlarmType;
};

export type AlarmsCount = {
  __typename?: 'AlarmsCount';
  count: Scalars['Int']['output'];
};

export type AlarmsDrawerFilterInput = {
  alarmDataFilter?: InputMaybe<AlarmDataFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type AlarmsDrawerResult = {
  __typename?: 'AlarmsDrawerResult';
  installations: Array<AlarmSystemHierarchy>;
  items: Array<AlarmListItem>;
  spaces: Array<Space>;
  title: Scalars['String']['output'];
};

export type AlarmsFilterInput = {
  alarmDataFilter?: InputMaybe<AlarmDataFilterInput>;
  dataFilter?: InputMaybe<DataQueryFiltersInput>;
  orderBy?: InputMaybe<AlarmStatisticsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  spaceFilter?: InputMaybe<SpaceInput>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type AncillaryFile = {
  __typename?: 'AncillaryFile';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  kind: AncillaryFileKind;
  latestVersion: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version?: Maybe<AncillaryFileVersion>;
  versions: Array<AncillaryFileVersionInfo>;
};


export type AncillaryFileVersionArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type AncillaryFileVersionsArgs = {
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};

export enum AncillaryFileKind {
  Csv = 'CSV',
  Ede = 'EDE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Xml = 'XML',
  Yaml = 'YAML'
}

export type AncillaryFileVersion = {
  __typename?: 'AncillaryFileVersion';
  comment?: Maybe<Scalars['String']['output']>;
  contentBase64: Scalars['String']['output'];
  contentHash: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  tenantId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
};

export type AncillaryFileVersionInfo = {
  __typename?: 'AncillaryFileVersionInfo';
  comment?: Maybe<Scalars['String']['output']>;
  contentHash: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  tenantId: Scalars['UUID']['output'];
  version: Scalars['Int']['output'];
};

export type AncillaryImportResult = {
  __typename?: 'AncillaryImportResult';
  commitSha: Scalars['String']['output'];
  dryRun: Scalars['Boolean']['output'];
  files: Array<AncillaryImportedFile>;
  semanticModelsSlug: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type AncillaryImportedFile = {
  __typename?: 'AncillaryImportedFile';
  contentType: Scalars['String']['output'];
  created: Scalars['Boolean']['output'];
  kind: AncillaryFileKind;
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Int']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type Attribute = {
  __typename?: 'Attribute';
  dataType: DataTypes;
  description?: Maybe<Scalars['String']['output']>;
  deviceAttributeValues: Array<DeviceAttributeValue>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  mappingAttributeDeviceModelAttributeSets: Array<MappingAttributeDeviceModelAttributeSet>;
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


export type AttributeDeviceAttributeValuesArgs = {
  order?: InputMaybe<Array<DeviceAttributeValueSortInput>>;
  where?: InputMaybe<DeviceAttributeValueFilterInput>;
};


export type AttributeMappingAttributeDeviceModelAttributeSetsArgs = {
  order?: InputMaybe<Array<MappingAttributeDeviceModelAttributeSetSortInput>>;
  where?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
};

export type AttributeCreateType = {
  dataType: DataTypes;
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AttributeDataType {
  Co2EmissionsFactor = 'CO2_EMISSIONS_FACTOR',
  CostFactor = 'COST_FACTOR',
  OccupancyState = 'OCCUPANCY_STATE',
  RoomCo2Setpoint = 'ROOM_CO2_SETPOINT',
  RoomHumiditySetpoint = 'ROOM_HUMIDITY_SETPOINT',
  RoomTemperatureSetpoint = 'ROOM_TEMPERATURE_SETPOINT'
}

export type AttributeDefinition = {
  __typename?: 'AttributeDefinition';
  dataType: DataTypes;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type AttributeDefinitionFilterInput = {
  and?: InputMaybe<Array<AttributeDefinitionFilterInput>>;
  dataType?: InputMaybe<DataTypesOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AttributeDefinitionFilterInput>>;
  required?: InputMaybe<BooleanOperationFilterInput>;
};

export type AttributeFilterInput = {
  and?: InputMaybe<Array<AttributeFilterInput>>;
  attributeId?: InputMaybe<UuidOperationFilterInput>;
  dataType?: InputMaybe<DataTypesOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceAttributeValues?: InputMaybe<ListFilterInputTypeOfDeviceAttributeValueFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingAttributeDeviceModelAttributeSets?: InputMaybe<ListFilterInputTypeOfMappingAttributeDeviceModelAttributeSetFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AttributeFilterInput>>;
  required?: InputMaybe<BooleanOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type AttributeIdAttributeValueInputType = {
  attributeId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AttributeSetNullInputType = {
  dataType?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  deviceAttributeValues?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappingAttributeDeviceModelAttributeSets?: InputMaybe<Scalars['Boolean']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttributeSortInput = {
  attributeId?: InputMaybe<SortEnumType>;
  dataType?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  required?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type AttributeUpdateType = {
  dataType?: InputMaybe<DataTypes>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AttributeWithValue = {
  __typename?: 'AttributeWithValue';
  attribute?: Maybe<Attribute>;
  value?: Maybe<Scalars['String']['output']>;
};

export type AttributesByBuildings = {
  __typename?: 'AttributesByBuildings';
  buildingId?: Maybe<Scalars['UUID']['output']>;
  deviceAttributes?: Maybe<Array<AttributeDefinition>>;
};

/** A segment of a collection. */
export type AttributesByBuildingsCollectionSegment = {
  __typename?: 'AttributesByBuildingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AttributesByBuildings>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AttributesByBuildingsFilterInput = {
  and?: InputMaybe<Array<AttributesByBuildingsFilterInput>>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  deviceAttributes?: InputMaybe<ListFilterInputTypeOfAttributeDefinitionFilterInput>;
  or?: InputMaybe<Array<AttributesByBuildingsFilterInput>>;
};

export type AttributesByBuildingsSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AttributesCollectionSegment = {
  __typename?: 'AttributesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Attribute>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  action?: Maybe<Scalars['String']['output']>;
  changeDate: Scalars['DateTime']['output'];
  entity?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  service?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  userId: Scalars['UUID']['output'];
};

export type AuditLogCreateType = {
  action?: InputMaybe<Scalars['String']['input']>;
  changeDate: Scalars['DateTime']['input'];
  entity?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['UUID']['input'];
};

export type AuditLogFilterInput = {
  action?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  auditLogId?: InputMaybe<UuidOperationFilterInput>;
  changeDate?: InputMaybe<DateTimeOperationFilterInput>;
  entity?: InputMaybe<StringOperationFilterInput>;
  entityType?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  service?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  userId?: InputMaybe<UuidOperationFilterInput>;
};

export type AuditLogSortInput = {
  action?: InputMaybe<SortEnumType>;
  auditLogId?: InputMaybe<SortEnumType>;
  changeDate?: InputMaybe<SortEnumType>;
  entity?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  service?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AuditLogsCollectionSegment = {
  __typename?: 'AuditLogsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AuditLog>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Author = {
  __typename?: 'Author';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AuthorInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AutomationDevice = {
  __typename?: 'AutomationDevice';
  deviceId?: Maybe<Scalars['String']['output']>;
  firmware?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  ipNetworkId?: Maybe<Scalars['ID']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConnectionStatus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AutomationDevicePage = {
  __typename?: 'AutomationDevicePage';
  items?: Maybe<Array<Maybe<AutomationDevice>>>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AutomationNetwork = {
  __typename?: 'AutomationNetwork';
  address?: Maybe<Scalars['String']['output']>;
  allIpDevicesCount?: Maybe<Scalars['Int']['output']>;
  allIpDevicesOnlineCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldTechnician?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipNetworks?: Maybe<Array<Maybe<IpNetwork>>>;
  ipNetworksCount?: Maybe<Scalars['Int']['output']>;
  mobiles?: Maybe<Array<Maybe<Mobile>>>;
  name?: Maybe<Scalars['String']['output']>;
  networkType?: Maybe<NetworkType>;
  remoteAccessEnabled?: Maybe<Scalars['Boolean']['output']>;
  remoteSessions?: Maybe<Array<Maybe<RemoteAccessSession>>>;
  router?: Maybe<Router>;
  routerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConnectionStatus>;
  vpnNetworkId?: Maybe<Scalars['ID']['output']>;
  vpnNetworkName?: Maybe<Scalars['String']['output']>;
};

export type BacnetMetadata = Metadata & {
  __typename?: 'BacnetMetadata';
  description?: Maybe<Scalars['String']['output']>;
  deviceInstance?: Maybe<Scalars['Int']['output']>;
  objectInstance?: Maybe<Scalars['Int']['output']>;
  objectName?: Maybe<Scalars['String']['output']>;
  objectType?: Maybe<Scalars['String']['output']>;
  protocolType: ProtocolType;
  unitText?: Maybe<Scalars['String']['output']>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BuildInAggregationLogic {
  MeterConsumption = 'METER_CONSUMPTION',
  None = 'NONE',
  Occupied = 'OCCUPIED',
  OperatingTimeBinary = 'OPERATING_TIME_BINARY',
  RunninMeanOutsideAirTemperature = 'RUNNIN_MEAN_OUTSIDE_AIR_TEMPERATURE',
  Standard1RmotBasedDeviation = 'STANDARD1_RMOT_BASED_DEVIATION',
  Standard1RmotBasedDeviationReal = 'STANDARD1_RMOT_BASED_DEVIATION_REAL',
  Standard2RmotBasedDeviation = 'STANDARD2_RMOT_BASED_DEVIATION',
  Standard2RmotBasedDeviationReal = 'STANDARD2_RMOT_BASED_DEVIATION_REAL',
  TimeWeightedAvg = 'TIME_WEIGHTED_AVG',
  UnOccupied = 'UN_OCCUPIED',
  WindowAverage = 'WINDOW_AVERAGE',
  WindowSum = 'WINDOW_SUM'
}

/** I am a generated type! */
export type Building = {
  __typename?: 'Building';
  description?: Maybe<Scalars['String']['output']>;
  dimension?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['UUID']['output']>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  mappingDeviceBuildings?: Maybe<Array<Maybe<MappingDeviceBuilding>>>;
  name: Scalars['String']['output'];
  site: Site;
  siteId: Scalars['UUID']['output'];
  storeys: Array<Storey>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  weather?: Maybe<Weather>;
};


/** I am a generated type! */
export type BuildingStoreysArgs = {
  order?: InputMaybe<Array<StoreySortInput>>;
  where?: InputMaybe<StoreyFilterInput>;
};

export type BuildingCreateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  dimension?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  siteId: Scalars['UUID']['input'];
};

export type BuildingFilterInput = {
  and?: InputMaybe<Array<BuildingFilterInput>>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dimension?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  mappingDeviceBuildings?: InputMaybe<ListFilterInputTypeOfMappingDeviceBuildingFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BuildingFilterInput>>;
  site?: InputMaybe<SiteFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  storeys?: InputMaybe<ListFilterInputTypeOfStoreyFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  weather?: InputMaybe<WeatherFilterInput>;
};

/** A segment of a collection. */
export type BuildingFilterTableCollectionSegment = {
  __typename?: 'BuildingFilterTableCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PlacementFilterRow>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuildingSetNullInputType = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dimension?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Scalars['Boolean']['input']>;
  storeys?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuildingSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dimension?: InputMaybe<SortEnumType>;
  image?: InputMaybe<ImageSortInput>;
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  site?: InputMaybe<SiteSortInput>;
  siteId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  weather?: InputMaybe<WeatherSortInput>;
};

export type BuildingUpdateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  dimension?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A segment of a collection. */
export type BuildingsCollectionSegment = {
  __typename?: 'BuildingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Building>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type CapabilitiesCollectionSegment = {
  __typename?: 'CapabilitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Capability>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Capability = {
  __typename?: 'Capability';
  dataType: DataTypes;
  description?: Maybe<Scalars['String']['output']>;
  deviceModelCapabilities: Array<DeviceModelCapability>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


export type CapabilityDeviceModelCapabilitiesArgs = {
  order?: InputMaybe<Array<DeviceModelCapabilitySortInput>>;
  where?: InputMaybe<DeviceModelCapabilityFilterInput>;
};

export type CapabilityCreateType = {
  dataType: DataTypes;
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
};

export type CapabilityFilterInput = {
  and?: InputMaybe<Array<CapabilityFilterInput>>;
  capabilityId?: InputMaybe<UuidOperationFilterInput>;
  dataType?: InputMaybe<DataTypesOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceModelCapabilities?: InputMaybe<ListFilterInputTypeOfDeviceModelCapabilityFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CapabilityFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type CapabilitySetNullInputType = {
  dataType?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CapabilitySortInput = {
  capabilityId?: InputMaybe<SortEnumType>;
  dataType?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type CapabilityUpdateType = {
  dataType?: InputMaybe<DataTypes>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategorizedInstallationParts = {
  __typename?: 'CategorizedInstallationParts';
  category: CategoryType;
  installationParts: Array<InstallationPart>;
};

export type CategorizedInstallationPartsScores = {
  __typename?: 'CategorizedInstallationPartsScores';
  category: CategoryType;
  installationPartScores: Array<InstallationPartScores>;
};

export type CategorizedInstallationPartsTyped = {
  __typename?: 'CategorizedInstallationPartsTyped';
  category: CategoryType;
  installationParts: Array<BuildingInformationSchema_InstallationPartTyped>;
};

export type CategoryScoresInput = {
  category: CategoryType;
  scoreTypeAggregations?: InputMaybe<Array<ScoreTypeAggregationInput>>;
  scoreTypes?: InputMaybe<Array<ScoreType>>;
};

export enum CategoryType {
  Actuators = 'ACTUATORS',
  Components = 'COMPONENTS',
  ControlLoop = 'CONTROL_LOOP',
  Sensors = 'SENSORS'
}

export enum ChannelType {
  BackDelivery = 'BACK_DELIVERY',
  Delivery = 'DELIVERY'
}

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export enum CombinedUnit {
  CubicMeters = 'CUBIC_METERS',
  Eur = 'EUR',
  KilogramsCo2Equivalent = 'KILOGRAMS_CO2_EQUIVALENT',
  KilowattHours = 'KILOWATT_HOURS'
}

export enum ComparisonType {
  BaseLine = 'BASE_LINE',
  PreviousPeriod = 'PREVIOUS_PERIOD',
  SamePeriodLastYear = 'SAME_PERIOD_LAST_YEAR'
}

export type ConfigurationPoint = {
  __typename?: 'ConfigurationPoint';
  bms: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  timeseriesId: Scalars['UUID']['output'];
  uri: Scalars['String']['output'];
};

export enum ConnectionStates {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  NeverConnected = 'NEVER_CONNECTED',
  Unknown = 'UNKNOWN'
}

export type ConnectionStatesOperationFilterInput = {
  eq?: InputMaybe<ConnectionStates>;
  in?: InputMaybe<Array<ConnectionStates>>;
  neq?: InputMaybe<ConnectionStates>;
  nin?: InputMaybe<Array<ConnectionStates>>;
};

export enum ConnectionStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type ConsumptionOrGenerationNode = EnergyNode & {
  __typename?: 'ConsumptionOrGenerationNode';
  dataSources?: Maybe<Array<EnergyNodeDataSource>>;
  id: Scalars['String']['output'];
  type: EnergyNodeType;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CreateDeploymentRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: Scalars['Boolean']['input'];
  graphVersion?: InputMaybe<Scalars['Int']['input']>;
  semanticModelsSlugOverride?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDeploymentRequestPayload = {
  __typename?: 'CreateDeploymentRequestPayload';
  additionalFiles: Array<Scalars['String']['output']>;
  dryRun: Scalars['Boolean']['output'];
  request?: Maybe<DeploymentRequest>;
  sites: Array<SiteFileChange>;
  warnings: Array<Scalars['String']['output']>;
};

export type CreateEnergyContractInput = {
  factors: Array<EnergyContractFactorInput>;
  flowDirection: FlowDirection;
  fromDate: Scalars['Date']['input'];
  meterEntityIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
  utility: Utility;
};

export type CreateFindingInput = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  findingState?: InputMaybe<FindingStateType>;
  followUpActions: Scalars['String']['input'];
  notification?: InputMaybe<Notification>;
  notifiedGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  ruleId: Scalars['ID']['input'];
};

export type CreateSiteAttributeInput = {
  dataType: AttributeDataType;
  entityId: Scalars['String']['input'];
  fromDate: Scalars['Date']['input'];
  schedule: Array<ScheduleTimeRangeInput>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Custom Feature Request object */
export type CustomFeatureRequestInput = {
  /** Description of the request */
  description: Scalars['String']['input'];
  /** Reason of the request */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Roles of users that should receive notifications */
  roles: Array<Scalars['String']['input']>;
  /** User that should send notification */
  sender: UserBaseInput;
  /** Custom feature request title */
  title: Scalars['String']['input'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: DashboardType;
  widgets: Array<Widget>;
};

export type DashboardAlarmOverviewWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardAlarmOverviewWidgetConfiguration';
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardAlarmOverviewWidgetConfigurationInput = {
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardCommonTextWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardCommonTextWidgetConfiguration';
  /** How the divider under the text is drawn. Only meaningful while showDivider is true. */
  dividerStyle: DashboardCommonTextWidgetDividerStyle;
  horizontalAlignment: DashboardCommonTextWidgetHorizontalAlignment;
  showDivider: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variant: DashboardCommonTextWidgetVariant;
  verticalAlignment: DashboardCommonTextWidgetVerticalAlignment;
};

export type DashboardCommonTextWidgetConfigurationInput = {
  /** How the divider under the text is drawn. Only meaningful while showDivider is true. */
  dividerStyle?: InputMaybe<DashboardCommonTextWidgetDividerStyle>;
  horizontalAlignment?: DashboardCommonTextWidgetHorizontalAlignment;
  showDivider?: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  variant?: DashboardCommonTextWidgetVariant;
  verticalAlignment?: DashboardCommonTextWidgetVerticalAlignment;
};

export enum DashboardCommonTextWidgetDividerStyle {
  Dashed = 'DASHED',
  Solid = 'SOLID'
}

export enum DashboardCommonTextWidgetHorizontalAlignment {
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

/** Mirrors the UI kit's typography scale (react-ui Typography variants). */
export enum DashboardCommonTextWidgetVariant {
  BodyLarge = 'BODY_LARGE',
  BodyMedium = 'BODY_MEDIUM',
  BodySmall = 'BODY_SMALL',
  DisplaySmall = 'DISPLAY_SMALL',
  HeadlineLarge = 'HEADLINE_LARGE',
  HeadlineMedium = 'HEADLINE_MEDIUM',
  HeadlineSmall = 'HEADLINE_SMALL',
  LabelLarge = 'LABEL_LARGE',
  LabelMedium = 'LABEL_MEDIUM',
  LabelSmall = 'LABEL_SMALL',
  TitleLarge = 'TITLE_LARGE',
  TitleMedium = 'TITLE_MEDIUM',
  TitleSmall = 'TITLE_SMALL'
}

export enum DashboardCommonTextWidgetVerticalAlignment {
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export type DashboardCommonWeatherWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardCommonWeatherWidgetConfiguration';
  space: DashboardWidgetSpaceSetting;
  title: Scalars['String']['output'];
};

export type DashboardCommonWeatherWidgetConfigurationInput = {
  space: DashboardWidgetSpaceSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardDateRange = {
  __typename?: 'DashboardDateRange';
  from: Scalars['DateTime']['output'];
  until: Scalars['DateTime']['output'];
};

export type DashboardDateRangeInput = {
  from: Scalars['DateTime']['input'];
  until: Scalars['DateTime']['input'];
};

export type DashboardEmptySetting = {
  __typename?: 'DashboardEmptySetting';
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardEmptySettingInput = {
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DashboardEnergyAnalysisWidgetAxisType {
  ColumnAxis = 'COLUMN_AXIS',
  RowAxis = 'ROW_AXIS',
  XAxis = 'X_AXIS',
  YAxis = 'Y_AXIS'
}

export enum DashboardEnergyAnalysisWidgetChartType {
  Donut = 'DONUT',
  HeatMap = 'HEAT_MAP',
  HorizontalBar = 'HORIZONTAL_BAR',
  Line = 'LINE',
  Pie = 'PIE',
  Table = 'TABLE',
  VerticalBar = 'VERTICAL_BAR'
}

export type DashboardEnergyAnalysisWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyAnalysisWidgetConfiguration';
  axises: Array<DashboardEnergyAnalysisWidgetAxisType>;
  chartType: DashboardEnergyAnalysisWidgetChartType;
  dataType: DataType;
  display: Array<DashboardEnergyAnalysisWidgetDisplayType>;
  heatmapDistributionType: DashboardEnergyAnalysisWidgetHeatmapDistributionType;
  manualColorStops?: Maybe<Array<DashboardEnergyAnalysisWidgetHeatmapColorStop>>;
  selectedInterval: AggregationIntervals;
  sortOrder?: Maybe<SortEnumType>;
  space: DashboardWidgetSpaceSetting;
  splitBy: SplitByType;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
  utilities: Array<MediumType>;
  weatherAdjusted?: Maybe<Scalars['Boolean']['output']>;
};

export type DashboardEnergyAnalysisWidgetConfigurationInput = {
  axises?: Array<DashboardEnergyAnalysisWidgetAxisType>;
  chartType?: DashboardEnergyAnalysisWidgetChartType;
  dataType?: DataType;
  display?: Array<DashboardEnergyAnalysisWidgetDisplayType>;
  heatmapDistributionType?: DashboardEnergyAnalysisWidgetHeatmapDistributionType;
  manualColorStops?: InputMaybe<Array<DashboardEnergyAnalysisWidgetHeatmapColorStopInput>>;
  selectedInterval?: AggregationIntervals;
  sortOrder?: InputMaybe<SortEnumType>;
  space: DashboardWidgetSpaceSettingInput;
  splitBy?: SplitByType;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
  utilities?: Array<MediumType>;
  weatherAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DashboardEnergyAnalysisWidgetDisplayType {
  Percentage = 'PERCENTAGE',
  Subtotal = 'SUBTOTAL',
  Total = 'TOTAL'
}

export type DashboardEnergyAnalysisWidgetHeatmapColorStop = {
  __typename?: 'DashboardEnergyAnalysisWidgetHeatmapColorStop';
  color: Scalars['String']['output'];
  threshold: Scalars['Float']['output'];
};

export type DashboardEnergyAnalysisWidgetHeatmapColorStopInput = {
  color: Scalars['String']['input'];
  threshold: Scalars['Float']['input'];
};

export enum DashboardEnergyAnalysisWidgetHeatmapDistributionType {
  Linear = 'LINEAR',
  Manual = 'MANUAL'
}

export type DashboardEnergyConsumptionProfileWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyConsumptionProfileWidgetConfiguration';
  title: Scalars['String']['output'];
};

export type DashboardEnergyConsumptionProfileWidgetConfigurationInput = {
  title: Scalars['String']['input'];
};

export type DashboardEnergyConsumptionWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyConsumptionWidgetConfiguration';
  mediumType: MediumType;
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardEnergyConsumptionWidgetConfigurationInput = {
  mediumType?: MediumType;
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardEnergyDynamicPricingWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyDynamicPricingWidgetConfiguration';
  title: Scalars['String']['output'];
};

export type DashboardEnergyDynamicPricingWidgetConfigurationInput = {
  title: Scalars['String']['input'];
};

export type DashboardEnergyEmissionWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyEmissionWidgetConfiguration';
  title: Scalars['String']['output'];
};

export type DashboardEnergyEmissionWidgetConfigurationInput = {
  title: Scalars['String']['input'];
};

export type DashboardEnergyEvaluationWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyEvaluationWidgetConfiguration';
  title: Scalars['String']['output'];
};

export type DashboardEnergyEvaluationWidgetConfigurationInput = {
  title: Scalars['String']['input'];
};

export enum DashboardEnergyMeterReadingsWidgetChartType {
  Line = 'LINE',
  Table = 'TABLE'
}

export enum DashboardEnergyMeterReadingsWidgetColumn {
  Unit = 'UNIT',
  Utility = 'UTILITY'
}

export type DashboardEnergyMeterReadingsWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyMeterReadingsWidgetConfiguration';
  chartType: DashboardEnergyMeterReadingsWidgetChartType;
  columns: Array<DashboardEnergyMeterReadingsWidgetColumn>;
  locationColumns: Array<SpaceType>;
  meterCategory?: Maybe<MeterCategory>;
  meterDataMode: MeterDataMode;
  selectedInterval: AggregationIntervals;
  showMarkers?: Maybe<Scalars['Boolean']['output']>;
  sortColumn: DashboardEnergyMeterReadingsWidgetSortColumn;
  sortOrder: SortEnumType;
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
  utilities: Array<MediumType>;
};

export type DashboardEnergyMeterReadingsWidgetConfigurationInput = {
  chartType?: DashboardEnergyMeterReadingsWidgetChartType;
  columns?: Array<DashboardEnergyMeterReadingsWidgetColumn>;
  locationColumns?: Array<SpaceType>;
  meterCategory?: InputMaybe<MeterCategory>;
  meterDataMode?: MeterDataMode;
  selectedInterval?: AggregationIntervals;
  showMarkers?: InputMaybe<Scalars['Boolean']['input']>;
  sortColumn?: DashboardEnergyMeterReadingsWidgetSortColumn;
  sortOrder?: SortEnumType;
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
  utilities?: Array<MediumType>;
};

export enum DashboardEnergyMeterReadingsWidgetSortColumn {
  Building = 'BUILDING',
  Datapoint = 'DATAPOINT',
  Level = 'LEVEL',
  MeterReading = 'METER_READING',
  Room = 'ROOM',
  Site = 'SITE',
  SubBuilding = 'SUB_BUILDING',
  Timestamp = 'TIMESTAMP',
  Unit = 'UNIT',
  Utility = 'UTILITY'
}

export type DashboardEnergyRegressionWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergyRegressionWidgetConfiguration';
  /** Consumption or generation side of the medium. */
  energyFlow: Selector1;
  /** Medium whose energy values land on the y-axis. */
  mediumType: MediumType;
  selectedInterval: AggregationIntervals;
  sensorIds: Array<Scalars['String']['output']>;
  sensorType?: Maybe<PointsType>;
  /** Renders the correlation summary (equation, R, R²) under the chart. */
  showCorrelation: Scalars['Boolean']['output'];
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardEnergyRegressionWidgetConfigurationInput = {
  /** Consumption or generation side of the medium. */
  energyFlow?: Selector1;
  /** Medium whose energy values land on the y-axis. */
  mediumType?: MediumType;
  selectedInterval?: AggregationIntervals;
  sensorIds?: Array<Scalars['String']['input']>;
  sensorType?: InputMaybe<PointsType>;
  /** Renders the correlation summary (equation, R, R²) under the chart. */
  showCorrelation?: Scalars['Boolean']['input'];
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardEnergySpendingWidgetConfiguration = DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergySpendingWidgetConfiguration';
  title: Scalars['String']['output'];
};

export type DashboardEnergySpendingWidgetConfigurationInput = {
  title: Scalars['String']['input'];
};

export enum DashboardEnergySummaryWidgetChartType {
  Flow = 'FLOW',
  Sankey = 'SANKEY'
}

export type DashboardEnergySummaryWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardEnergySummaryWidgetConfiguration';
  chartType: DashboardEnergySummaryWidgetChartType;
  mediumType: MediumType;
  /** SANKEY only: the mediums merged into mediumType. */
  sankeyUtilities?: Maybe<Array<MediumType>>;
  space: DashboardWidgetSpaceSetting;
  /** SANKEY only. True with 2+ utilities: one diagram per utility instead of one merged diagram. */
  splitUtilities: Scalars['Boolean']['output'];
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardEnergySummaryWidgetConfigurationInput = {
  chartType?: DashboardEnergySummaryWidgetChartType;
  mediumType?: MediumType;
  /** SANKEY only: the mediums merged into mediumType. */
  sankeyUtilities?: InputMaybe<Array<MediumType>>;
  space: DashboardWidgetSpaceSettingInput;
  /** SANKEY only. True with 2+ utilities: one diagram per utility instead of one merged diagram. */
  splitUtilities?: Scalars['Boolean']['input'];
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardFixedSpaceSetting = {
  __typename?: 'DashboardFixedSpaceSetting';
  spaceId: Scalars['String']['output'];
};

export type DashboardFixedSpaceSettingInput = {
  spaceId: Scalars['String']['input'];
};

export type DashboardFixedTimeInterval = {
  __typename?: 'DashboardFixedTimeInterval';
  range?: Maybe<DashboardDateRange>;
  timeSpan?: Maybe<TimeSpans>;
};

export type DashboardFixedTimeIntervalInput = {
  range?: InputMaybe<DashboardDateRangeInput>;
  timeSpan?: InputMaybe<TimeSpans>;
};

export type DashboardIndoorClimateCorrelationWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardIndoorClimateCorrelationWidgetConfiguration';
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSetting;
  standardId?: Maybe<Scalars['String']['output']>;
  standardType?: Maybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardIndoorClimateCorrelationWidgetConfigurationInput = {
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSettingInput;
  standardId?: InputMaybe<Scalars['String']['input']>;
  standardType?: InputMaybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export enum DashboardIndoorClimateOverviewView {
  Measurement = 'MEASUREMENT',
  Score = 'SCORE'
}

export type DashboardIndoorClimateOverviewWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardIndoorClimateOverviewWidgetConfiguration';
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSetting;
  standardId?: Maybe<Scalars['String']['output']>;
  standardType?: Maybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
  view: DashboardIndoorClimateOverviewView;
};

export type DashboardIndoorClimateOverviewWidgetConfigurationInput = {
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSettingInput;
  standardId?: InputMaybe<Scalars['String']['input']>;
  standardType?: InputMaybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
  view: DashboardIndoorClimateOverviewView;
};

export enum DashboardIndoorClimateScoreType {
  Co2 = 'CO2',
  Humidity = 'HUMIDITY',
  Temperature = 'TEMPERATURE'
}

export type DashboardIndoorClimateScoreWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardIndoorClimateScoreWidgetConfiguration';
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSetting;
  standardId?: Maybe<Scalars['String']['output']>;
  standardType?: Maybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardIndoorClimateScoreWidgetConfigurationInput = {
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
  scoreType: DashboardIndoorClimateScoreType;
  space: DashboardWidgetSpaceSettingInput;
  standardId?: InputMaybe<Scalars['String']['input']>;
  standardType?: InputMaybe<IndoorClimateStandardType>;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardInput = {
  name: Scalars['String']['input'];
  type: DashboardType;
  widgets?: InputMaybe<Array<WidgetInput>>;
};

export type DashboardInstallationCategoryScoreWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardInstallationCategoryScoreWidgetConfiguration';
  space: DashboardWidgetSpaceSetting;
  systemType: SystemsType;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardInstallationCategoryScoreWidgetConfigurationInput = {
  space: DashboardWidgetSpaceSettingInput;
  systemType: SystemsType;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardInstallationPerformanceWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardInstallationPerformanceWidgetConfiguration';
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardInstallationPerformanceWidgetConfigurationInput = {
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export type DashboardScopedWidgetConfiguration = {
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardSensorValuesWidgetConfiguration = DashboardScopedWidgetConfiguration & DashboardWidgetConfigurationBase & {
  __typename?: 'DashboardSensorValuesWidgetConfiguration';
  sensorIds: Array<Scalars['String']['output']>;
  sensorType?: Maybe<PointsType>;
  space: DashboardWidgetSpaceSetting;
  timeInterval: DashboardWidgetTimeIntervalSetting;
  title: Scalars['String']['output'];
};

export type DashboardSensorValuesWidgetConfigurationInput = {
  sensorIds?: Array<Scalars['String']['input']>;
  sensorType?: InputMaybe<PointsType>;
  space: DashboardWidgetSpaceSettingInput;
  timeInterval: DashboardWidgetTimeIntervalSettingInput;
  title: Scalars['String']['input'];
};

export enum DashboardType {
  Energy = 'ENERGY',
  Generic = 'GENERIC',
  IndoorClimate = 'INDOOR_CLIMATE',
  Installation = 'INSTALLATION'
}

export type DashboardWidgetConfiguration = DashboardAlarmOverviewWidgetConfiguration | DashboardCommonTextWidgetConfiguration | DashboardCommonWeatherWidgetConfiguration | DashboardEnergyAnalysisWidgetConfiguration | DashboardEnergyConsumptionProfileWidgetConfiguration | DashboardEnergyConsumptionWidgetConfiguration | DashboardEnergyDynamicPricingWidgetConfiguration | DashboardEnergyEmissionWidgetConfiguration | DashboardEnergyEvaluationWidgetConfiguration | DashboardEnergyMeterReadingsWidgetConfiguration | DashboardEnergyRegressionWidgetConfiguration | DashboardEnergySpendingWidgetConfiguration | DashboardEnergySummaryWidgetConfiguration | DashboardIndoorClimateCorrelationWidgetConfiguration | DashboardIndoorClimateOverviewWidgetConfiguration | DashboardIndoorClimateScoreWidgetConfiguration | DashboardInstallationCategoryScoreWidgetConfiguration | DashboardInstallationPerformanceWidgetConfiguration | DashboardSensorValuesWidgetConfiguration;

export type DashboardWidgetConfigurationBase = {
  title: Scalars['String']['output'];
};

export type DashboardWidgetConfigurationInput = {
  alarmOverview?: InputMaybe<DashboardAlarmOverviewWidgetConfigurationInput>;
  commonText?: InputMaybe<DashboardCommonTextWidgetConfigurationInput>;
  commonWeather?: InputMaybe<DashboardCommonWeatherWidgetConfigurationInput>;
  energyAnalysis?: InputMaybe<DashboardEnergyAnalysisWidgetConfigurationInput>;
  energyConsumption?: InputMaybe<DashboardEnergyConsumptionWidgetConfigurationInput>;
  energyConsumptionProfile?: InputMaybe<DashboardEnergyConsumptionProfileWidgetConfigurationInput>;
  energyDynamicPricing?: InputMaybe<DashboardEnergyDynamicPricingWidgetConfigurationInput>;
  energyEmission?: InputMaybe<DashboardEnergyEmissionWidgetConfigurationInput>;
  energyEvaluation?: InputMaybe<DashboardEnergyEvaluationWidgetConfigurationInput>;
  energyMeterReadings?: InputMaybe<DashboardEnergyMeterReadingsWidgetConfigurationInput>;
  energyRegression?: InputMaybe<DashboardEnergyRegressionWidgetConfigurationInput>;
  energySpending?: InputMaybe<DashboardEnergySpendingWidgetConfigurationInput>;
  energySummary?: InputMaybe<DashboardEnergySummaryWidgetConfigurationInput>;
  indoorClimateCorrelation?: InputMaybe<DashboardIndoorClimateCorrelationWidgetConfigurationInput>;
  indoorClimateOverview?: InputMaybe<DashboardIndoorClimateOverviewWidgetConfigurationInput>;
  indoorClimateScore?: InputMaybe<DashboardIndoorClimateScoreWidgetConfigurationInput>;
  installationCategoryScore?: InputMaybe<DashboardInstallationCategoryScoreWidgetConfigurationInput>;
  installationPerformance?: InputMaybe<DashboardInstallationPerformanceWidgetConfigurationInput>;
  sensorValues?: InputMaybe<DashboardSensorValuesWidgetConfigurationInput>;
};

export type DashboardWidgetSpaceSetting = {
  __typename?: 'DashboardWidgetSpaceSetting';
  fixed?: Maybe<DashboardFixedSpaceSetting>;
  global?: Maybe<DashboardEmptySetting>;
  local?: Maybe<DashboardEmptySetting>;
};

export type DashboardWidgetSpaceSettingInput = {
  fixed?: InputMaybe<DashboardFixedSpaceSettingInput>;
  global?: InputMaybe<DashboardEmptySettingInput>;
  local?: InputMaybe<DashboardEmptySettingInput>;
};

export type DashboardWidgetTimeIntervalSetting = {
  __typename?: 'DashboardWidgetTimeIntervalSetting';
  fixed?: Maybe<DashboardFixedTimeInterval>;
  global?: Maybe<DashboardEmptySetting>;
  local?: Maybe<DashboardEmptySetting>;
};

export type DashboardWidgetTimeIntervalSettingInput = {
  fixed?: InputMaybe<DashboardFixedTimeIntervalInput>;
  global?: InputMaybe<DashboardEmptySettingInput>;
  local?: InputMaybe<DashboardEmptySettingInput>;
};

export type DataItem = {
  __typename?: 'DataItem';
  timeStamp: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type DataPoint = {
  __typename?: 'DataPoint';
  device: Device;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  deviceModelCapability?: Maybe<DeviceModelCapability>;
  deviceModelCapabilityId?: Maybe<Scalars['UUID']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  utcTimeMeasured?: Maybe<Scalars['DateTime']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

export type DataPointAggregated = {
  __typename?: 'DataPointAggregated';
  avg_value?: Maybe<Scalars['Float']['output']>;
  count_values?: Maybe<Scalars['Int']['output']>;
  day?: Maybe<Scalars['Int']['output']>;
  device_id?: Maybe<Scalars['Int']['output']>;
  device_model_capability_id?: Maybe<Scalars['Int']['output']>;
  first_value?: Maybe<Scalars['Float']['output']>;
  hour?: Maybe<Scalars['Int']['output']>;
  last_value?: Maybe<Scalars['Float']['output']>;
  max_value?: Maybe<Scalars['Float']['output']>;
  min_value?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  quarter?: Maybe<Scalars['Int']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type DataQueryFiltersInput = {
  aggregationIntervalTypeActive?: InputMaybe<AggregationIntervals>;
  aggregationType?: InputMaybe<AggregationTypes>;
  baselineYear?: InputMaybe<Scalars['Int']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilNow?: InputMaybe<Scalars['Boolean']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  timeSpan?: InputMaybe<TimeSpans>;
};

export enum DataSourceAttribute {
  Additive = 'ADDITIVE',
  Consumption = 'CONSUMPTION',
  FeedIn = 'FEED_IN',
  Generation = 'GENERATION',
  Subtractive = 'SUBTRACTIVE'
}

export enum DataSourceType {
  Aggregate = 'AGGREGATE',
  Timeseries = 'TIMESERIES'
}

export enum DataType {
  Consumption = 'CONSUMPTION',
  Costs = 'COSTS',
  Emissions = 'EMISSIONS',
  Production = 'PRODUCTION'
}

export enum DataTypes {
  Bool = 'BOOL',
  Date = 'DATE',
  Datetime = 'DATETIME',
  Decimal = 'DECIMAL',
  Double = 'DOUBLE',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  NotSpecified = 'NOT_SPECIFIED',
  String = 'STRING'
}

export type DataTypesOperationFilterInput = {
  eq?: InputMaybe<DataTypes>;
  in?: InputMaybe<Array<DataTypes>>;
  neq?: InputMaybe<DataTypes>;
  nin?: InputMaybe<Array<DataTypes>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DayAheadPriceItem = {
  __typename?: 'DayAheadPriceItem';
  areaCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  curveType: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  points: Array<DayAheadPricePoint>;
  resolution: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type DayAheadPricePoint = {
  __typename?: 'DayAheadPricePoint';
  priceAmount: Scalars['Decimal']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type DayAheadPriceResult = {
  __typename?: 'DayAheadPriceResult';
  entries: Array<DayAheadPriceItem>;
  resolvedFrom: Scalars['DateTime']['output'];
  resolvedTo: Scalars['DateTime']['output'];
};

export type DayAheadPrices = {
  __typename?: 'DayAheadPrices';
  areaCode: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  curveType: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  points: Array<DayAheadPricePoint>;
  resolution: Scalars['String']['output'];
  unit: Scalars['String']['output'];
};

export type DayAheadPricesInput = {
  areaCode: Scalars['String']['input'];
  dataFilters: DataQueryFiltersInput;
  showDayAhead: Scalars['Boolean']['input'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DebugPoint = {
  __typename?: 'DebugPoint';
  id: Scalars['String']['output'];
  latestData?: Maybe<TimeseriesDataPoint>;
  name: Scalars['String']['output'];
  timeseries?: Maybe<TimeseriesInfo>;
  timeseriesId: Scalars['UUID']['output'];
  type: PointsType;
};

export enum DeleteE2ETestDataResult {
  Failed = 'FAILED',
  Successful = 'SUCCESSFUL'
}

export type DeleteSensorMeasurementsResponse = {
  __typename?: 'DeleteSensorMeasurementsResponse';
  numAffected: Scalars['Int']['output'];
};

export enum DemoSiteType {
  Cube = 'CUBE',
  Dstrct = 'DSTRCT',
  Edge = 'EDGE',
  KpHeadquarters = 'KP_HEADQUARTERS',
  Ship = 'SHIP'
}

export type DeploymentEvent = {
  __typename?: 'DeploymentEvent';
  at: Scalars['DateTime']['output'];
  deploymentRequestId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  kind: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DeploymentRequest = {
  __typename?: 'DeploymentRequest';
  baseCommitSha: Scalars['String']['output'];
  branchName: Scalars['String']['output'];
  canTriggerDeployment: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  deployments: Array<PipelineRun>;
  error?: Maybe<Scalars['String']['output']>;
  events: Array<DeploymentEvent>;
  graphContentHash: Scalars['String']['output'];
  graphVersion: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  isDraft: Scalars['Boolean']['output'];
  lastPolledAt?: Maybe<Scalars['DateTime']['output']>;
  latestDeployment?: Maybe<PipelineRun>;
  mergeCommitSha?: Maybe<Scalars['String']['output']>;
  mergeStatus?: Maybe<Scalars['String']['output']>;
  prClosedAt?: Maybe<Scalars['DateTime']['output']>;
  prState?: Maybe<Scalars['String']['output']>;
  pullRequest?: Maybe<PullRequestInfoDto>;
  pullRequestId?: Maybe<Scalars['Int']['output']>;
  pullRequestUrl?: Maybe<Scalars['String']['output']>;
  sites: Array<DeploymentRequestSite>;
  slug: Scalars['String']['output'];
  stage: Scalars['String']['output'];
  status: DeploymentRequestStatus;
  tenantId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DeploymentRequestSite = {
  __typename?: 'DeploymentRequestSite';
  added: Scalars['Int']['output'];
  changed: Scalars['Boolean']['output'];
  deploymentRequestId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isNew: Scalars['Boolean']['output'];
  removed: Scalars['Int']['output'];
  siteIris: Array<Scalars['String']['output']>;
  sitePath: Scalars['String']['output'];
  tripleCountAfter: Scalars['Int']['output'];
  tripleCountBefore: Scalars['Int']['output'];
};

export enum DeploymentRequestStatus {
  Abandoned = 'ABANDONED',
  Approved = 'APPROVED',
  ChangesRequested = 'CHANGES_REQUESTED',
  Deployed = 'DEPLOYED',
  Deploying = 'DEPLOYING',
  DeployFailed = 'DEPLOY_FAILED',
  Failed = 'FAILED',
  Merged = 'MERGED',
  MergeConflict = 'MERGE_CONFLICT',
  PrOpen = 'PR_OPEN',
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

/** I am a generated type! */
export type Device = {
  __typename?: 'Device';
  connectionState: ConnectionStates;
  description?: Maybe<Scalars['String']['output']>;
  deviceAttributeValues: Array<DeviceAttributeValue>;
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceModel: DeviceModel;
  deviceModelId: Scalars['UUID']['output'];
  firstConnected?: Maybe<Scalars['DateTime']['output']>;
  gatewayDeviceConnections: Array<GatewayDeviceConnection>;
  heartbeatState?: Maybe<HeartbeatStates>;
  id: Scalars['UUID']['output'];
  inverseParentDevice: Array<Device>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  lastConnected?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parentDevice?: Maybe<Device>;
  parentDeviceId?: Maybe<Scalars['UUID']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


/** I am a generated type! */
export type DeviceDeviceAttributeValuesArgs = {
  order?: InputMaybe<Array<DeviceAttributeValueSortInput>>;
  where?: InputMaybe<DeviceAttributeValueFilterInput>;
};


/** I am a generated type! */
export type DeviceGatewayDeviceConnectionsArgs = {
  order?: InputMaybe<Array<GatewayDeviceConnectionSortInput>>;
  where?: InputMaybe<GatewayDeviceConnectionFilterInput>;
};


/** I am a generated type! */
export type DeviceInverseParentDeviceArgs = {
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};

export type DeviceAndCapabilityInfo = {
  __typename?: 'DeviceAndCapabilityInfo';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  deviceModelCapability?: Maybe<DeviceModelCapability>;
  deviceModelCapabilityId: Scalars['UUID']['output'];
  telemetryRecords?: Maybe<Array<Maybe<TelemetryRecord>>>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type DeviceAttributeValue = {
  __typename?: 'DeviceAttributeValue';
  attribute: Attribute;
  attributeId: Scalars['UUID']['output'];
  device: Device;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeviceAttributeValueCreateType = {
  attributeId: Scalars['UUID']['input'];
  deviceId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceAttributeValueFilterInput = {
  and?: InputMaybe<Array<DeviceAttributeValueFilterInput>>;
  attribute?: InputMaybe<AttributeFilterInput>;
  attributeId?: InputMaybe<UuidOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceAttributeValueId?: InputMaybe<UuidOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DeviceAttributeValueFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceAttributeValueSetNullInputType = {
  attribute?: InputMaybe<Scalars['Boolean']['input']>;
  device?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceAttributeValueSortInput = {
  attribute?: InputMaybe<AttributeSortInput>;
  attributeId?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceAttributeValueId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export type DeviceAttributeValueUpdateType = {
  attributeId?: InputMaybe<Scalars['UUID']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type DeviceAttributeValuesCollectionSegment = {
  __typename?: 'DeviceAttributeValuesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DeviceAttributeValue>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceCreate = {
  __typename?: 'DeviceCreate';
  description?: Maybe<Scalars['String']['output']>;
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceModel: DeviceModel;
  deviceModelId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentDeviceId?: Maybe<Scalars['UUID']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
};

export type DeviceCreateAttributeValueType = {
  attributeId: Scalars['UUID']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceCreateInputType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  deviceModelId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  parentDeviceId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=50 */
  serialNo?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceCreateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  deviceModelId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  parentDeviceId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=50 */
  serialNo?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceFilterInput = {
  and?: InputMaybe<Array<DeviceFilterInput>>;
  connectionState?: InputMaybe<ConnectionStatesOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceAttributeValues?: InputMaybe<ListFilterInputTypeOfDeviceAttributeValueFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  deviceIdentifier?: InputMaybe<StringOperationFilterInput>;
  deviceModel?: InputMaybe<DeviceModelFilterInput>;
  deviceModelId?: InputMaybe<UuidOperationFilterInput>;
  firstConnected?: InputMaybe<DateTimeOperationFilterInput>;
  gatewayDeviceConnections?: InputMaybe<ListFilterInputTypeOfGatewayDeviceConnectionFilterInput>;
  heartbeatState?: InputMaybe<NullableOfHeartbeatStatesOperationFilterInput>;
  inverseParentDevice?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastConnected?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceFilterInput>>;
  parentDevice?: InputMaybe<DeviceFilterInput>;
  parentDeviceId?: InputMaybe<UuidOperationFilterInput>;
  serialNo?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type DeviceMappingReturnType = {
  __typename?: 'DeviceMappingReturnType';
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  placementId: Scalars['UUID']['output'];
};

export type DeviceMessage = {
  __typename?: 'DeviceMessage';
  connectionState: ConnectionStates;
  description?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['UUID']['output'];
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceModelId?: Maybe<Scalars['UUID']['output']>;
  firstConnected?: Maybe<Scalars['DateTime']['output']>;
  heartbeatState?: Maybe<HeartbeatStates>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastConnected?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentDeviceId?: Maybe<Scalars['UUID']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  dataMeasurementTimestampFieldSelector?: Maybe<Scalars['String']['output']>;
  dataMeasurementTimestampFormat?: Maybe<Scalars['String']['output']>;
  deviceIdentifierFieldSelector?: Maybe<Scalars['String']['output']>;
  deviceModelAttributeSets: Array<DeviceModelAttributeSet>;
  deviceModelCapabilities: Array<DeviceModelCapability>;
  deviceType: DeviceType;
  deviceTypeId: Scalars['UUID']['output'];
  devices: Array<Device>;
  gatewayReceivedDataTimestampFieldSelector?: Maybe<Scalars['String']['output']>;
  gatewayReceivedDataTimestampFormat?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


export type DeviceModelDeviceModelAttributeSetsArgs = {
  order?: InputMaybe<Array<DeviceModelAttributeSetSortInput>>;
  where?: InputMaybe<DeviceModelAttributeSetFilterInput>;
};


export type DeviceModelDeviceModelCapabilitiesArgs = {
  order?: InputMaybe<Array<DeviceModelCapabilitySortInput>>;
  where?: InputMaybe<DeviceModelCapabilityFilterInput>;
};


export type DeviceModelDevicesArgs = {
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};

export type DeviceModelAttributeSet = {
  __typename?: 'DeviceModelAttributeSet';
  deviceModel: DeviceModel;
  deviceModelId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  mappingAttributeDeviceModelAttributeSets: Array<MappingAttributeDeviceModelAttributeSet>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


export type DeviceModelAttributeSetMappingAttributeDeviceModelAttributeSetsArgs = {
  order?: InputMaybe<Array<MappingAttributeDeviceModelAttributeSetSortInput>>;
  where?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
};

export type DeviceModelAttributeSetCreateType = {
  deviceModelId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
};

export type DeviceModelAttributeSetFilterInput = {
  and?: InputMaybe<Array<DeviceModelAttributeSetFilterInput>>;
  deviceModel?: InputMaybe<DeviceModelFilterInput>;
  deviceModelAttributeSetId?: InputMaybe<UuidOperationFilterInput>;
  deviceModelId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingAttributeDeviceModelAttributeSets?: InputMaybe<ListFilterInputTypeOfMappingAttributeDeviceModelAttributeSetFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceModelAttributeSetFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type DeviceModelAttributeSetSetNullInputType = {
  deviceModel?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappingAttributeDeviceModelAttributeSets?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceModelAttributeSetSortInput = {
  deviceModel?: InputMaybe<DeviceModelSortInput>;
  deviceModelAttributeSetId?: InputMaybe<SortEnumType>;
  deviceModelId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DeviceModelAttributeSetUpdateType = {
  deviceModelId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type DeviceModelAttributeSetsCollectionSegment = {
  __typename?: 'DeviceModelAttributeSetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DeviceModelAttributeSet>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type DeviceModelCapabilitiesCollectionSegment = {
  __typename?: 'DeviceModelCapabilitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DeviceModelCapability>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceModelCapability = {
  __typename?: 'DeviceModelCapability';
  capability: Capability;
  capabilityId: Scalars['UUID']['output'];
  deviceModel: DeviceModel;
  deviceModelId: Scalars['UUID']['output'];
  fieldSelector?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  technicalMax?: Maybe<Scalars['Float']['output']>;
  technicalMin?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  unit: Unit;
  unitId: Scalars['UUID']['output'];
};

export type DeviceModelCapabilityCreateType = {
  capabilityId: Scalars['UUID']['input'];
  deviceModelId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  fieldSelector?: InputMaybe<Scalars['String']['input']>;
  technicalMax?: InputMaybe<Scalars['Float']['input']>;
  technicalMin?: InputMaybe<Scalars['Float']['input']>;
  unitId: Scalars['UUID']['input'];
};

export type DeviceModelCapabilityFilterInput = {
  and?: InputMaybe<Array<DeviceModelCapabilityFilterInput>>;
  capability?: InputMaybe<CapabilityFilterInput>;
  capabilityId?: InputMaybe<UuidOperationFilterInput>;
  deviceModel?: InputMaybe<DeviceModelFilterInput>;
  deviceModelCapabilityId?: InputMaybe<UuidOperationFilterInput>;
  deviceModelId?: InputMaybe<UuidOperationFilterInput>;
  fieldSelector?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<DeviceModelCapabilityFilterInput>>;
  technicalMax?: InputMaybe<FloatOperationFilterInput>;
  technicalMin?: InputMaybe<FloatOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  unit?: InputMaybe<UnitFilterInput>;
  unitId?: InputMaybe<UuidOperationFilterInput>;
};

export type DeviceModelCapabilityIdsInput = {
  deviceModelCapabilityId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeviceModelCapabilitySetNullInputType = {
  capability?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['Boolean']['input']>;
  fieldSelector?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  technicalMax?: InputMaybe<Scalars['Boolean']['input']>;
  technicalMin?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceModelCapabilitySortInput = {
  capability?: InputMaybe<CapabilitySortInput>;
  capabilityId?: InputMaybe<SortEnumType>;
  deviceModel?: InputMaybe<DeviceModelSortInput>;
  deviceModelCapabilityId?: InputMaybe<SortEnumType>;
  deviceModelId?: InputMaybe<SortEnumType>;
  fieldSelector?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  technicalMax?: InputMaybe<SortEnumType>;
  technicalMin?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unit?: InputMaybe<UnitSortInput>;
  unitId?: InputMaybe<SortEnumType>;
};

export type DeviceModelCapabilityUpdateType = {
  capabilityId?: InputMaybe<Scalars['UUID']['input']>;
  deviceModelId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  fieldSelector?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  technicalMax?: InputMaybe<Scalars['Float']['input']>;
  technicalMin?: InputMaybe<Scalars['Float']['input']>;
  unitId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeviceModelCreateType = {
  /** MinLength=0, MaxLength=50 */
  dataMeasurementTimestampFieldSelector?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=25 */
  dataMeasurementTimestampFormat?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  deviceIdentifierFieldSelector?: InputMaybe<Scalars['String']['input']>;
  deviceTypeId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=50 */
  gatewayReceivedDataTimestampFieldSelector?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=25 */
  gatewayReceivedDataTimestampFormat?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
};

export type DeviceModelFilterInput = {
  and?: InputMaybe<Array<DeviceModelFilterInput>>;
  dataMeasurementTimestampFieldSelector?: InputMaybe<StringOperationFilterInput>;
  dataMeasurementTimestampFormat?: InputMaybe<StringOperationFilterInput>;
  deviceIdentifierFieldSelector?: InputMaybe<StringOperationFilterInput>;
  deviceModelAttributeSets?: InputMaybe<ListFilterInputTypeOfDeviceModelAttributeSetFilterInput>;
  deviceModelCapabilities?: InputMaybe<ListFilterInputTypeOfDeviceModelCapabilityFilterInput>;
  deviceModelId?: InputMaybe<UuidOperationFilterInput>;
  deviceType?: InputMaybe<DeviceTypeFilterInput>;
  deviceTypeId?: InputMaybe<UuidOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  gatewayReceivedDataTimestampFieldSelector?: InputMaybe<StringOperationFilterInput>;
  gatewayReceivedDataTimestampFormat?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceModelFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type DeviceModelSetNullInputType = {
  dataMeasurementTimestampFieldSelector?: InputMaybe<Scalars['Boolean']['input']>;
  dataMeasurementTimestampFormat?: InputMaybe<Scalars['Boolean']['input']>;
  deviceIdentifierFieldSelector?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelAttributeSets?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  deviceType?: InputMaybe<Scalars['Boolean']['input']>;
  devices?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayReceivedDataTimestampFieldSelector?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayReceivedDataTimestampFormat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceModelSortInput = {
  dataMeasurementTimestampFieldSelector?: InputMaybe<SortEnumType>;
  dataMeasurementTimestampFormat?: InputMaybe<SortEnumType>;
  deviceIdentifierFieldSelector?: InputMaybe<SortEnumType>;
  deviceModelId?: InputMaybe<SortEnumType>;
  deviceType?: InputMaybe<DeviceTypeSortInput>;
  deviceTypeId?: InputMaybe<SortEnumType>;
  gatewayReceivedDataTimestampFieldSelector?: InputMaybe<SortEnumType>;
  gatewayReceivedDataTimestampFormat?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DeviceModelUpdateType = {
  /** MinLength=0, MaxLength=50 */
  dataMeasurementTimestampFieldSelector?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=25 */
  dataMeasurementTimestampFormat?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  deviceIdentifierFieldSelector?: InputMaybe<Scalars['String']['input']>;
  deviceTypeId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=50 */
  gatewayReceivedDataTimestampFieldSelector?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=25 */
  gatewayReceivedDataTimestampFormat?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type DeviceModelsCollectionSegment = {
  __typename?: 'DeviceModelsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DeviceModel>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceSetNullInputType = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
  deviceAttributeValues?: InputMaybe<Scalars['Boolean']['input']>;
  deviceIdentifier?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModel?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDeviceConnections?: InputMaybe<Scalars['Boolean']['input']>;
  inverseParentDevice?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  parentDevice?: InputMaybe<Scalars['Boolean']['input']>;
  parentDeviceId?: InputMaybe<Scalars['Boolean']['input']>;
  serialNo?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeviceSortField {
  DeviceId = 'DEVICE_ID',
  IpAddress = 'IP_ADDRESS',
  Name = 'NAME',
  Status = 'STATUS',
  Type = 'TYPE'
}

export type DeviceSortInput = {
  connectionState?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceIdentifier?: InputMaybe<SortEnumType>;
  deviceModel?: InputMaybe<DeviceModelSortInput>;
  deviceModelId?: InputMaybe<SortEnumType>;
  firstConnected?: InputMaybe<SortEnumType>;
  heartbeatState?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastConnected?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentDevice?: InputMaybe<DeviceSortInput>;
  parentDeviceId?: InputMaybe<SortEnumType>;
  serialNo?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DeviceType = {
  __typename?: 'DeviceType';
  deviceModels: Array<DeviceModel>;
  id: Scalars['UUID']['output'];
  isGateway?: Maybe<Scalars['Boolean']['output']>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


export type DeviceTypeDeviceModelsArgs = {
  order?: InputMaybe<Array<DeviceModelSortInput>>;
  where?: InputMaybe<DeviceModelFilterInput>;
};

export type DeviceTypeCreateType = {
  isGateway?: InputMaybe<Scalars['Boolean']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
};

export type DeviceTypeFilterInput = {
  and?: InputMaybe<Array<DeviceTypeFilterInput>>;
  deviceModels?: InputMaybe<ListFilterInputTypeOfDeviceModelFilterInput>;
  deviceTypeId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isGateway?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceTypeFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type DeviceTypeSetNullInputType = {
  deviceModels?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isGateway?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceTypeSortInput = {
  deviceTypeId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isGateway?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type DeviceTypeUpdateType = {
  id: Scalars['UUID']['input'];
  isGateway?: InputMaybe<Scalars['Boolean']['input']>;
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type DeviceTypesCollectionSegment = {
  __typename?: 'DeviceTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DeviceType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceUpdateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  serialNo?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceWithAttributeValues = {
  __typename?: 'DeviceWithAttributeValues';
  attributeValues?: Maybe<Array<Maybe<AttributeWithValue>>>;
  connectionState: ConnectionStates;
  description?: Maybe<Scalars['String']['output']>;
  deviceAttributeValues?: Maybe<Array<Maybe<DeviceAttributeValue>>>;
  deviceId: Scalars['UUID']['output'];
  deviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceModel?: Maybe<DeviceModel>;
  deviceModelId: Scalars['UUID']['output'];
  firstConnected?: Maybe<Scalars['DateTime']['output']>;
  gatewayDeviceConnections?: Maybe<Array<Maybe<GatewayDeviceConnection>>>;
  heartbeatState?: Maybe<HeartbeatStates>;
  inverseParentDevice?: Maybe<Array<Maybe<Device>>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastConnected?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parentDevice?: Maybe<Device>;
  parentDeviceId?: Maybe<Scalars['UUID']['output']>;
  serialNo?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type DevicesByBuilding = {
  __typename?: 'DevicesByBuilding';
  building: Building;
  buildingId?: Maybe<Scalars['UUID']['output']>;
  device: Device;
  deviceAttributeValues?: Maybe<Array<ValueEntity>>;
  deviceDescription?: Maybe<Scalars['String']['output']>;
  deviceDeviceIdentifier?: Maybe<Scalars['String']['output']>;
  deviceGatewayName?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  deviceModelName?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceSerialNumber?: Maybe<Scalars['String']['output']>;
  deviceTypeId?: Maybe<Scalars['UUID']['output']>;
  deviceTypeName?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['UUID']['output']>;
  storeyId?: Maybe<Scalars['UUID']['output']>;
  zoneId?: Maybe<Scalars['UUID']['output']>;
};

export type DevicesByBuildingFilterInput = {
  and?: InputMaybe<Array<DevicesByBuildingFilterInput>>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  deviceAttributeValues?: InputMaybe<ListFilterInputTypeOfValueEntityFilterInput>;
  deviceDescription?: InputMaybe<StringOperationFilterInput>;
  deviceDeviceIdentifier?: InputMaybe<StringOperationFilterInput>;
  deviceGatewayName?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  deviceModelName?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  deviceSerialNumber?: InputMaybe<StringOperationFilterInput>;
  deviceTypeId?: InputMaybe<UuidOperationFilterInput>;
  deviceTypeName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DevicesByBuildingFilterInput>>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  storeyId?: InputMaybe<UuidOperationFilterInput>;
  zoneId?: InputMaybe<UuidOperationFilterInput>;
};

export type DevicesByBuildingSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
  deviceDescription?: InputMaybe<SortEnumType>;
  deviceDeviceIdentifier?: InputMaybe<SortEnumType>;
  deviceGatewayName?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceModelName?: InputMaybe<SortEnumType>;
  deviceName?: InputMaybe<SortEnumType>;
  deviceSerialNumber?: InputMaybe<SortEnumType>;
  deviceTypeId?: InputMaybe<SortEnumType>;
  deviceTypeName?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  storeyId?: InputMaybe<SortEnumType>;
  zoneId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type DevicesByBuildingsCollectionSegment = {
  __typename?: 'DevicesByBuildingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<DevicesByBuilding>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type DevicesCollectionSegment = {
  __typename?: 'DevicesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Device>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** User Request object */
export type EmailContactRequestInput = {
  /** Message */
  message: Scalars['String']['input'];
  /** User that should receive notification */
  recipient: UserBaseInput;
  /** User that should send notification */
  sender: UserBaseInput;
  /** Subject of the message */
  subject: Scalars['String']['input'];
};

export type EnergyContract = {
  __typename?: 'EnergyContract';
  factors: Array<EnergyContractFactor>;
  flowDirection: FlowDirection;
  fromDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  meters: Array<EnergyContractMeter>;
  name: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  toDate?: Maybe<Scalars['Date']['output']>;
  utility: Utility;
};

export type EnergyContractFactor = {
  __typename?: 'EnergyContractFactor';
  energyContract: EnergyContract;
  energyContractId: Scalars['UUID']['output'];
  factorType: EnergyFactorType;
  id: Scalars['UUID']['output'];
  timeseriesId: Scalars['UUID']['output'];
  value: Scalars['Decimal']['output'];
};

export type EnergyContractFactorInput = {
  factorType: EnergyFactorType;
  timeseriesId?: InputMaybe<Scalars['UUID']['input']>;
  value: Scalars['Decimal']['input'];
};

export type EnergyContractMeter = {
  __typename?: 'EnergyContractMeter';
  energyContract: EnergyContract;
  energyContractId: Scalars['UUID']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
};

export type EnergyData = {
  __typename?: 'EnergyData';
  data: Array<DataItem>;
  gap: Scalars['Int']['output'];
  isPartialSeries: Scalars['Boolean']['output'];
  mediumType?: Maybe<MediumType>;
  splitLabel?: Maybe<LabelType>;
  unit: CombinedUnit;
};

export type EnergyDataByType = {
  __typename?: 'EnergyDataByType';
  data: Array<EnergyData>;
  dataType: DataType;
  intervals: Array<AggregationIntervals>;
  selectedInterval: AggregationIntervals;
  weatherAdjustment?: Maybe<WeatherAdjustment>;
};

export type EnergyDataByTypeInput = {
  dataFilters: DataQueryFiltersInput;
  dataType: DataType;
  mediums: Array<MediumType>;
  space: SpaceInput;
  splitBy: SplitByType;
  weatherAdjusted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnergyDataSource = {
  __typename?: 'EnergyDataSource';
  attribute?: Maybe<DataSourceAttribute>;
  flowDirection: FlowDirection;
  id: Scalars['String']['output'];
  type: DataSourceType;
};

export enum EnergyFactorType {
  Co2EmissionsFactor = 'CO2_EMISSIONS_FACTOR',
  CorrectionFactor = 'CORRECTION_FACTOR',
  CostFactor = 'COST_FACTOR',
  GasCalorificValue = 'GAS_CALORIFIC_VALUE'
}

export type EnergyFlow = {
  __typename?: 'EnergyFlow';
  dataSources: Array<EnergyDataSource>;
  from: Scalars['String']['output'];
  mediumType: EnergyMediumType;
  to: Scalars['String']['output'];
};

export type EnergyFlowConsumptionOrGenerationNode = EnergyFlowNode & {
  __typename?: 'EnergyFlowConsumptionOrGenerationNode';
  data?: Maybe<Array<EnergyFlowNodeData>>;
  id: Scalars['String']['output'];
  type: EnergyFlowNodeType;
};

export type EnergyFlowFlow = {
  __typename?: 'EnergyFlowFlow';
  from: Scalars['String']['output'];
  gap: Scalars['Int']['output'];
  mediumType: MediumType;
  to: Scalars['String']['output'];
  unit: CombinedUnit;
  value?: Maybe<Scalars['Float']['output']>;
};

export type EnergyFlowGridNode = EnergyFlowNode & {
  __typename?: 'EnergyFlowGridNode';
  data?: Maybe<Array<EnergyFlowNodeData>>;
  id: Scalars['String']['output'];
  mediumType: MediumType;
  type: EnergyFlowNodeType;
};

export type EnergyFlowNode = {
  data?: Maybe<Array<EnergyFlowNodeData>>;
  id: Scalars['String']['output'];
  type: EnergyFlowNodeType;
};

export enum EnergyFlowNodeAttribute {
  Consumption = 'CONSUMPTION',
  FeedIn = 'FEED_IN',
  Generation = 'GENERATION'
}

export type EnergyFlowNodeData = {
  __typename?: 'EnergyFlowNodeData';
  attribute: EnergyFlowNodeAttribute;
  gap: Scalars['Int']['output'];
  sourceId: Scalars['String']['output'];
  unit: CombinedUnit;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum EnergyFlowNodeType {
  Consumption = 'CONSUMPTION',
  Generation = 'GENERATION',
  Grid = 'GRID',
  System = 'SYSTEM'
}

export type EnergyFlowSystemNode = EnergyFlowNode & {
  __typename?: 'EnergyFlowSystemNode';
  data?: Maybe<Array<EnergyFlowNodeData>>;
  id: Scalars['String']['output'];
  systemType?: Maybe<SubsystemsType>;
  type: EnergyFlowNodeType;
};

export type EnergyFlows = {
  __typename?: 'EnergyFlows';
  energyFlowEdges: Array<EnergyFlowFlow>;
  energyNodes: Array<EnergyFlowNode>;
};

export type EnergyFlowsInput = {
  dataFilters: DataQueryFiltersInput;
  mediumType: MediumType;
  space: SpaceInput;
};

export enum EnergyMediumType {
  Cooling = 'COOLING',
  DomesticHotWater = 'DOMESTIC_HOT_WATER',
  ElectricalEnergy = 'ELECTRICAL_ENERGY',
  Gas = 'GAS',
  Heating = 'HEATING',
  Water = 'WATER'
}

export type EnergyMeterData = {
  __typename?: 'EnergyMeterData';
  intervals: Array<AggregationIntervals>;
  meterData: Array<MeterData>;
  selectedInterval: AggregationIntervals;
};

export type EnergyMeterDataInput = {
  dataFilters: DataQueryFiltersInput;
  mediums: Array<MediumType>;
  meterCategory?: InputMaybe<MeterCategory>;
  meterDataResultType: MeterDataResultType;
  mode: MeterDataMode;
  space: SpaceInput;
};

export type EnergyNode = {
  dataSources?: Maybe<Array<EnergyNodeDataSource>>;
  id: Scalars['String']['output'];
  type: EnergyNodeType;
};

export type EnergyNodeDataSource = {
  __typename?: 'EnergyNodeDataSource';
  attribute?: Maybe<DataSourceAttribute>;
  flowDirection: FlowDirection;
  id: Scalars['String']['output'];
  originNode: EnergyNode;
  type: DataSourceType;
};

export enum EnergyNodeType {
  Consumption = 'CONSUMPTION',
  Generation = 'GENERATION',
  Grid = 'GRID',
  System = 'SYSTEM'
}

export type EnergyRegressionBySensorsData = {
  __typename?: 'EnergyRegressionBySensorsData';
  energyValue: Scalars['Float']['output'];
  sensorValue: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EnergyRegressionBySensorsInput = {
  dataFilters: DataQueryFiltersInput;
  dataType: DataType;
  mediumType: MediumType;
  sensorIds: Array<Scalars['String']['input']>;
  space: SpaceInput;
};

export type EnergyRegressionBySensorsResult = {
  __typename?: 'EnergyRegressionBySensorsResult';
  aggregationIntervalActive: AggregationIntervals;
  intervals: Array<AggregationIntervals>;
  selectedInterval: AggregationIntervals;
  series: Array<EnergyRegressionBySensorsSeries>;
};

export type EnergyRegressionBySensorsSeries = {
  __typename?: 'EnergyRegressionBySensorsSeries';
  data: Array<EnergyRegressionBySensorsData>;
  gap: Scalars['Int']['output'];
};

export type EnergyRegressionData = {
  __typename?: 'EnergyRegressionData';
  timestamp: Scalars['DateTime']['output'];
  value1: Scalars['Float']['output'];
  value2: Scalars['Float']['output'];
};

export type EnergyRegressionInput = {
  dataFilters: DataQueryFiltersInput;
  mediumType: MediumType;
  selector1: Selector1;
  selector2: Selector2;
  space: SpaceInput;
};

export type EnergyRegressionResult = {
  __typename?: 'EnergyRegressionResult';
  aggregationIntervalActive: AggregationIntervals;
  intervals: Array<AggregationIntervals>;
  selectedInterval: AggregationIntervals;
  series: Array<EnergyRegressionSeries>;
};

export type EnergyRegressionSeries = {
  __typename?: 'EnergyRegressionSeries';
  data: Array<EnergyRegressionData>;
  gap: Scalars['Int']['output'];
};

export type EnergySensor = {
  __typename?: 'EnergySensor';
  customText?: Maybe<Scalars['String']['output']>;
  flowDirection: FlowDirection;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timeseriesId: Scalars['UUID']['output'];
  type: PointsType;
};

export type EnergySummaryBySpaceInput = {
  dataFilters: DataQueryFiltersInput;
  mediums: Array<MediumType>;
  space: SpaceInput;
};

export type Equipment = {
  __typename?: 'Equipment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: EquipmentType;
};

export enum EquipmentType {
  Afterheater = 'AFTERHEATER',
  BiomassBoiler = 'BIOMASS_BOILER',
  BufferTank = 'BUFFER_TANK',
  BypassExhaustAirDamperActuator = 'BYPASS_EXHAUST_AIR_DAMPER_ACTUATOR',
  BypassSupplyAirDamperActuator = 'BYPASS_SUPPLY_AIR_DAMPER_ACTUATOR',
  BypassValveActuator = 'BYPASS_VALVE_ACTUATOR',
  Chiller = 'CHILLER',
  CoolingCoil = 'COOLING_COIL',
  Degasser = 'DEGASSER',
  DirectDigitalControl = 'DIRECT_DIGITAL_CONTROL',
  DryCooler = 'DRY_COOLER',
  DxUnit = 'DX_UNIT',
  ElectricBoiler = 'ELECTRIC_BOILER',
  ExhaustAirDamperActuator = 'EXHAUST_AIR_DAMPER_ACTUATOR',
  ExhaustFan = 'EXHAUST_FAN',
  ExhaustFilter = 'EXHAUST_FILTER',
  FanCoilUnit = 'FAN_COIL_UNIT',
  FireDetector = 'FIRE_DETECTOR',
  Freezer = 'FREEZER',
  GasBoiler = 'GAS_BOILER',
  GasValve = 'GAS_VALVE',
  HeaterCoolerBlock = 'HEATER_COOLER_BLOCK',
  HeatingCoil = 'HEATING_COIL',
  HeatPump = 'HEAT_PUMP',
  HeatWheel = 'HEAT_WHEEL',
  Humidifier = 'HUMIDIFIER',
  NoEquipment = 'NO_EQUIPMENT',
  OutsideBypassSupplyAirDamperActuator = 'OUTSIDE_BYPASS_SUPPLY_AIR_DAMPER_ACTUATOR',
  OutsideExhaustAirDamperActuator = 'OUTSIDE_EXHAUST_AIR_DAMPER_ACTUATOR',
  OutsideSupplyAirDamperActuator = 'OUTSIDE_SUPPLY_AIR_DAMPER_ACTUATOR',
  PcmPowerUnit = 'PCM_POWER_UNIT',
  PhotovoltaicInverter = 'PHOTOVOLTAIC_INVERTER',
  Pump = 'PUMP',
  PumpCooler = 'PUMP_COOLER',
  PumpHeater = 'PUMP_HEATER',
  PumpHeaterCooler = 'PUMP_HEATER_COOLER',
  QantexGateway = 'QANTEX_GATEWAY',
  RecirculationAirDamperActuator = 'RECIRCULATION_AIR_DAMPER_ACTUATOR',
  Refrigerator = 'REFRIGERATOR',
  ReturnChangeOverValveActuator = 'RETURN_CHANGE_OVER_VALVE_ACTUATOR',
  ReturnChangeOverValveActuatorCooling = 'RETURN_CHANGE_OVER_VALVE_ACTUATOR_COOLING',
  ReturnChangeOverValveActuatorHeating = 'RETURN_CHANGE_OVER_VALVE_ACTUATOR_HEATING',
  Showers = 'SHOWERS',
  SmokeDetector = 'SMOKE_DETECTOR',
  SplitUnit = 'SPLIT_UNIT',
  SprinklerInstallation = 'SPRINKLER_INSTALLATION',
  StreamFilter = 'STREAM_FILTER',
  Sunblind = 'SUNBLIND',
  SupplyAirDamperActuator = 'SUPPLY_AIR_DAMPER_ACTUATOR',
  SupplyChangeOverValveActuator = 'SUPPLY_CHANGE_OVER_VALVE_ACTUATOR',
  SupplyChangeOverValveActuatorCooling = 'SUPPLY_CHANGE_OVER_VALVE_ACTUATOR_COOLING',
  SupplyChangeOverValveActuatorHeating = 'SUPPLY_CHANGE_OVER_VALVE_ACTUATOR_HEATING',
  SupplyFan = 'SUPPLY_FAN',
  SupplyFilter = 'SUPPLY_FILTER',
  ThrottlingValveActuatorGasboiler = 'THROTTLING_VALVE_ACTUATOR_GASBOILER',
  ThrottlingValveActuatorHeatPumpSystem = 'THROTTLING_VALVE_ACTUATOR_HEAT_PUMP_SYSTEM',
  Tracing = 'TRACING',
  TransportPump = 'TRANSPORT_PUMP',
  TransportPumpCooling = 'TRANSPORT_PUMP_COOLING',
  TwinCoil = 'TWIN_COIL',
  UgwGateway = 'UGW_GATEWAY',
  Unknown = 'UNKNOWN',
  ValveActuator = 'VALVE_ACTUATOR',
  ValveActuatorCooler = 'VALVE_ACTUATOR_COOLER',
  ValveActuatorHeater = 'VALVE_ACTUATOR_HEATER',
  ValveActuatorHeatercoolerCooler = 'VALVE_ACTUATOR_HEATERCOOLER_COOLER',
  ValveActuatorHeatercoolerHeater = 'VALVE_ACTUATOR_HEATERCOOLER_HEATER',
  VariableAirVolumeBox = 'VARIABLE_AIR_VOLUME_BOX'
}

export type ExternalIdScoreTypesInput = {
  externalId: Scalars['String']['input'];
  scoreTypes: Array<AggregationSchema_ScoreType>;
};

export type Finding = {
  __typename?: 'Finding';
  analysis?: Maybe<Scalars['String']['output']>;
  author: Author;
  createdAt: Scalars['String']['output'];
  findingState?: Maybe<FindingStateType>;
  followUpActions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEdited: Scalars['Boolean']['output'];
  notifiedGroups?: Maybe<Array<Scalars['String']['output']>>;
  ruleId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type FindingComment = {
  __typename?: 'FindingComment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  parentCommentId?: Maybe<Scalars['ID']['output']>;
  quotedComment?: Maybe<FindingQuotedComment>;
  replies: Array<FindingComment>;
  text: Scalars['String']['output'];
  totalReplies: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
};

export type FindingCommentInput = {
  findingId: Scalars['ID']['input'];
  notification?: InputMaybe<Notification>;
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  quotedCommentId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type FindingCommentsInput = {
  findingCommentId?: InputMaybe<Scalars['ID']['input']>;
  findingId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type FindingDescriptionChange = {
  __typename?: 'FindingDescriptionChange';
  oldAnalysis?: Maybe<Scalars['String']['output']>;
  oldFollowUpActions?: Maybe<Scalars['String']['output']>;
  oldNotifiedGroups?: Maybe<Array<Scalars['String']['output']>>;
};

export type FindingQuotedComment = {
  __typename?: 'FindingQuotedComment';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type FindingRecordChange = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  findingId: Scalars['ID']['input'];
  followUpActions?: InputMaybe<Scalars['String']['input']>;
  notifiedGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  shouldNotifyUsers: Scalars['Boolean']['input'];
};

export enum FindingStateType {
  Acknowledged = 'ACKNOWLEDGED',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type FindingStatusChange = {
  __typename?: 'FindingStatusChange';
  createdAt: Scalars['DateTime']['output'];
  from: FindingStateType;
  to: FindingStateType;
};

export type FindingStatusChangeInput = {
  findingId: Scalars['ID']['input'];
  status: FindingStateType;
};

export type FindingTimeline = {
  __typename?: 'FindingTimeline';
  items: Array<FindingTimelineItem>;
  totalCount: Scalars['Int']['output'];
};

export type FindingTimelineContext = FindingComment | FindingDescriptionChange | FindingStatusChange;

export type FindingTimelineInput = {
  findingId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInput>;
};

export type FindingTimelineItem = {
  __typename?: 'FindingTimelineItem';
  context: FindingTimelineContext;
  createdAt: Scalars['DateTime']['output'];
  type: FindingTimelineType;
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  userRoles: Array<Scalars['String']['output']>;
};

export enum FindingTimelineType {
  Comment = 'COMMENT',
  DescriptionChange = 'DESCRIPTION_CHANGE',
  StatusChange = 'STATUS_CHANGE'
}

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export enum FlowDirection {
  Export = 'EXPORT',
  Import = 'IMPORT'
}

export type Forecast = {
  __typename?: 'Forecast';
  date: Scalars['DateTime']['output'];
  iceProbability: Scalars['Int']['output'];
  iconCode: Scalars['Int']['output'];
  iconPhrase: Scalars['String']['output'];
  precipitationProbability: Scalars['Int']['output'];
  rainProbability: Scalars['Int']['output'];
  realFeelTemperature: Temperature;
  relativeHumidity: Scalars['Int']['output'];
  snowProbability: Scalars['Int']['output'];
  temperature: Temperature;
};

export type ForecastResult = {
  __typename?: 'ForecastResult';
  forecasts: Array<Forecast>;
};

export type GatewayDeviceConnection = {
  __typename?: 'GatewayDeviceConnection';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  host: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  primaryAuthenticationKey: Scalars['String']['output'];
  primaryConnectionString?: Maybe<Scalars['String']['output']>;
  secondaryAuthenticationKey: Scalars['String']['output'];
  secondaryConnectionString?: Maybe<Scalars['String']['output']>;
  sharedAccessSignatureExpiry?: Maybe<Scalars['DateTime']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  user: Scalars['String']['output'];
};

export type GatewayDeviceConnectionCreateType = {
  deviceId: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=100 */
  name: Scalars['String']['input'];
  /** MinLength=0, MaxLength=250 */
  primaryAuthenticationKey: Scalars['String']['input'];
  /** MinLength=0, MaxLength=250 */
  primaryConnectionString?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  secondaryAuthenticationKey: Scalars['String']['input'];
  /** MinLength=0, MaxLength=250 */
  secondaryConnectionString?: InputMaybe<Scalars['String']['input']>;
};

export type GatewayDeviceConnectionFilterInput = {
  and?: InputMaybe<Array<GatewayDeviceConnectionFilterInput>>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  gatewayDeviceConnectionId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<GatewayDeviceConnectionFilterInput>>;
  primaryAuthenticationKey?: InputMaybe<StringOperationFilterInput>;
  primaryConnectionString?: InputMaybe<StringOperationFilterInput>;
  secondaryAuthenticationKey?: InputMaybe<StringOperationFilterInput>;
  secondaryConnectionString?: InputMaybe<StringOperationFilterInput>;
  sharedAccessSignatureExpiry?: InputMaybe<DateTimeOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type GatewayDeviceConnectionSetNullInputType = {
  device?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  primaryConnectionString?: InputMaybe<Scalars['Boolean']['input']>;
  secondaryConnectionString?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GatewayDeviceConnectionSortInput = {
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  gatewayDeviceConnectionId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  primaryAuthenticationKey?: InputMaybe<SortEnumType>;
  primaryConnectionString?: InputMaybe<SortEnumType>;
  secondaryAuthenticationKey?: InputMaybe<SortEnumType>;
  secondaryConnectionString?: InputMaybe<SortEnumType>;
  sharedAccessSignatureExpiry?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type GatewayDeviceConnectionUpdateType = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=100 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  primaryAuthenticationKey?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  primaryConnectionString?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  secondaryAuthenticationKey?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  secondaryConnectionString?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type GatewayDeviceConnectionsCollectionSegment = {
  __typename?: 'GatewayDeviceConnectionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<GatewayDeviceConnection>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type GatewayLocation = {
  __typename?: 'GatewayLocation';
  gatewayId: Scalars['UUID']['output'];
  gatewayLabel: Scalars['String']['output'];
  gatewayTags: Array<Scalars['String']['output']>;
  gatewayUdp: Scalars['String']['output'];
  locationUri: Scalars['String']['output'];
};

export type GatewayProperties = IGateway_Gateway_Properties & {
  __typename?: 'GatewayProperties';
  firmwareVersion?: Maybe<Scalars['String']['output']>;
};

export type Gateway_Gateway_Gateway = {
  __typename?: 'Gateway_Gateway_Gateway';
  id: Scalars['String']['output'];
  properties?: Maybe<IGateway_Gateway_Properties>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Gateway_Gateway_Properties_GatewayProperties = IGateway_Gateway_Properties & {
  __typename?: 'Gateway_Gateway_Properties_GatewayProperties';
  firmwareVersion?: Maybe<Scalars['String']['output']>;
};

export type GraphImportResult = {
  __typename?: 'GraphImportResult';
  commitSha: Scalars['String']['output'];
  created: Scalars['Boolean']['output'];
  deduplicatedTriples: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  importId?: Maybe<Scalars['UUID']['output']>;
  semanticModelsSlug: Scalars['String']['output'];
  sites: Array<ImportedSite>;
  tripleCount: Scalars['Int']['output'];
  version?: Maybe<GraphVersionInfo>;
  warnings: Array<Scalars['String']['output']>;
};

export enum GraphSource {
  Api = 'API',
  SemanticModelsImport = 'SEMANTIC_MODELS_IMPORT'
}

export type GraphVersion = {
  __typename?: 'GraphVersion';
  comment?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  contentHash: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  detectedTenantPrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  importCommitSha?: Maybe<Scalars['String']['output']>;
  importId?: Maybe<Scalars['UUID']['output']>;
  sizeBytes: Scalars['Int']['output'];
  source: GraphSource;
  tenantId: Scalars['UUID']['output'];
  tripleCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type GraphVersionInfo = {
  __typename?: 'GraphVersionInfo';
  comment?: Maybe<Scalars['String']['output']>;
  contentHash: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  detectedTenantPrefix?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  importCommitSha?: Maybe<Scalars['String']['output']>;
  importId?: Maybe<Scalars['UUID']['output']>;
  sizeBytes: Scalars['Int']['output'];
  source: GraphSource;
  tenantId: Scalars['UUID']['output'];
  tripleCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type GridEnergyNode = EnergyNode & {
  __typename?: 'GridEnergyNode';
  dataSources?: Maybe<Array<EnergyNodeDataSource>>;
  id: Scalars['String']['output'];
  mediumType: EnergyMediumType;
  type: EnergyNodeType;
};

export type GroupedSystemsScore = {
  __typename?: 'GroupedSystemsScore';
  score?: Maybe<Scalars['Float']['output']>;
  systemType: SystemsType;
};

export enum HeartbeatStates {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Unknown = 'UNKNOWN'
}

export type IGateway_Gateway_Properties = {
  firmwareVersion?: Maybe<Scalars['String']['output']>;
};

export enum IccidValidationFailureReason {
  AlreadyBound = 'ALREADY_BOUND',
  UnknownIccid = 'UNKNOWN_ICCID'
}

export type IccidValidationResult = {
  __typename?: 'IccidValidationResult';
  alreadyActive?: Maybe<Scalars['Boolean']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<IccidValidationFailureReason>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

/** Idea Request object */
export type IdeaRequestInput = {
  /** Description of the idea */
  description: Scalars['String']['input'];
  /** Roles of users that should receive notifications */
  roles: Array<Scalars['String']['input']>;
  /** User that should send notification */
  sender: UserBaseInput;
  /** Subject of the idea */
  subject: Scalars['String']['input'];
};

/** I am a generated type! */
export type Image = {
  __typename?: 'Image';
  buildings: Array<Building>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  mappingDeviceImages: Array<MappingDeviceImage>;
  name: Scalars['String']['output'];
  sites: Array<Site>;
  storeys: Array<Storey>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zones: Array<Zone>;
};


/** I am a generated type! */
export type ImageBuildingsArgs = {
  order?: InputMaybe<Array<BuildingSortInput>>;
  where?: InputMaybe<BuildingFilterInput>;
};


/** I am a generated type! */
export type ImageMappingDeviceImagesArgs = {
  order?: InputMaybe<Array<MappingDeviceImageSortInput>>;
  where?: InputMaybe<MappingDeviceImageFilterInput>;
};


/** I am a generated type! */
export type ImageSitesArgs = {
  order?: InputMaybe<Array<SiteSortInput>>;
  where?: InputMaybe<SiteFilterInput>;
};


/** I am a generated type! */
export type ImageStoreysArgs = {
  order?: InputMaybe<Array<StoreySortInput>>;
  where?: InputMaybe<StoreyFilterInput>;
};


/** I am a generated type! */
export type ImageZonesArgs = {
  order?: InputMaybe<Array<ZoneSortInput>>;
  where?: InputMaybe<ZoneFilterInput>;
};

export type ImageCreateType = {
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  /** MinLength=0, MaxLength=500 */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ImageFilterInput = {
  and?: InputMaybe<Array<ImageFilterInput>>;
  buildings?: InputMaybe<ListFilterInputTypeOfBuildingFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingDeviceImages?: InputMaybe<ListFilterInputTypeOfMappingDeviceImageFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ImageFilterInput>>;
  sites?: InputMaybe<ListFilterInputTypeOfSiteFilterInput>;
  storeys?: InputMaybe<ListFilterInputTypeOfStoreyFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  zones?: InputMaybe<ListFilterInputTypeOfZoneFilterInput>;
};

export type ImageSetNullInputType = {
  buildings?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappingDeviceImages?: InputMaybe<Scalars['Boolean']['input']>;
  sites?: InputMaybe<Scalars['Boolean']['input']>;
  storeys?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['Boolean']['input']>;
  zones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageSortInput = {
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export type ImageUpdateType = {
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=500 */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type ImagesCollectionSegment = {
  __typename?: 'ImagesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Image>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportAncillaryInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commitSha?: InputMaybe<Scalars['String']['input']>;
  dryRun?: Scalars['Boolean']['input'];
  force?: Scalars['Boolean']['input'];
  kinds?: InputMaybe<Array<AncillaryFileKind>>;
  semanticModelsSlugOverride?: InputMaybe<Scalars['String']['input']>;
  siteSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportFromSemanticModelsInput = {
  branch?: InputMaybe<Scalars['String']['input']>;
  commitSha?: InputMaybe<Scalars['String']['input']>;
  dryRun?: Scalars['Boolean']['input'];
  force?: Scalars['Boolean']['input'];
  semanticModelsSlugOverride?: InputMaybe<Scalars['String']['input']>;
  siteSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImportedSite = {
  __typename?: 'ImportedSite';
  blobSha: Scalars['String']['output'];
  byteSize: Scalars['Int']['output'];
  sitePath: Scalars['String']['output'];
  siteSlug: Scalars['String']['output'];
  tripleCount: Scalars['Int']['output'];
};

export type IndoorClimateStandard = {
  __typename?: 'IndoorClimateStandard';
  affectedRoomTypes: Array<Scalars['String']['output']>;
  cypherCode: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  indoorClimateStandardType: IndoorClimateStandardType;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  standardId: Scalars['Int']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type IndoorClimateStandardBySpace = {
  __typename?: 'IndoorClimateStandardBySpace';
  key: Scalars['String']['output'];
  standardId: Scalars['Int']['output'];
};

export type IndoorClimateStandardBySpaceResult = {
  __typename?: 'IndoorClimateStandardBySpaceResult';
  indoorClimateStandardBySpaces: Array<IndoorClimateStandardBySpace>;
};

export type IndoorClimateStandardInfo = {
  __typename?: 'IndoorClimateStandardInfo';
  standardId: Scalars['Int']['output'];
  standardKey: Scalars['String']['output'];
};

export enum IndoorClimateStandardType {
  SetpointMode = 'SETPOINT_MODE',
  StandardMode = 'STANDARD_MODE'
}

export type IndoorClimateStandardsBySpaceInput = {
  spaceId: Scalars['String']['input'];
};

export type InstallationPart = {
  __typename?: 'InstallationPart';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Array<Metadata>>;
  name: Scalars['String']['output'];
  timeseriesId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type InstallationPartControlLoop = InstallationPartTyped & {
  __typename?: 'InstallationPartControlLoop';
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  points: Array<InstallationPartPoint>;
};

export type InstallationPartEquipment = InstallationPartTyped & {
  __typename?: 'InstallationPartEquipment';
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  points: Array<InstallationPartPoint>;
  type: EquipmentType;
};

export type InstallationPartPoint = InstallationPartTyped & {
  __typename?: 'InstallationPartPoint';
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<Metadata>>;
  name: Scalars['String']['output'];
  timeseriesId: Scalars['String']['output'];
  type: PointsType;
};

export type InstallationPartScores = {
  __typename?: 'InstallationPartScores';
  alarms: AlarmsCount;
  installationPart: InstallationPartTyped;
  scores: Array<Score>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type InstallationPartTyped = {
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type IpNetwork = {
  __typename?: 'IpNetwork';
  automationNetworkId?: Maybe<Scalars['ID']['output']>;
  devices?: Maybe<Array<Maybe<AutomationDevice>>>;
  devicesOfflineCount?: Maybe<Scalars['Int']['output']>;
  devicesOnlineCount?: Maybe<Scalars['Int']['output']>;
  devicesTotalCount?: Maybe<Scalars['Int']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ipRange?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LabelType = {
  __typename?: 'LabelType';
  mediumType?: Maybe<MediumType>;
  name?: Maybe<Scalars['String']['output']>;
  source?: Maybe<SourceType>;
};

export type ListFilterInputTypeOfAttributeDefinitionFilterInput = {
  all?: InputMaybe<AttributeDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AttributeDefinitionFilterInput>;
  some?: InputMaybe<AttributeDefinitionFilterInput>;
};

export type ListFilterInputTypeOfBuildingFilterInput = {
  all?: InputMaybe<BuildingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BuildingFilterInput>;
  some?: InputMaybe<BuildingFilterInput>;
};

export type ListFilterInputTypeOfDeviceAttributeValueFilterInput = {
  all?: InputMaybe<DeviceAttributeValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceAttributeValueFilterInput>;
  some?: InputMaybe<DeviceAttributeValueFilterInput>;
};

export type ListFilterInputTypeOfDeviceFilterInput = {
  all?: InputMaybe<DeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceFilterInput>;
  some?: InputMaybe<DeviceFilterInput>;
};

export type ListFilterInputTypeOfDeviceModelAttributeSetFilterInput = {
  all?: InputMaybe<DeviceModelAttributeSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceModelAttributeSetFilterInput>;
  some?: InputMaybe<DeviceModelAttributeSetFilterInput>;
};

export type ListFilterInputTypeOfDeviceModelCapabilityFilterInput = {
  all?: InputMaybe<DeviceModelCapabilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceModelCapabilityFilterInput>;
  some?: InputMaybe<DeviceModelCapabilityFilterInput>;
};

export type ListFilterInputTypeOfDeviceModelFilterInput = {
  all?: InputMaybe<DeviceModelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceModelFilterInput>;
  some?: InputMaybe<DeviceModelFilterInput>;
};

export type ListFilterInputTypeOfGatewayDeviceConnectionFilterInput = {
  all?: InputMaybe<GatewayDeviceConnectionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GatewayDeviceConnectionFilterInput>;
  some?: InputMaybe<GatewayDeviceConnectionFilterInput>;
};

export type ListFilterInputTypeOfMappingAttributeDeviceModelAttributeSetFilterInput = {
  all?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
  some?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
};

export type ListFilterInputTypeOfMappingDeviceBuildingFilterInput = {
  all?: InputMaybe<MappingDeviceBuildingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MappingDeviceBuildingFilterInput>;
  some?: InputMaybe<MappingDeviceBuildingFilterInput>;
};

export type ListFilterInputTypeOfMappingDeviceImageFilterInput = {
  all?: InputMaybe<MappingDeviceImageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MappingDeviceImageFilterInput>;
  some?: InputMaybe<MappingDeviceImageFilterInput>;
};

export type ListFilterInputTypeOfMappingDeviceZoneFilterInput = {
  all?: InputMaybe<MappingDeviceZoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MappingDeviceZoneFilterInput>;
  some?: InputMaybe<MappingDeviceZoneFilterInput>;
};

export type ListFilterInputTypeOfSiteFilterInput = {
  all?: InputMaybe<SiteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SiteFilterInput>;
  some?: InputMaybe<SiteFilterInput>;
};

export type ListFilterInputTypeOfStoreyFilterInput = {
  all?: InputMaybe<StoreyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StoreyFilterInput>;
  some?: InputMaybe<StoreyFilterInput>;
};

export type ListFilterInputTypeOfValueEntityFilterInput = {
  all?: InputMaybe<ValueEntityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ValueEntityFilterInput>;
  some?: InputMaybe<ValueEntityFilterInput>;
};

export type ListFilterInputTypeOfZoneFilterInput = {
  all?: InputMaybe<ZoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ZoneFilterInput>;
  some?: InputMaybe<ZoneFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

/** I am a generated type! */
export type Location = {
  __typename?: 'Location';
  buildings: Array<Building>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lon?: Maybe<Scalars['Float']['output']>;
  no?: Maybe<Scalars['String']['output']>;
  sites: Array<Site>;
  street?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};


/** I am a generated type! */
export type LocationBuildingsArgs = {
  order?: InputMaybe<Array<BuildingSortInput>>;
  where?: InputMaybe<BuildingFilterInput>;
};


/** I am a generated type! */
export type LocationSitesArgs = {
  order?: InputMaybe<Array<SiteSortInput>>;
  where?: InputMaybe<SiteFilterInput>;
};

export type LocationCreateType = {
  /** MinLength=0, MaxLength=250 */
  city?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  country?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  county?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  no?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  street?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LocationFilterInput = {
  and?: InputMaybe<Array<LocationFilterInput>>;
  buildings?: InputMaybe<ListFilterInputTypeOfBuildingFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  county?: InputMaybe<StringOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lat?: InputMaybe<FloatOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  lon?: InputMaybe<FloatOperationFilterInput>;
  no?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationFilterInput>>;
  sites?: InputMaybe<ListFilterInputTypeOfSiteFilterInput>;
  street?: InputMaybe<StringOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

export type LocationSetNullInputType = {
  buildings?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  no?: InputMaybe<Scalars['Boolean']['input']>;
  sites?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  zip?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationSortInput = {
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  county?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lat?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  lon?: InputMaybe<SortEnumType>;
  no?: InputMaybe<SortEnumType>;
  street?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export type LocationUpdateType = {
  /** MinLength=0, MaxLength=250 */
  city?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  country?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  county?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=50 */
  no?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  street?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=50 */
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type LocationsCollectionSegment = {
  __typename?: 'LocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Location>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ManagedBy {
  Nmcs = 'NMCS'
}

export type ManagementSource = {
  __typename?: 'ManagementSource';
  instanceBaseUrl?: Maybe<Scalars['String']['output']>;
  managedBy?: Maybe<ManagedBy>;
  protocol?: Maybe<Scalars['String']['output']>;
  vpnServer?: Maybe<Scalars['String']['output']>;
};

export type MappingAttributeDeviceModelAttributeSet = {
  __typename?: 'MappingAttributeDeviceModelAttributeSet';
  attribute: Attribute;
  attributeId: Scalars['UUID']['output'];
  deviceModelAttributeSet: DeviceModelAttributeSet;
  deviceModelAttributeSetId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type MappingAttributeDeviceModelAttributeSetCreateType = {
  attributeId: Scalars['UUID']['input'];
  deviceModelAttributeSetId: Scalars['UUID']['input'];
};

export type MappingAttributeDeviceModelAttributeSetFilterInput = {
  and?: InputMaybe<Array<MappingAttributeDeviceModelAttributeSetFilterInput>>;
  attribute?: InputMaybe<AttributeFilterInput>;
  attributeId?: InputMaybe<UuidOperationFilterInput>;
  deviceModelAttributeSet?: InputMaybe<DeviceModelAttributeSetFilterInput>;
  deviceModelAttributeSetId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingAttributeDeviceModelAttributeSetId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<MappingAttributeDeviceModelAttributeSetFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type MappingAttributeDeviceModelAttributeSetSetNullInputType = {
  attribute?: InputMaybe<Scalars['Boolean']['input']>;
  deviceModelAttributeSet?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MappingAttributeDeviceModelAttributeSetSortInput = {
  attribute?: InputMaybe<AttributeSortInput>;
  attributeId?: InputMaybe<SortEnumType>;
  deviceModelAttributeSet?: InputMaybe<DeviceModelAttributeSetSortInput>;
  deviceModelAttributeSetId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mappingAttributeDeviceModelAttributeSetId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MappingAttributeDeviceModelAttributeSetUpdateType = {
  attributeId?: InputMaybe<Scalars['UUID']['input']>;
  deviceModelAttributeSetId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

/** A segment of a collection. */
export type MappingAttributeDeviceModelAttributeSetsCollectionSegment = {
  __typename?: 'MappingAttributeDeviceModelAttributeSetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<MappingAttributeDeviceModelAttributeSet>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** I am a generated type! */
export type MappingDeviceBuilding = {
  __typename?: 'MappingDeviceBuilding';
  building: Building;
  buildingId: Scalars['UUID']['output'];
  device: Device;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type MappingDeviceBuildingCreateType = {
  buildingId: Scalars['UUID']['input'];
  deviceId: Scalars['UUID']['input'];
};

export type MappingDeviceBuildingFilterInput = {
  and?: InputMaybe<Array<MappingDeviceBuildingFilterInput>>;
  building?: InputMaybe<BuildingFilterInput>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingDeviceBuildingId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<MappingDeviceBuildingFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type MappingDeviceBuildingSetNullInputType = {
  building?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MappingDeviceBuildingSortInput = {
  building?: InputMaybe<BuildingSortInput>;
  buildingId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mappingDeviceBuildingId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MappingDeviceBuildingUpdateType = {
  buildingId?: InputMaybe<Scalars['UUID']['input']>;
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};

/** A segment of a collection. */
export type MappingDeviceBuildingsCollectionSegment = {
  __typename?: 'MappingDeviceBuildingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<MappingDeviceBuilding>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** I am a generated type! */
export type MappingDeviceImage = {
  __typename?: 'MappingDeviceImage';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  image: Image;
  imageId: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type MappingDeviceImageCreateType = {
  deviceId: Scalars['UUID']['input'];
  imageId: Scalars['UUID']['input'];
};

export type MappingDeviceImageFilterInput = {
  and?: InputMaybe<Array<MappingDeviceImageFilterInput>>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingDeviceImageId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<MappingDeviceImageFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type MappingDeviceImageSetNullInputType = {
  image?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MappingDeviceImageSortInput = {
  deviceId?: InputMaybe<SortEnumType>;
  image?: InputMaybe<ImageSortInput>;
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mappingDeviceImageId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type MappingDeviceImageUpdateType = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A segment of a collection. */
export type MappingDeviceImagesCollectionSegment = {
  __typename?: 'MappingDeviceImagesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<MappingDeviceImage>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** I am a generated type! */
export type MappingDeviceZone = {
  __typename?: 'MappingDeviceZone';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  zone: Zone;
  zoneId: Scalars['UUID']['output'];
};

export type MappingDeviceZoneCreateType = {
  deviceId: Scalars['UUID']['input'];
  zoneId: Scalars['UUID']['input'];
};

export type MappingDeviceZoneFilterInput = {
  and?: InputMaybe<Array<MappingDeviceZoneFilterInput>>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingDeviceZoneId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<MappingDeviceZoneFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  zone?: InputMaybe<ZoneFilterInput>;
  zoneId?: InputMaybe<UuidOperationFilterInput>;
};

export type MappingDeviceZoneSetNullInputType = {
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  zone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MappingDeviceZoneSortInput = {
  deviceId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  mappingDeviceZoneId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  zone?: InputMaybe<ZoneSortInput>;
  zoneId?: InputMaybe<SortEnumType>;
};

export type MappingDeviceZoneUpdateType = {
  deviceId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  zoneId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A segment of a collection. */
export type MappingDeviceZonesCollectionSegment = {
  __typename?: 'MappingDeviceZonesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<MappingDeviceZone>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MediumType {
  Cooling = 'COOLING',
  ElectricalEnergy = 'ELECTRICAL_ENERGY',
  Gas = 'GAS',
  Heating = 'HEATING'
}

export type Metadata = {
  protocolType: ProtocolType;
};

export type Meter = {
  __typename?: 'Meter';
  dataType?: Maybe<MeterDataType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: MetersType;
};

export enum MeterCategory {
  MainMeter = 'MAIN_METER',
  SubMeter = 'SUB_METER'
}

export type MeterData = {
  __typename?: 'MeterData';
  data: Array<DataItem>;
  datapointName: Scalars['String']['output'];
  mediumType: MediumType;
  meter: Meter;
  spaces?: Maybe<MeterSpaceTree>;
  unit: CombinedUnit;
};

export enum MeterDataMode {
  AllValues = 'ALL_VALUES',
  LatestValue = 'LATEST_VALUE'
}

export enum MeterDataResultType {
  CalculatedValues = 'CALCULATED_VALUES',
  Readings = 'READINGS'
}

export enum MeterDataType {
  TotalDifferential = 'TOTAL_DIFFERENTIAL',
  TotalIncreasing = 'TOTAL_INCREASING'
}

export type MeterSpaceTree = {
  __typename?: 'MeterSpaceTree';
  building?: Maybe<NodeBase>;
  level?: Maybe<NodeBase>;
  room?: Maybe<NodeBase>;
  site?: Maybe<NodeBase>;
  subBuilding?: Maybe<NodeBase>;
};

export enum MetersType {
  BuildingElectricalMeter = 'BUILDING_ELECTRICAL_METER',
  BuildingGasMeter = 'BUILDING_GAS_METER',
  BuildingHotWaterMeter = 'BUILDING_HOT_WATER_METER',
  BuildingWaterMeter = 'BUILDING_WATER_METER',
  ChilledWaterMeter = 'CHILLED_WATER_METER',
  ElectricalMeter = 'ELECTRICAL_METER',
  GasMeter = 'GAS_METER',
  HotWaterMeter = 'HOT_WATER_METER',
  ThermalEnergyMeter = 'THERMAL_ENERGY_METER',
  Unknown = 'UNKNOWN',
  WaterMeter = 'WATER_METER'
}

export type Mobile = {
  __typename?: 'Mobile';
  iccid?: Maybe<Scalars['String']['output']>;
  imei?: Maybe<Scalars['String']['output']>;
  imsi?: Maybe<Scalars['String']['output']>;
  moduleInfo?: Maybe<Scalars['String']['output']>;
  moduleInfoFirmware?: Maybe<Scalars['String']['output']>;
  moduleInfoManufacturer?: Maybe<Scalars['String']['output']>;
  moduleInfoModel?: Maybe<Scalars['String']['output']>;
  moduleSlot?: Maybe<Scalars['String']['output']>;
  moduleState?: Maybe<Scalars['String']['output']>;
  moduleType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  registrationState?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  sim?: Maybe<Scalars['String']['output']>;
  simState?: Maybe<Scalars['String']['output']>;
  simStatus?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateSim?: Maybe<SimCard>;
  addFindingToProblemCase: Finding;
  bulkProvisionIoTHubDevices: Scalars['String']['output'];
  cancelDeploymentRequest: DeploymentRequest;
  cleanupGatewayDevicesFromIoTHub: Scalars['String']['output'];
  createAttribute?: Maybe<Attribute>;
  createAttributes: Array<Maybe<Attribute>>;
  createAuditLog?: Maybe<AuditLog>;
  createAuditLogs: Array<Maybe<AuditLog>>;
  createBuilding?: Maybe<Building>;
  createBuildings: Array<Maybe<Building>>;
  createCapabilities: Array<Maybe<Capability>>;
  createCapability?: Maybe<Capability>;
  createDashboard: Dashboard;
  createDashboardWidget: Widget;
  createDeploymentRequest: CreateDeploymentRequestPayload;
  createDeviceModel?: Maybe<DeviceModel>;
  createDeviceModelAttributeSet?: Maybe<DeviceModelAttributeSet>;
  createDeviceModelAttributeSets: Array<Maybe<DeviceModelAttributeSet>>;
  createDeviceModelCapabilities: Array<Maybe<DeviceModelCapability>>;
  createDeviceModelCapability?: Maybe<DeviceModelCapability>;
  createDeviceModels: Array<Maybe<DeviceModel>>;
  createDeviceType?: Maybe<DeviceType>;
  createDeviceTypes: Array<Maybe<DeviceType>>;
  createDeviceWithPlacement: DeviceCreate;
  createEmptyProblemCase: ProblemCase;
  createEnergyContract: EnergyContract;
  createFinding: Finding;
  createFindingComment?: Maybe<Scalars['Boolean']['output']>;
  createGatewayDeviceConnection?: Maybe<GatewayDeviceConnection>;
  createGatewayDeviceConnections: Array<Maybe<GatewayDeviceConnection>>;
  createImage?: Maybe<Image>;
  createImages: Array<Maybe<Image>>;
  createLocation?: Maybe<Location>;
  createLocations: Array<Maybe<Location>>;
  createMappingAttributeDeviceModelAttributeSet?: Maybe<MappingAttributeDeviceModelAttributeSet>;
  createMappingAttributeDeviceModelAttributeSets: Array<Maybe<MappingAttributeDeviceModelAttributeSet>>;
  createMappingDeviceBuilding?: Maybe<MappingDeviceBuilding>;
  createMappingDeviceBuildings: Array<Maybe<MappingDeviceBuilding>>;
  createMappingDeviceImage?: Maybe<MappingDeviceImage>;
  createMappingDeviceImages: Array<Maybe<MappingDeviceImage>>;
  createMappingDeviceZone?: Maybe<MappingDeviceZone>;
  createMappingDeviceZones: Array<Maybe<MappingDeviceZone>>;
  /** Create a new schedule. */
  createSchedule: Schedule;
  createSite?: Maybe<Site>;
  createSiteAttribute: SiteAttribute;
  createSites: Array<Maybe<Site>>;
  createStorey?: Maybe<Storey>;
  createStoreys: Array<Maybe<Storey>>;
  createTicket: Ticket;
  createUnit?: Maybe<Unit>;
  createUnits: Array<Maybe<Unit>>;
  createZone?: Maybe<Zone>;
  createZones: Array<Maybe<Zone>>;
  deactivateSim?: Maybe<SimCard>;
  deleteAttribute?: Maybe<Attribute>;
  deleteAttributes: Array<Maybe<Attribute>>;
  deleteBuilding?: Maybe<Building>;
  deleteBuildings: Array<Maybe<Building>>;
  deleteCapabilities: Array<Maybe<Capability>>;
  deleteCapability?: Maybe<Capability>;
  deleteDashboard: Scalars['Boolean']['output'];
  deleteDashboardWidget: Scalars['Boolean']['output'];
  deleteDevice?: Maybe<Device>;
  /** Delete list of sensor measurements by device and device capability */
  deleteDeviceCapabilitySensorMeasurements?: Maybe<DeleteSensorMeasurementsResponse>;
  deleteDeviceModel?: Maybe<DeviceModel>;
  deleteDeviceModelAttributeSet?: Maybe<DeviceModelAttributeSet>;
  deleteDeviceModelAttributeSets: Array<Maybe<DeviceModelAttributeSet>>;
  deleteDeviceModelCapabilities: Array<Maybe<DeviceModelCapability>>;
  deleteDeviceModelCapability?: Maybe<DeviceModelCapability>;
  deleteDeviceModels: Array<Maybe<DeviceModel>>;
  deleteDeviceType?: Maybe<DeviceType>;
  deleteDeviceTypes: Array<Maybe<DeviceType>>;
  deleteDevices: Array<Maybe<Device>>;
  deleteDevicesByGatewayId: DeleteE2ETestDataResult;
  deleteEnergyContract: Scalars['Boolean']['output'];
  /** @deprecated This action is deprecated and will be removed soon */
  deleteFinding?: Maybe<Scalars['Boolean']['output']>;
  deleteFindingComment?: Maybe<Scalars['Boolean']['output']>;
  deleteGatewayDeviceConnection?: Maybe<GatewayDeviceConnection>;
  deleteGatewayDeviceConnections: Array<Maybe<GatewayDeviceConnection>>;
  deleteImage?: Maybe<Image>;
  deleteImages: Array<Maybe<Image>>;
  deleteLocation?: Maybe<Location>;
  deleteLocations: Array<Maybe<Location>>;
  deleteMappingAttributeDeviceModelAttributeSet?: Maybe<MappingAttributeDeviceModelAttributeSet>;
  deleteMappingAttributeDeviceModelAttributeSets: Array<Maybe<MappingAttributeDeviceModelAttributeSet>>;
  deleteMappingDeviceBuilding?: Maybe<MappingDeviceBuilding>;
  deleteMappingDeviceBuildings: Array<Maybe<MappingDeviceBuilding>>;
  deleteMappingDeviceImage?: Maybe<MappingDeviceImage>;
  deleteMappingDeviceImages: Array<Maybe<MappingDeviceImage>>;
  deleteMappingDeviceZone?: Maybe<MappingDeviceZone>;
  deleteMappingDeviceZones: Array<Maybe<MappingDeviceZone>>;
  /** Delete a schedule by its ID. */
  deleteSchedule: Scalars['Boolean']['output'];
  deleteSite?: Maybe<Site>;
  deleteSiteAttribute: Scalars['Boolean']['output'];
  deleteSites: Array<Maybe<Site>>;
  deleteStorey?: Maybe<Storey>;
  deleteStoreys: Array<Maybe<Storey>>;
  deleteTicket?: Maybe<Scalars['Boolean']['output']>;
  deleteUnit?: Maybe<Unit>;
  deleteUnits: Array<Maybe<Unit>>;
  deleteZone?: Maybe<Zone>;
  deleteZones: Array<Maybe<Zone>>;
  exportIoTDevicesToBlobStorage: Scalars['String']['output'];
  findingRecordChange?: Maybe<Scalars['Boolean']['output']>;
  findingStatusChange?: Maybe<Scalars['Boolean']['output']>;
  importAncillaryFilesFromSemanticModels: AncillaryImportResult;
  importTenantGraphFromSemanticModels: GraphImportResult;
  moveFinding: ProblemCase;
  rebuildDeviceMappingsInStorageTable: Scalars['String']['output'];
  redoCreateGatewayDeviceNotification?: Maybe<Scalars['String']['output']>;
  refreshDeploymentRequest: DeploymentRequest;
  regenerateGatewayDeviceConnectionKey?: Maybe<GatewayDeviceConnection>;
  regenerateGatewayDeviceConnectionsKeys: Array<Maybe<GatewayDeviceConnection>>;
  regenerateGatewayDeviceSharedAccessSignature: SharedAccessSignatureData;
  regenerateTenantGatewayDeviceConnectionsKeys: Array<GatewayDeviceConnection>;
  registerSim?: Maybe<SimCard>;
  removeDeletedDeviceMappingsInStorageTable: Scalars['String']['output'];
  removeSim?: Maybe<Scalars['Boolean']['output']>;
  saveAncillaryFile: SaveAncillaryFilePayload;
  saveTenantGraph: SaveTenantGraphPayload;
  /** Send alarm notification by email to selected roles */
  sendAlarmByRoles: Scalars['Boolean']['output'];
  /** Send new email contact request to selected user */
  sendContactRequestByEmail: Scalars['Boolean']['output'];
  /** Send new custom request to users in selected roles */
  sendCustomFeatureRequestByRoles: Scalars['Boolean']['output'];
  /** Send new idea request to users in selected roles */
  sendIdeaRequestByRoles: Scalars['Boolean']['output'];
  /** Send report by email to selected users */
  sendReportByEmail: Scalars['Boolean']['output'];
  setDeviceAttributeValue?: Maybe<DeviceAttributeValue>;
  setDeviceAttributeValues: Array<Maybe<DeviceAttributeValue>>;
  testSubscriptionDeviceMessage?: Maybe<DeviceMessage>;
  triggerDeployment: PipelineRun;
  unsetDeviceAttributeValue?: Maybe<DeviceAttributeValue>;
  unsetDeviceAttributeValues: Array<Maybe<DeviceAttributeValue>>;
  updateAttribute: Attribute;
  updateAttributes: Array<Attribute>;
  updateBuilding: Building;
  updateBuildings: Array<Building>;
  updateCapabilities: Array<Capability>;
  updateCapability: Capability;
  updateDashboard: Dashboard;
  updateDashboardWidget: Widget;
  updateDevice: Device;
  updateDeviceModel: DeviceModel;
  updateDeviceModelAttributeSet: DeviceModelAttributeSet;
  updateDeviceModelAttributeSets: Array<DeviceModelAttributeSet>;
  updateDeviceModelCapabilities: Array<DeviceModelCapability>;
  updateDeviceModelCapability: DeviceModelCapability;
  updateDeviceModels: Array<DeviceModel>;
  updateDeviceType: DeviceType;
  updateDeviceTypes: Array<DeviceType>;
  updateDevices: Array<Device>;
  updateEnergyContract: EnergyContract;
  /** @deprecated This action is deprecated and will be removed soon */
  updateFinding?: Maybe<Finding>;
  updateFindingComment?: Maybe<Scalars['Boolean']['output']>;
  updateGatewayDeviceConnection: GatewayDeviceConnection;
  updateGatewayDeviceConnections: Array<GatewayDeviceConnection>;
  updateImage: Image;
  updateImages: Array<Image>;
  updateLocation: Location;
  updateLocations: Array<Location>;
  updateMappingAttributeDeviceModelAttributeSet: MappingAttributeDeviceModelAttributeSet;
  updateMappingAttributeDeviceModelAttributeSets: Array<MappingAttributeDeviceModelAttributeSet>;
  updateMappingDeviceBuilding: MappingDeviceBuilding;
  updateMappingDeviceBuildingToBuilding: MappingDeviceBuilding;
  updateMappingDeviceBuildingToZone: MappingDeviceZone;
  updateMappingDeviceBuildings: Array<MappingDeviceBuilding>;
  updateMappingDeviceImage: MappingDeviceImage;
  updateMappingDeviceImages: Array<MappingDeviceImage>;
  updateMappingDeviceZone: MappingDeviceZone;
  updateMappingDeviceZoneToBuilding: MappingDeviceBuilding;
  updateMappingDeviceZoneToZone: MappingDeviceZone;
  updateMappingDeviceZones: Array<MappingDeviceZone>;
  updatePlacementOfDevice: DeviceMappingReturnType;
  /** Update an existing schedule. */
  updateSchedule: Schedule;
  updateSite: Site;
  updateSiteAttribute: SiteAttribute;
  updateSites: Array<Site>;
  updateStorey: Storey;
  updateStoreys: Array<Storey>;
  updateStressTestMappingTablesAsync: Scalars['String']['output'];
  /** @deprecated This action is deprecated and will be removed soon */
  updateTicket?: Maybe<Ticket>;
  updateTicketStatus?: Maybe<Ticket>;
  updateUnit: Unit;
  updateUnits: Array<Unit>;
  updateZone: Zone;
  updateZones: Array<Zone>;
};


export type MutationActivateSimArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddFindingToProblemCaseArgs = {
  findingInput: CreateFindingInput;
  problemCaseId: Scalars['ID']['input'];
};


export type MutationBulkProvisionIoTHubDevicesArgs = {
  numDevices: Scalars['Int']['input'];
  numTenants: Scalars['Int']['input'];
};


export type MutationCancelDeploymentRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCleanupGatewayDevicesFromIoTHubArgs = {
  tenantIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationCreateAttributeArgs = {
  attribute: AttributeCreateType;
};


export type MutationCreateAttributesArgs = {
  attributes: Array<AttributeCreateType>;
};


export type MutationCreateAuditLogArgs = {
  auditLog: AuditLogCreateType;
};


export type MutationCreateAuditLogsArgs = {
  auditLogs: Array<AuditLogCreateType>;
};


export type MutationCreateBuildingArgs = {
  building: BuildingCreateType;
};


export type MutationCreateBuildingsArgs = {
  buildings: Array<BuildingCreateType>;
};


export type MutationCreateCapabilitiesArgs = {
  capabilities: Array<CapabilityCreateType>;
};


export type MutationCreateCapabilityArgs = {
  capability: CapabilityCreateType;
};


export type MutationCreateDashboardArgs = {
  input: DashboardInput;
};


export type MutationCreateDashboardWidgetArgs = {
  dashboardId: Scalars['String']['input'];
  widget: WidgetInput;
};


export type MutationCreateDeploymentRequestArgs = {
  input: CreateDeploymentRequestInput;
};


export type MutationCreateDeviceModelArgs = {
  deviceModel: DeviceModelCreateType;
};


export type MutationCreateDeviceModelAttributeSetArgs = {
  deviceModelAttributeSet: DeviceModelAttributeSetCreateType;
};


export type MutationCreateDeviceModelAttributeSetsArgs = {
  deviceModelAttributeSets: Array<DeviceModelAttributeSetCreateType>;
};


export type MutationCreateDeviceModelCapabilitiesArgs = {
  deviceModelCapabilities: Array<DeviceModelCapabilityCreateType>;
};


export type MutationCreateDeviceModelCapabilityArgs = {
  deviceModelCapability: DeviceModelCapabilityCreateType;
};


export type MutationCreateDeviceModelsArgs = {
  deviceModels: Array<DeviceModelCreateType>;
};


export type MutationCreateDeviceTypeArgs = {
  deviceType: DeviceTypeCreateType;
};


export type MutationCreateDeviceTypesArgs = {
  deviceTypes: Array<DeviceTypeCreateType>;
};


export type MutationCreateDeviceWithPlacementArgs = {
  attributeValues: Array<DeviceCreateAttributeValueType>;
  device: DeviceCreateInputType;
  placementId: Scalars['UUID']['input'];
  placementType: PlacementKind;
};


export type MutationCreateEnergyContractArgs = {
  input: CreateEnergyContractInput;
};


export type MutationCreateFindingArgs = {
  findingInput: CreateFindingInput;
};


export type MutationCreateFindingCommentArgs = {
  input?: InputMaybe<FindingCommentInput>;
};


export type MutationCreateGatewayDeviceConnectionArgs = {
  gatewayDeviceConnection: GatewayDeviceConnectionCreateType;
};


export type MutationCreateGatewayDeviceConnectionsArgs = {
  gatewayDeviceConnections: Array<GatewayDeviceConnectionCreateType>;
};


export type MutationCreateImageArgs = {
  image: ImageCreateType;
};


export type MutationCreateImagesArgs = {
  images: Array<ImageCreateType>;
};


export type MutationCreateLocationArgs = {
  location: LocationCreateType;
};


export type MutationCreateLocationsArgs = {
  locations: Array<LocationCreateType>;
};


export type MutationCreateMappingAttributeDeviceModelAttributeSetArgs = {
  mappingAttributeDeviceModelAttributeSet: MappingAttributeDeviceModelAttributeSetCreateType;
};


export type MutationCreateMappingAttributeDeviceModelAttributeSetsArgs = {
  mappingAttributeDeviceModelAttributeSets: Array<MappingAttributeDeviceModelAttributeSetCreateType>;
};


export type MutationCreateMappingDeviceBuildingArgs = {
  mappingDeviceBuilding: MappingDeviceBuildingCreateType;
};


export type MutationCreateMappingDeviceBuildingsArgs = {
  mappingDeviceBuildings: Array<MappingDeviceBuildingCreateType>;
};


export type MutationCreateMappingDeviceImageArgs = {
  mappingDeviceImage: MappingDeviceImageCreateType;
};


export type MutationCreateMappingDeviceImagesArgs = {
  mappingDeviceImages: Array<MappingDeviceImageCreateType>;
};


export type MutationCreateMappingDeviceZoneArgs = {
  mappingDeviceZone: MappingDeviceZoneCreateType;
};


export type MutationCreateMappingDeviceZonesArgs = {
  mappingDeviceZones: Array<MappingDeviceZoneCreateType>;
};


export type MutationCreateScheduleArgs = {
  schedule: ScheduleInput;
};


export type MutationCreateSiteArgs = {
  site: SiteCreateType;
};


export type MutationCreateSiteAttributeArgs = {
  input: CreateSiteAttributeInput;
};


export type MutationCreateSitesArgs = {
  sites: Array<SiteCreateType>;
};


export type MutationCreateStoreyArgs = {
  storey: StoreyCreateType;
};


export type MutationCreateStoreysArgs = {
  storeys: Array<StoreyCreateType>;
};


export type MutationCreateTicketArgs = {
  problemCaseId: Scalars['ID']['input'];
  ticketInput: TicketInput;
};


export type MutationCreateUnitArgs = {
  unit: UnitCreateType;
};


export type MutationCreateUnitsArgs = {
  units: Array<UnitCreateType>;
};


export type MutationCreateZoneArgs = {
  zone: ZoneCreateType;
};


export type MutationCreateZonesArgs = {
  zones: Array<ZoneCreateType>;
};


export type MutationDeactivateSimArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAttributeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAttributesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteBuildingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteBuildingsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteCapabilitiesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteCapabilityArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDashboardArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDashboardWidgetArgs = {
  dashboardId: Scalars['String']['input'];
  widgetId: Scalars['String']['input'];
};


export type MutationDeleteDeviceArgs = {
  deleteChildDevices?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeviceCapabilitySensorMeasurementsArgs = {
  deviceId: Scalars['UUID']['input'];
  deviceModelCapabilityIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationDeleteDeviceModelArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeviceModelAttributeSetArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeviceModelAttributeSetsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteDeviceModelCapabilitiesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteDeviceModelCapabilityArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeviceModelsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteDeviceTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeviceTypesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteDevicesArgs = {
  deleteChildDevices?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteDevicesByGatewayIdArgs = {
  gatewayId: Scalars['UUID']['input'];
};


export type MutationDeleteEnergyContractArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFindingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFindingCommentArgs = {
  findingCommentId: Scalars['ID']['input'];
};


export type MutationDeleteGatewayDeviceConnectionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteGatewayDeviceConnectionsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteImageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteImagesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteLocationsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteMappingAttributeDeviceModelAttributeSetArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMappingAttributeDeviceModelAttributeSetsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteMappingDeviceBuildingArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMappingDeviceBuildingsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteMappingDeviceImageArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMappingDeviceImagesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteMappingDeviceZoneArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMappingDeviceZonesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSiteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSiteAttributeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSitesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteStoreyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteStoreysArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnitArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUnitsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationDeleteZoneArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteZonesArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationExportIoTDevicesToBlobStorageArgs = {
  blobName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationFindingRecordChangeArgs = {
  input: FindingRecordChange;
};


export type MutationFindingStatusChangeArgs = {
  input?: InputMaybe<FindingStatusChangeInput>;
};


export type MutationImportAncillaryFilesFromSemanticModelsArgs = {
  input: ImportAncillaryInput;
};


export type MutationImportTenantGraphFromSemanticModelsArgs = {
  input: ImportFromSemanticModelsInput;
};


export type MutationMoveFindingArgs = {
  findingId: Scalars['ID']['input'];
  targetProblemCaseId: Scalars['ID']['input'];
};


export type MutationRebuildDeviceMappingsInStorageTableArgs = {
  tenantIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRedoCreateGatewayDeviceNotificationArgs = {
  deviceId: Scalars['UUID']['input'];
};


export type MutationRefreshDeploymentRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRegenerateGatewayDeviceConnectionKeyArgs = {
  deviceId: Scalars['UUID']['input'];
  regeneratePrimaryKey?: Scalars['Boolean']['input'];
  regenerateSecondaryKey?: Scalars['Boolean']['input'];
};


export type MutationRegenerateGatewayDeviceConnectionsKeysArgs = {
  deviceIds: Array<Scalars['UUID']['input']>;
  regeneratePrimaryKey?: Scalars['Boolean']['input'];
  regenerateSecondaryKey?: Scalars['Boolean']['input'];
};


export type MutationRegenerateGatewayDeviceSharedAccessSignatureArgs = {
  deviceId: Scalars['UUID']['input'];
  expirySeconds: Scalars['Int']['input'];
};


export type MutationRegenerateTenantGatewayDeviceConnectionsKeysArgs = {
  regeneratePrimaryKey?: Scalars['Boolean']['input'];
  regenerateSecondaryKey?: Scalars['Boolean']['input'];
};


export type MutationRegisterSimArgs = {
  automationNetworkId: Scalars['ID']['input'];
  iccid: Scalars['String']['input'];
};


export type MutationRemoveDeletedDeviceMappingsInStorageTableArgs = {
  tenantIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRemoveSimArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveAncillaryFileArgs = {
  input: SaveAncillaryFileInput;
};


export type MutationSaveTenantGraphArgs = {
  input: SaveTenantGraphInput;
};


export type MutationSendAlarmByRolesArgs = {
  request: AlarmNotificationInput;
};


export type MutationSendContactRequestByEmailArgs = {
  request: EmailContactRequestInput;
};


export type MutationSendCustomFeatureRequestByRolesArgs = {
  request: CustomFeatureRequestInput;
};


export type MutationSendIdeaRequestByRolesArgs = {
  request: IdeaRequestInput;
};


export type MutationSendReportByEmailArgs = {
  request: ReportRequestInput;
};


export type MutationSetDeviceAttributeValueArgs = {
  attributeId: Scalars['UUID']['input'];
  deviceId: Scalars['UUID']['input'];
  value: Scalars['String']['input'];
};


export type MutationSetDeviceAttributeValuesArgs = {
  deviceId: Scalars['UUID']['input'];
  input: Array<AttributeIdAttributeValueInputType>;
};


export type MutationTestSubscriptionDeviceMessageArgs = {
  deviceId: Scalars['UUID']['input'];
};


export type MutationTriggerDeploymentArgs = {
  requestId: Scalars['UUID']['input'];
};


export type MutationUnsetDeviceAttributeValueArgs = {
  attributeId: Scalars['UUID']['input'];
  deviceId: Scalars['UUID']['input'];
};


export type MutationUnsetDeviceAttributeValuesArgs = {
  attributeIds: Array<Scalars['UUID']['input']>;
  deviceId: Scalars['UUID']['input'];
};


export type MutationUpdateAttributeArgs = {
  attribute: AttributeUpdateType;
};


export type MutationUpdateAttributesArgs = {
  attributes: Array<AttributeUpdateType>;
};


export type MutationUpdateBuildingArgs = {
  building: BuildingUpdateType;
};


export type MutationUpdateBuildingsArgs = {
  buildings: Array<BuildingUpdateType>;
};


export type MutationUpdateCapabilitiesArgs = {
  capabilities: Array<CapabilityUpdateType>;
};


export type MutationUpdateCapabilityArgs = {
  capability: CapabilityUpdateType;
};


export type MutationUpdateDashboardArgs = {
  id: Scalars['String']['input'];
  input: DashboardInput;
};


export type MutationUpdateDashboardWidgetArgs = {
  dashboardId: Scalars['String']['input'];
  widget: WidgetInput;
  widgetId: Scalars['String']['input'];
};


export type MutationUpdateDeviceArgs = {
  device: DeviceUpdateType;
};


export type MutationUpdateDeviceModelArgs = {
  deviceModel: DeviceModelUpdateType;
};


export type MutationUpdateDeviceModelAttributeSetArgs = {
  deviceModelAttributeSet: DeviceModelAttributeSetUpdateType;
};


export type MutationUpdateDeviceModelAttributeSetsArgs = {
  deviceModelAttributeSets: Array<DeviceModelAttributeSetUpdateType>;
};


export type MutationUpdateDeviceModelCapabilitiesArgs = {
  deviceModelCapabilities: Array<DeviceModelCapabilityUpdateType>;
};


export type MutationUpdateDeviceModelCapabilityArgs = {
  deviceModelCapability: DeviceModelCapabilityUpdateType;
};


export type MutationUpdateDeviceModelsArgs = {
  deviceModels: Array<DeviceModelUpdateType>;
};


export type MutationUpdateDeviceTypeArgs = {
  deviceType: DeviceTypeUpdateType;
};


export type MutationUpdateDeviceTypesArgs = {
  deviceTypes: Array<DeviceTypeUpdateType>;
};


export type MutationUpdateDevicesArgs = {
  devices: Array<DeviceUpdateType>;
};


export type MutationUpdateEnergyContractArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateEnergyContractInput;
};


export type MutationUpdateFindingArgs = {
  findingInput?: InputMaybe<UpdateFindingInput>;
};


export type MutationUpdateFindingCommentArgs = {
  input: UpdateFindingCommentInput;
};


export type MutationUpdateGatewayDeviceConnectionArgs = {
  gatewayDeviceConnection: GatewayDeviceConnectionUpdateType;
};


export type MutationUpdateGatewayDeviceConnectionsArgs = {
  gatewayDeviceConnections: Array<GatewayDeviceConnectionUpdateType>;
};


export type MutationUpdateImageArgs = {
  image: ImageUpdateType;
};


export type MutationUpdateImagesArgs = {
  images: Array<ImageUpdateType>;
};


export type MutationUpdateLocationArgs = {
  location: LocationUpdateType;
};


export type MutationUpdateLocationsArgs = {
  locations: Array<LocationUpdateType>;
};


export type MutationUpdateMappingAttributeDeviceModelAttributeSetArgs = {
  mappingAttributeDeviceModelAttributeSet: MappingAttributeDeviceModelAttributeSetUpdateType;
};


export type MutationUpdateMappingAttributeDeviceModelAttributeSetsArgs = {
  mappingAttributeDeviceModelAttributeSets: Array<MappingAttributeDeviceModelAttributeSetUpdateType>;
};


export type MutationUpdateMappingDeviceBuildingArgs = {
  mappingDeviceBuilding: MappingDeviceBuildingUpdateType;
};


export type MutationUpdateMappingDeviceBuildingToBuildingArgs = {
  mappingDeviceBuildingToBuildingUpdate: MappingDeviceBuildingUpdateType;
};


export type MutationUpdateMappingDeviceBuildingToZoneArgs = {
  mappingDeviceBuildingToZoneUpdate: MappingDeviceZoneCreateType;
};


export type MutationUpdateMappingDeviceBuildingsArgs = {
  mappingDeviceBuildings: Array<MappingDeviceBuildingUpdateType>;
};


export type MutationUpdateMappingDeviceImageArgs = {
  mappingDeviceImage: MappingDeviceImageUpdateType;
};


export type MutationUpdateMappingDeviceImagesArgs = {
  mappingDeviceImages: Array<MappingDeviceImageUpdateType>;
};


export type MutationUpdateMappingDeviceZoneArgs = {
  mappingDeviceZone: MappingDeviceZoneUpdateType;
};


export type MutationUpdateMappingDeviceZoneToBuildingArgs = {
  mappingDeviceZoneToBuildingUpdate: MappingDeviceBuildingCreateType;
};


export type MutationUpdateMappingDeviceZoneToZoneArgs = {
  mappingDeviceZoneToZoneUpdate: MappingDeviceZoneUpdateType;
};


export type MutationUpdateMappingDeviceZonesArgs = {
  mappingDeviceZones: Array<MappingDeviceZoneUpdateType>;
};


export type MutationUpdatePlacementOfDeviceArgs = {
  deviceId: Scalars['UUID']['input'];
  placementId: Scalars['UUID']['input'];
  placementType: PlacementKind;
};


export type MutationUpdateScheduleArgs = {
  id: Scalars['ID']['input'];
  schedule: ScheduleInput;
};


export type MutationUpdateSiteArgs = {
  site: SiteUpdateType;
};


export type MutationUpdateSiteAttributeArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateSiteAttributeInput;
};


export type MutationUpdateSitesArgs = {
  sites: Array<SiteUpdateType>;
};


export type MutationUpdateStoreyArgs = {
  storey: StoreyUpdateType;
};


export type MutationUpdateStoreysArgs = {
  storeys: Array<StoreyUpdateType>;
};


export type MutationUpdateStressTestMappingTablesAsyncArgs = {
  delete?: Scalars['Boolean']['input'];
  numCapabilities: Scalars['Int']['input'];
  numDevices: Scalars['Int']['input'];
  numTenants: Scalars['Int']['input'];
};


export type MutationUpdateTicketArgs = {
  id: Scalars['ID']['input'];
  ticketInput?: InputMaybe<UpdateTicketInput>;
};


export type MutationUpdateTicketStatusArgs = {
  id: Scalars['ID']['input'];
  status: TicketStatusType;
};


export type MutationUpdateUnitArgs = {
  unit: UnitUpdateType;
};


export type MutationUpdateUnitsArgs = {
  units: Array<UnitUpdateType>;
};


export type MutationUpdateZoneArgs = {
  zone: ZoneUpdateType;
};


export type MutationUpdateZonesArgs = {
  zones: Array<ZoneUpdateType>;
};

export type NetDeviceFilterInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum NetSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum NetworkType {
  Lan = 'LAN',
  Lte = 'LTE'
}

export enum NmcsAggregatedStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Partial = 'PARTIAL'
}

export type NmcsAutomationDevice = {
  __typename?: 'NmcsAutomationDevice';
  deviceId: Scalars['String']['output'];
  firmware: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  ipNetworkId: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: NmcsConnectionStatus;
  type: Scalars['String']['output'];
};

export type NmcsAutomationDevicePage = {
  __typename?: 'NmcsAutomationDevicePage';
  items: Array<NmcsAutomationDevice>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type NmcsAutomationNetwork = {
  __typename?: 'NmcsAutomationNetwork';
  address: Scalars['String']['output'];
  allIpDevicesCount: Scalars['Int']['output'];
  allIpDevicesOnlineCount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  fieldTechnician: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipNetworks: Array<NmcsIpNetwork>;
  name: Scalars['String']['output'];
  remoteAccessEnabled: Scalars['Boolean']['output'];
  router?: Maybe<NmcsRouter>;
  siteId: Scalars['String']['output'];
  status: NmcsConnectionStatus;
};

export type NmcsAutomationNetworkListItem = {
  __typename?: 'NmcsAutomationNetworkListItem';
  address: Scalars['String']['output'];
  devicesOnlineCount: Scalars['Int']['output'];
  devicesTotalCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  ipNetworks: Array<NmcsIpNetwork>;
  ipNetworksCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  networkType: NmcsNetworkType;
  routerName: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
  status: NmcsConnectionStatus;
};

export enum NmcsConnectionStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type NmcsIpNetwork = {
  __typename?: 'NmcsIpNetwork';
  automationNetworkId: Scalars['String']['output'];
  bbmdEnabled: Scalars['Boolean']['output'];
  devices: Array<NmcsAutomationDevice>;
  devicesOfflineCount: Scalars['Int']['output'];
  devicesOnlineCount: Scalars['Int']['output'];
  devicesTotalCount: Scalars['Int']['output'];
  gateway: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipRange: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum NmcsNetworkType {
  Lan = 'LAN',
  Lte = 'LTE'
}

export type NmcsRemoteAccessSession = {
  __typename?: 'NmcsRemoteAccessSession';
  date: Scalars['DateTime']['output'];
  device: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
};

export type NmcsRemoteAccessSessionPage = {
  __typename?: 'NmcsRemoteAccessSessionPage';
  items: Array<NmcsRemoteAccessSession>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type NmcsRouter = {
  __typename?: 'NmcsRouter';
  automationNetworkId: Scalars['String']['output'];
  firmware: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  name: Scalars['String']['output'];
  routerId: Scalars['String']['output'];
  status: NmcsConnectionStatus;
  type: NmcsNetworkType;
  vpnServer: Scalars['String']['output'];
};

export type NmcsSessionFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum NmcsSessionScopeType {
  AutomationNetwork = 'AUTOMATION_NETWORK',
  Site = 'SITE'
}

export type NmcsSite = {
  __typename?: 'NmcsSite';
  automationNetworks: Array<NmcsAutomationNetworkListItem>;
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastRemoteAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  remoteAccessEnabled: Scalars['Boolean']['output'];
  routersOnlineCount: Scalars['Int']['output'];
  routersTotalCount: Scalars['Int']['output'];
  salesManager: Scalars['String']['output'];
  status: NmcsAggregatedStatus;
  tenantId: Scalars['String']['output'];
  vpnServer: Scalars['String']['output'];
};

export type NmcsTenant = {
  __typename?: 'NmcsTenant';
  branchCode: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type NodeBase = {
  __typename?: 'NodeBase';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NodeInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type NodeParents = {
  __typename?: 'NodeParents';
  controlLoop?: Maybe<Point>;
  equipment?: Maybe<Equipment>;
  sensor?: Maybe<Point>;
  spaces: Array<Space>;
  subsystem?: Maybe<Subsystem>;
  system?: Maybe<System>;
};

export type NodeUriInfosInput = {
  dataFilters: DataQueryFiltersInput;
  enableAggregates: Scalars['Boolean']['input'];
  parentUri: Scalars['String']['input'];
};

export type NodeWithSystemType = {
  __typename?: 'NodeWithSystemType';
  equipment?: Maybe<BuildingInformationSchema_Equipment>;
  id: Scalars['String']['output'];
  point?: Maybe<BuildingInformationSchema_Point>;
  space: BuildingInformationSchema_Space;
  subsystem?: Maybe<Subsystem>;
  system: SystemNode;
  systemType: SystemsType;
};

export type Notification = {
  alertDescription: Scalars['String']['input'];
  alertLink: Scalars['String']['input'];
  alertSeverity: Scalars['String']['input'];
  alertSpace: Scalars['String']['input'];
  alertState: Scalars['String']['input'];
  alertTitle: Scalars['String']['input'];
  createdAt: Scalars['String']['input'];
};

export type NullableOfHeartbeatStatesOperationFilterInput = {
  eq?: InputMaybe<HeartbeatStates>;
  in?: InputMaybe<Array<InputMaybe<HeartbeatStates>>>;
  neq?: InputMaybe<HeartbeatStates>;
  nin?: InputMaybe<Array<InputMaybe<HeartbeatStates>>>;
};

export type Output = {
  __typename?: 'Output';
  cypherCode: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  timeSeriesId: Scalars['String']['output'];
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PipelineRun = {
  __typename?: 'PipelineRun';
  adoRunId: Scalars['Long']['output'];
  deploymentRequestId: Scalars['UUID']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  jobs: Array<TimelineJob>;
  queuedAt: Scalars['DateTime']['output'];
  queuedBy?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  sourceCommitSha: Scalars['String']['output'];
  stage: Scalars['String']['output'];
  state: Scalars['String']['output'];
  status: PipelineRunStatus;
  url?: Maybe<Scalars['String']['output']>;
};

export enum PipelineRunStatus {
  Deployed = 'DEPLOYED',
  Deploying = 'DEPLOYING',
  DeployFailed = 'DEPLOY_FAILED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

export type PlacementFilterRow = {
  __typename?: 'PlacementFilterRow';
  buildingId?: Maybe<Scalars['UUID']['output']>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  mappingPlacementId?: Maybe<Scalars['UUID']['output']>;
  siteId?: Maybe<Scalars['UUID']['output']>;
  storeyId?: Maybe<Scalars['UUID']['output']>;
  zoneId?: Maybe<Scalars['UUID']['output']>;
};

export type PlacementFilterRowFilterInput = {
  and?: InputMaybe<Array<PlacementFilterRowFilterInput>>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  deviceId?: InputMaybe<UuidOperationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  mappingPlacementId?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PlacementFilterRowFilterInput>>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  storeyId?: InputMaybe<UuidOperationFilterInput>;
  zoneId?: InputMaybe<UuidOperationFilterInput>;
};

export type PlacementFilterRowSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  mappingPlacementId?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  storeyId?: InputMaybe<SortEnumType>;
  zoneId?: InputMaybe<SortEnumType>;
};

export enum PlacementKind {
  Building = 'BUILDING',
  Zone = 'ZONE'
}

export type PlacementOfDevice = {
  __typename?: 'PlacementOfDevice';
  buildingCity?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['UUID']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  buildingStreet?: Maybe<Scalars['String']['output']>;
  buildingZip?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['UUID']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  mappingPlacementId?: Maybe<Scalars['UUID']['output']>;
  mappingPlacementType?: Maybe<Scalars['String']['output']>;
  siteCity?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['UUID']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  siteNumber?: Maybe<Scalars['String']['output']>;
  siteStreet?: Maybe<Scalars['String']['output']>;
  siteZip?: Maybe<Scalars['String']['output']>;
  storeyId?: Maybe<Scalars['UUID']['output']>;
  storeyName?: Maybe<Scalars['String']['output']>;
  zoneId?: Maybe<Scalars['UUID']['output']>;
  zoneName?: Maybe<Scalars['String']['output']>;
};

export type Point = {
  __typename?: 'Point';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: PointsType;
};

export type PointWithBms = {
  __typename?: 'PointWithBms';
  bmsAddress: Scalars['String']['output'];
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timeseriesId: Scalars['UUID']['output'];
  type: PointsType;
};

export enum PointsType {
  BathWaterTemperatureSensor = 'BATH_WATER_TEMPERATURE_SENSOR',
  BoilerTemperatureSensor = 'BOILER_TEMPERATURE_SENSOR',
  BoilerTemperatureSetpoint = 'BOILER_TEMPERATURE_SETPOINT',
  BufferTemperatureSensorHigh = 'BUFFER_TEMPERATURE_SENSOR_HIGH',
  BufferTemperatureSensorLow = 'BUFFER_TEMPERATURE_SENSOR_LOW',
  CapacitySensor = 'CAPACITY_SENSOR',
  ChilledWaterUsageSensor = 'CHILLED_WATER_USAGE_SENSOR',
  Co2Alarm = 'CO2_ALARM',
  CombinedRoomHumiditySensor = 'COMBINED_ROOM_HUMIDITY_SENSOR',
  CombinedRoomTemperatureSensor = 'COMBINED_ROOM_TEMPERATURE_SENSOR',
  Command = 'COMMAND',
  CommunicationState = 'COMMUNICATION_STATE',
  CoolingCommand = 'COOLING_COMMAND',
  CoolingEnableCommand = 'COOLING_ENABLE_COMMAND',
  CopSensor = 'COP_SENSOR',
  CostFactor = 'COST_FACTOR',
  ElectricEnergySensor = 'ELECTRIC_ENERGY_SENSOR',
  EmissionsFactorCo2 = 'EMISSIONS_FACTOR_CO2',
  EnableCommand = 'ENABLE_COMMAND',
  EnableCommandCompressor = 'ENABLE_COMMAND_COMPRESSOR',
  EnableCommandHigh = 'ENABLE_COMMAND_HIGH',
  EnableCommandLow = 'ENABLE_COMMAND_LOW',
  EnteringWaterTemperatureSensor = 'ENTERING_WATER_TEMPERATURE_SENSOR',
  EnteringWaterTemperatureSensorCchePrimary = 'ENTERING_WATER_TEMPERATURE_SENSOR_CCHE_PRIMARY',
  EnteringWaterTemperatureSensorCcheSecondary = 'ENTERING_WATER_TEMPERATURE_SENSOR_CCHE_SECONDARY',
  EnteringWaterTemperatureSensorDomesticHotWater = 'ENTERING_WATER_TEMPERATURE_SENSOR_DOMESTIC_HOT_WATER',
  EnteringWaterTemperatureSetpoint = 'ENTERING_WATER_TEMPERATURE_SETPOINT',
  ExhaustAirCo2Sensor = 'EXHAUST_AIR_CO2_SENSOR',
  ExhaustAirCo2Setpoint = 'EXHAUST_AIR_CO2_SETPOINT',
  ExhaustAirFlowSensor = 'EXHAUST_AIR_FLOW_SENSOR',
  ExhaustAirFlowSetpoint = 'EXHAUST_AIR_FLOW_SETPOINT',
  ExhaustAirHumiditySensor = 'EXHAUST_AIR_HUMIDITY_SENSOR',
  ExhaustAirHumiditySetpoint = 'EXHAUST_AIR_HUMIDITY_SETPOINT',
  ExhaustAirPressureSensor = 'EXHAUST_AIR_PRESSURE_SENSOR',
  ExhaustAirPressureSetpoint = 'EXHAUST_AIR_PRESSURE_SETPOINT',
  ExhaustAirTemperatureSensor = 'EXHAUST_AIR_TEMPERATURE_SENSOR',
  ExhaustAirTemperatureSensorAfterHeatRecovery = 'EXHAUST_AIR_TEMPERATURE_SENSOR_AFTER_HEAT_RECOVERY',
  ExhaustAirTemperatureSetpoint = 'EXHAUST_AIR_TEMPERATURE_SETPOINT',
  FaultStatus = 'FAULT_STATUS',
  FaultStatusCompressor = 'FAULT_STATUS_COMPRESSOR',
  FaultStatusFlow = 'FAULT_STATUS_FLOW',
  FaultStatusHeatPump = 'FAULT_STATUS_HEAT_PUMP',
  FaultStatusHydrobox = 'FAULT_STATUS_HYDROBOX',
  FaultStatusLegionella = 'FAULT_STATUS_LEGIONELLA',
  FaultStatusNotUrgent = 'FAULT_STATUS_NOT_URGENT',
  FaultStatusUrgent = 'FAULT_STATUS_URGENT',
  FireDetectionAlarm = 'FIRE_DETECTION_ALARM',
  FrostAlarmState = 'FROST_ALARM_STATE',
  HeatingCommand = 'HEATING_COMMAND',
  HeatingEnableCommand = 'HEATING_ENABLE_COMMAND',
  HeatPumpModeBetween = 'HEAT_PUMP_MODE_BETWEEN',
  HeatPumpModeSummer = 'HEAT_PUMP_MODE_SUMMER',
  HeatPumpModeWinter = 'HEAT_PUMP_MODE_WINTER',
  HotWaterUsageSensor = 'HOT_WATER_USAGE_SENSOR',
  IlluminanceSensor = 'ILLUMINANCE_SENSOR',
  IlluminanceSetpoint = 'ILLUMINANCE_SETPOINT',
  IlluminanceSetpointDown = 'ILLUMINANCE_SETPOINT_DOWN',
  IlluminanceSetpointUp = 'ILLUMINANCE_SETPOINT_UP',
  IndoorAirCo2Sensor = 'INDOOR_AIR_CO2_SENSOR',
  IndoorAirCo2Setpoint = 'INDOOR_AIR_CO2_SETPOINT',
  IndoorAirHumiditySensor = 'INDOOR_AIR_HUMIDITY_SENSOR',
  IndoorAirHumiditySetpoint = 'INDOOR_AIR_HUMIDITY_SETPOINT',
  IndoorAirHumiditySetpointLower = 'INDOOR_AIR_HUMIDITY_SETPOINT_LOWER',
  IndoorAirHumiditySetpointUpper = 'INDOOR_AIR_HUMIDITY_SETPOINT_UPPER',
  IndoorAirPressureSensor = 'INDOOR_AIR_PRESSURE_SENSOR',
  IndoorAirPressureSetpoint = 'INDOOR_AIR_PRESSURE_SETPOINT',
  IndoorAirQualitySensor = 'INDOOR_AIR_QUALITY_SENSOR',
  IndoorAirQualitySetpoint = 'INDOOR_AIR_QUALITY_SETPOINT',
  IndoorAirTemperatureSensor = 'INDOOR_AIR_TEMPERATURE_SENSOR',
  IndoorAirTemperatureSetpoint = 'INDOOR_AIR_TEMPERATURE_SETPOINT',
  IndoorAirTemperatureSetpointCool = 'INDOOR_AIR_TEMPERATURE_SETPOINT_COOL',
  IndoorAirTemperatureSetpointHeat = 'INDOOR_AIR_TEMPERATURE_SETPOINT_HEAT',
  IndoorAirTemperatureSetpointMin = 'INDOOR_AIR_TEMPERATURE_SETPOINT_MIN',
  IndoorAirTemperatureSetpointNight = 'INDOOR_AIR_TEMPERATURE_SETPOINT_NIGHT',
  IndoorAirVocSensor = 'INDOOR_AIR_VOC_SENSOR',
  IndoorIlluminanceSensor = 'INDOOR_ILLUMINANCE_SENSOR',
  IndoorIlluminanceSetpoint = 'INDOOR_ILLUMINANCE_SETPOINT',
  LeavingWaterDewpointSensor = 'LEAVING_WATER_DEWPOINT_SENSOR',
  LeavingWaterDewpointState = 'LEAVING_WATER_DEWPOINT_STATE',
  LeavingWaterTemperatureSensor = 'LEAVING_WATER_TEMPERATURE_SENSOR',
  LeavingWaterTemperatureSensorCchePrimary = 'LEAVING_WATER_TEMPERATURE_SENSOR_CCHE_PRIMARY',
  LeavingWaterTemperatureSensorCcheSecondary = 'LEAVING_WATER_TEMPERATURE_SENSOR_CCHE_SECONDARY',
  LeavingWaterTemperatureSensorDomesticHotWater = 'LEAVING_WATER_TEMPERATURE_SENSOR_DOMESTIC_HOT_WATER',
  LeavingWaterTemperatureSetpoint = 'LEAVING_WATER_TEMPERATURE_SETPOINT',
  LeavingWaterTemperatureSetpointSummer = 'LEAVING_WATER_TEMPERATURE_SETPOINT_SUMMER',
  LeavingWaterTemperatureSetpointWinter = 'LEAVING_WATER_TEMPERATURE_SETPOINT_WINTER',
  ModeCoolHeat = 'MODE_COOL_HEAT',
  NaturalGasUsageSensor = 'NATURAL_GAS_USAGE_SENSOR',
  OccupancyState = 'OCCUPANCY_STATE',
  OperatingModeCool = 'OPERATING_MODE_COOL',
  OperatingModeHeat = 'OPERATING_MODE_HEAT',
  OperatingModeStatus = 'OPERATING_MODE_STATUS',
  OperatingModeSummerWinter = 'OPERATING_MODE_SUMMER_WINTER',
  OutsideAirCo2Sensor = 'OUTSIDE_AIR_CO2_SENSOR',
  OutsideAirHumiditySensor = 'OUTSIDE_AIR_HUMIDITY_SENSOR',
  OutsideAirTemperatureSensor = 'OUTSIDE_AIR_TEMPERATURE_SENSOR',
  OutsideExhaustAirTemperatureSensor = 'OUTSIDE_EXHAUST_AIR_TEMPERATURE_SENSOR',
  OutsideIlluminanceSensor = 'OUTSIDE_ILLUMINANCE_SENSOR',
  OutsideSupplyAirTemperatureSensor = 'OUTSIDE_SUPPLY_AIR_TEMPERATURE_SENSOR',
  PressureDifferenceCoolingSensor = 'PRESSURE_DIFFERENCE_COOLING_SENSOR',
  PressureDifferenceSensor = 'PRESSURE_DIFFERENCE_SENSOR',
  PressureDifferenceSetpoint = 'PRESSURE_DIFFERENCE_SETPOINT',
  PressureDifferenceState = 'PRESSURE_DIFFERENCE_STATE',
  ReturnAirCo2Sensor = 'RETURN_AIR_CO2_SENSOR',
  RoomAirTemperatureSensor = 'ROOM_AIR_TEMPERATURE_SENSOR',
  SmokeDetectionAlarm = 'SMOKE_DETECTION_ALARM',
  SupplyAirCo2Sensor = 'SUPPLY_AIR_CO2_SENSOR',
  SupplyAirFlowSensor = 'SUPPLY_AIR_FLOW_SENSOR',
  SupplyAirFlowSetpoint = 'SUPPLY_AIR_FLOW_SETPOINT',
  SupplyAirHumidistat = 'SUPPLY_AIR_HUMIDISTAT',
  SupplyAirHumiditySensor = 'SUPPLY_AIR_HUMIDITY_SENSOR',
  SupplyAirHumiditySetpoint = 'SUPPLY_AIR_HUMIDITY_SETPOINT',
  SupplyAirPressureSensor = 'SUPPLY_AIR_PRESSURE_SENSOR',
  SupplyAirPressureSetpoint = 'SUPPLY_AIR_PRESSURE_SETPOINT',
  SupplyAirTemperatureSensor = 'SUPPLY_AIR_TEMPERATURE_SENSOR',
  SupplyAirTemperatureSensorAfterHeatRecovery = 'SUPPLY_AIR_TEMPERATURE_SENSOR_AFTER_HEAT_RECOVERY',
  SupplyAirTemperatureSetpoint = 'SUPPLY_AIR_TEMPERATURE_SETPOINT',
  SupplyMixAirTemperatureSensor = 'SUPPLY_MIX_AIR_TEMPERATURE_SENSOR',
  SystemWaterPressureSensor = 'SYSTEM_WATER_PRESSURE_SENSOR',
  SystemWaterPressureSetpoint = 'SYSTEM_WATER_PRESSURE_SETPOINT',
  TemperatureAlarm = 'TEMPERATURE_ALARM',
  ThermalEnergySensor = 'THERMAL_ENERGY_SENSOR',
  Unknown = 'UNKNOWN',
  WaterThermostatMax = 'WATER_THERMOSTAT_MAX',
  WaterUsageSensor = 'WATER_USAGE_SENSOR',
  WindDirectionSensor = 'WIND_DIRECTION_SENSOR',
  WindSpeedSensor = 'WIND_SPEED_SENSOR'
}

export type Position = {
  __typename?: 'Position';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type PositionInput = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type ProblemCase = {
  __typename?: 'ProblemCase';
  createdAt: Scalars['String']['output'];
  findings?: Maybe<Array<Finding>>;
  id: Scalars['ID']['output'];
  problemCaseState: ProblemCaseState;
  ruleIds?: Maybe<Array<Scalars['ID']['output']>>;
  ticket?: Maybe<Ticket>;
  updatedAt: Scalars['String']['output'];
};

export enum ProblemCaseState {
  Closed = 'CLOSED',
  New = 'NEW'
}

export enum ProtocolType {
  Bacnet = 'BACNET',
  Unknown = 'UNKNOWN'
}

export type PullRequestInfoDto = {
  __typename?: 'PullRequestInfoDto';
  closedDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isDraft: Scalars['Boolean']['output'];
  mergeCommitSha?: Maybe<Scalars['String']['output']>;
  mergeStatus?: Maybe<Scalars['String']['output']>;
  reviewers: Array<Reviewer>;
  state: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  aggregates: Array<Aggregate>;
  /** Queries a single alarm by ID combining RuleEngine, Building Information, Problem Case Service and Alarm Service */
  alarm?: Maybe<AlarmListItem>;
  /** Get alarm counts with findings for both active and inactive states */
  alarmCountWithFindings: AlarmCountResult;
  alarmFindings?: Maybe<Array<Scalars['Boolean']['output']>>;
  /** Queries one expanded alarm group: gray timeline for the group, logic-type subgroups, and individual timelines */
  alarmGroupDetails: AlarmGroupDetails;
  /** Queries one alarm group's Duration / Alert count / Timeline from filtered member leaf timeseries (progressive filtered gray-row metrics) */
  alarmGroupSummary: AlarmGroupNode;
  /** Get alarm by Unique ID */
  alarmSchema_alarm?: Maybe<Alarm>;
  /** Queries alarm statistics data for charting */
  alarmStatistics: Array<AlarmStatisticsData>;
  alarmTimelineStatistics: AlarmTimelineStatisticsResponse;
  /** Queries grouped alarm totals (location / system / subsystem). Each group timeline is the union of member activity; expand a row with alarmGroupDetails for the alarms inside it. */
  alarmTimelineStatisticsGrouped: AlarmGroupedTimelineResponse;
  /** Queries alarms combining RuleEngine, Building Information, Problem Case Service and Alarm Service. Pass filter.uri to scope to a space, system, subsystem, or installation part (and its children). */
  alarms: Array<AlarmListItem>;
  /** Queries total count of active and inactive alarms with their open findings counts */
  alarmsCount: AlarmCountResult;
  /** Alarms drawer: items for uri plus title, spaces and installations of the clicked node. Each item also has its own installations path. */
  alarmsDrawer: AlarmsDrawerResult;
  /** Get alarms with filtering */
  alarmsWithFilters: Array<Alarm>;
  attribute?: Maybe<Attribute>;
  attributes?: Maybe<AttributesCollectionSegment>;
  /** Queries all attributes assigned to devices in a building */
  attributesByBuildings?: Maybe<AttributesByBuildingsCollectionSegment>;
  auditLog?: Maybe<AuditLog>;
  /** Audit Logs */
  auditLogs?: Maybe<AuditLogsCollectionSegment>;
  automationNetwork?: Maybe<AutomationNetwork>;
  automationNetworks?: Maybe<Array<AutomationNetwork>>;
  building?: Maybe<Building>;
  buildingFilterTable?: Maybe<BuildingFilterTableCollectionSegment>;
  buildingInformationSchema_dayAheadPrices: Array<DayAheadPrices>;
  buildingInformationSchema_energyFlows: EnergyFlows;
  buildings?: Maybe<BuildingsCollectionSegment>;
  capabilities?: Maybe<CapabilitiesCollectionSegment>;
  capability?: Maybe<Capability>;
  configurationPoints: Array<ConfigurationPoint>;
  createDemoSite: Scalars['Boolean']['output'];
  /** Get DataService Info */
  dataServiceInfo?: Maybe<ServiceInfo>;
  dayAheadPrices: DayAheadPriceResult;
  deploymentRequest?: Maybe<DeploymentRequest>;
  deploymentRequests: Array<DeploymentRequest>;
  device?: Maybe<Device>;
  deviceAttributeValue?: Maybe<DeviceAttributeValue>;
  deviceAttributeValues?: Maybe<DeviceAttributeValuesCollectionSegment>;
  deviceGroupedSensorDataByViews?: Maybe<Array<Maybe<TimeAndAggregationParameter>>>;
  deviceModel?: Maybe<DeviceModel>;
  deviceModelAttributeSet?: Maybe<DeviceModelAttributeSet>;
  deviceModelAttributeSets?: Maybe<DeviceModelAttributeSetsCollectionSegment>;
  deviceModelCapabilities?: Maybe<DeviceModelCapabilitiesCollectionSegment>;
  deviceModelCapability?: Maybe<DeviceModelCapability>;
  deviceModels?: Maybe<DeviceModelsCollectionSegment>;
  deviceType?: Maybe<DeviceType>;
  deviceTypes?: Maybe<DeviceTypesCollectionSegment>;
  deviceWithAttributes?: Maybe<DeviceWithAttributeValues>;
  devices?: Maybe<DevicesCollectionSegment>;
  /** Queries all devices in a building */
  devicesByBuildings?: Maybe<DevicesByBuildingsCollectionSegment>;
  energyContract?: Maybe<EnergyContract>;
  energyContracts: Array<EnergyContract>;
  energyDataByType: EnergyDataByType;
  energyFlows: EnergyFlows;
  energyFlowsV2: EnergyFlows;
  energyMeterDataQuery: EnergyMeterData;
  /** Queries paired energy regression values (energyValue = energy by data type, sensorValue = the average across the given sensors) by space */
  energyRegressionBySensors: EnergyRegressionBySensorsResult;
  /** Queries paired energy regression values (value1 vs value2, e.g. consumption vs outdoor air temperature) by space */
  energyRegressionQuery: EnergyRegressionResult;
  energySummary: SummaryEnergyData;
  fakeErrors: Array<TestError>;
  finding?: Maybe<Finding>;
  findingComments: Array<FindingComment>;
  findingTimeline?: Maybe<FindingTimeline>;
  findingsByProblemCase?: Maybe<Array<Finding>>;
  findingsByRuleId?: Maybe<Array<Finding>>;
  gatewayDeviceConnection?: Maybe<GatewayDeviceConnection>;
  gatewayDeviceConnections?: Maybe<GatewayDeviceConnectionsCollectionSegment>;
  gatewayDevices?: Maybe<Array<Maybe<Device>>>;
  gatewayLocations: Array<GatewayLocation>;
  getDashboard?: Maybe<Dashboard>;
  getRuleIdsWithOpenFindings: Array<Maybe<RuleFindingCount>>;
  image?: Maybe<Image>;
  images?: Maybe<ImagesCollectionSegment>;
  indoorClimateStandards: Array<IndoorClimateStandard>;
  indoorClimateStandardsBySpaceQuery: IndoorClimateStandardBySpaceResult;
  ipNetworkDevices?: Maybe<AutomationDevicePage>;
  latestSensorData?: Maybe<Array<Maybe<DataPoint>>>;
  latestTimeseriesData?: Maybe<Array<Maybe<TimeseriesDataPoint>>>;
  listDashboards: Array<Dashboard>;
  location?: Maybe<Location>;
  locations?: Maybe<LocationsCollectionSegment>;
  mappingAttributeDeviceModelAttributeSet?: Maybe<MappingAttributeDeviceModelAttributeSet>;
  mappingAttributeDeviceModelAttributeSets?: Maybe<MappingAttributeDeviceModelAttributeSetsCollectionSegment>;
  mappingDeviceBuilding?: Maybe<MappingDeviceBuilding>;
  mappingDeviceBuildings?: Maybe<MappingDeviceBuildingsCollectionSegment>;
  mappingDeviceImage?: Maybe<MappingDeviceImage>;
  mappingDeviceImages?: Maybe<MappingDeviceImagesCollectionSegment>;
  mappingDeviceZone?: Maybe<MappingDeviceZone>;
  mappingDeviceZones?: Maybe<MappingDeviceZonesCollectionSegment>;
  multipleDeviceSensorDataByViews?: Maybe<Array<Maybe<TimeAndAggregationParameter>>>;
  /** Get Info of multi sensor measurements */
  multipleDeviceSensorDataInfo?: Maybe<SensorMeasurementsInfo>;
  multipleTimeseriesData?: Maybe<TimeseriesTimeAndAggregationParameter>;
  nmcsAutomationNetwork?: Maybe<NmcsAutomationNetwork>;
  nmcsIpNetworkDevices: NmcsAutomationDevicePage;
  nmcsRemoteAccessSessions: NmcsRemoteAccessSessionPage;
  nmcsSite?: Maybe<NmcsSite>;
  nmcsSites: Array<NmcsSite>;
  nmcsTenant?: Maybe<NmcsTenant>;
  nodeParents: Array<NodeParents>;
  /** Debug query to get data for points by their parent uri */
  nodeUriInfos: Array<DebugPoint>;
  nodesSystemType: Array<NodeWithSystemType>;
  placementOfDevice?: Maybe<PlacementOfDevice>;
  pointsByParentUri: Array<Point>;
  pointsByTimeseriesId: Array<PointWithBms>;
  pointsByUris: Array<Point>;
  problemCase?: Maybe<ProblemCase>;
  problemCases?: Maybe<Array<ProblemCase>>;
  remoteAccessSessions?: Maybe<RemoteAccessSessionPage>;
  resolveAllTimeseriesIdsByScoreType: Array<TimeseriesIdScoreType>;
  resolveEnergyMeterTimeseries: Array<SpaceEnergyMeterTimeseries>;
  resolveRules: Array<Rule>;
  resolveRulesByExternalUri: Array<Rule>;
  resolveSpaceSensorTimeseries: Array<SpaceSensorTimeseries>;
  resolveTimeseriesId: Scalars['UUID']['output'];
  resolveTimeseriesIdsByScoreTypes: Array<TimeseriesIdScoreType>;
  roomPointSystemTypes: Array<RoomPointSystem>;
  ruleAlarmQuery: RuleAlarmWithHistory;
  ruleAlarmsBySpaceQuery: RuleAlarmsWithTotal;
  rulesByIds: Array<Rule>;
  /** Fetch a single schedule by its ID. */
  schedule?: Maybe<Schedule>;
  /** Fetch all schedules or filter by type. */
  schedules: Array<Schedule>;
  /** Queries for timeseries data by score and together with RMOT of that Site */
  scoreAtRunningMeanOutsideAirTempBySpaceQuery: TimeseriesRmotDataBySpaceResult;
  scoreThresholdSettingByScoreType: ThresholdSettingWithScoreType;
  scoreThresholdSettingByScoreTypes: Array<ThresholdSettingWithScoreType>;
  /** Queries for timeseries data by score and space ID */
  scoreTimeseriesBySpace: TimeseriesDataBySpaceResult;
  /** Queries sensor data for a space by sensor types, including building path, system, subsystem and equipment information */
  sensorDataByTypes: SensorDataByTypesResult;
  /** Get list of sensor measurements */
  sensorMeasurements?: Maybe<SensorMeasurementsCollectionSegment>;
  /** Get Info of sensor measurement */
  sensorMeasurementsInfo?: Maybe<SensorMeasurementsInfo>;
  sensorStatisticInformation?: Maybe<Array<Maybe<SensorStatisticInformation>>>;
  /** Queries for timeseries data by sensor type and space ID */
  sensorTimeseriesBySpaceAndType: TimeseriesDataBySpaceAndSensorResult;
  /** Debug query to get sensors statistics data */
  sensorsStatistics: Array<SensorsStatisticsInformation>;
  sensorsWithBuildingPath: Array<SensorWithBuildingPath>;
  sidebarVpnNetworks?: Maybe<Array<VpnNetwork>>;
  simCards?: Maybe<Array<SimCard>>;
  site?: Maybe<Site>;
  siteAttribute?: Maybe<SiteAttribute>;
  siteAttributes: Array<SiteAttribute>;
  sites?: Maybe<SitesCollectionSegment>;
  spaceSensorTypes: Array<SpaceSensorTypeCount>;
  spaceSystems: Array<System>;
  spaceTree: Array<SpaceNode>;
  spacesSensorsByType: Array<SpaceSensorsWithParents>;
  spacesStatistics: Array<SpacesStatistics>;
  storey?: Maybe<Storey>;
  storeys?: Maybe<StoreysCollectionSegment>;
  /** @deprecated Use GetSystemOrSubsystemInstallationParts instead */
  subsystemInstallationParts: Array<CategorizedInstallationParts>;
  systemOrSubsystemInstallationParts: Array<CategorizedInstallationPartsTyped>;
  /** Queries for system or subsystem installation parts scores by space ID */
  systemOrSubsystemInstallationPartsScores: Array<CategorizedInstallationPartsScores>;
  systemsOrSubsystemsScoreBySpace: Array<SystemOrSubsystemsScore>;
  systemsOrSubsystemsScoreBySpaceDetail: Array<SystemOrSubsystemsScoreWithDetail>;
  /** Queries for systems score by space ID */
  systemsScoreBySpace: Array<GroupedSystemsScore>;
  tenant?: Maybe<Tenant>;
  /** Get tenant contact list */
  tenantContacts: Array<User>;
  tenantGraph: TenantGraph;
  tenantInformation: TenantInformation;
  ticket?: Maybe<Ticket>;
  ticketByProblemCase?: Maybe<Ticket>;
  tickets: Array<Ticket>;
  unit?: Maybe<Unit>;
  units?: Maybe<UnitsCollectionSegment>;
  usedIndoorClimateStandards: Array<UsedIndoorClimateStandard>;
  validateIccid?: Maybe<IccidValidationResult>;
  vpnNetwork?: Maybe<VpnNetwork>;
  vpnNetworks?: Maybe<Array<VpnNetwork>>;
  weatherInfoByCoordinates: ForecastResult;
  zone?: Maybe<Zone>;
  zoneAndBuildingFilterTable?: Maybe<ZoneAndBuildingFilterTableCollectionSegment>;
  zoneFilterTable?: Maybe<ZoneFilterTableCollectionSegment>;
  zones?: Maybe<ZonesCollectionSegment>;
};


export type QueryAggregatesArgs = {
  externalId: Scalars['String']['input'];
};


export type QueryAlarmArgs = {
  alarmId: Scalars['String']['input'];
};


export type QueryAlarmCountWithFindingsArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  ruleFindings: Array<RuleFindingCountInput>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryAlarmFindingsArgs = {
  ruleIds?: InputMaybe<Array<RuleIdInput>>;
};


export type QueryAlarmGroupDetailsArgs = {
  groupBy: AlarmGroupBy;
  groupId: Scalars['String']['input'];
  hierarchyLevel?: InputMaybe<SpaceType>;
  where: AlarmsFilterInput;
};


export type QueryAlarmGroupSummaryArgs = {
  groupBy: AlarmGroupBy;
  groupId: Scalars['String']['input'];
  hierarchyLevel?: InputMaybe<SpaceType>;
  where: AlarmsFilterInput;
};


export type QueryAlarmSchema_AlarmArgs = {
  id: Scalars['String']['input'];
};


export type QueryAlarmStatisticsArgs = {
  where: AlarmStatisticsInput;
};


export type QueryAlarmTimelineStatisticsArgs = {
  where: AlarmsFilterInput;
};


export type QueryAlarmTimelineStatisticsGroupedArgs = {
  groupBy: AlarmGroupBy;
  hierarchyLevel?: InputMaybe<SpaceType>;
  where: AlarmsFilterInput;
};


export type QueryAlarmsArgs = {
  where: AlarmsFilterInput;
};


export type QueryAlarmsCountArgs = {
  where: AlarmCountInput;
};


export type QueryAlarmsDrawerArgs = {
  filter: AlarmsDrawerFilterInput;
};


export type QueryAlarmsWithFiltersArgs = {
  where: AlarmFilterInput;
};


export type QueryAttributeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAttributesArgs = {
  order?: InputMaybe<Array<AttributeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttributeFilterInput>;
};


export type QueryAttributesByBuildingsArgs = {
  order?: InputMaybe<Array<AttributesByBuildingsSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AttributesByBuildingsFilterInput>;
};


export type QueryAuditLogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAuditLogsArgs = {
  order?: InputMaybe<Array<AuditLogSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuditLogFilterInput>;
};


export type QueryAutomationNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAutomationNetworksArgs = {
  vpnNetworkId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBuildingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBuildingFilterTableArgs = {
  order?: InputMaybe<Array<PlacementFilterRowSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlacementFilterRowFilterInput>;
};


export type QueryBuildingInformationSchema_DayAheadPricesArgs = {
  where: QueryDayAheadPricesInput;
};


export type QueryBuildingInformationSchema_EnergyFlowsArgs = {
  where: QueryEnergyMetersInput;
};


export type QueryBuildingsArgs = {
  order?: InputMaybe<Array<BuildingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BuildingFilterInput>;
};


export type QueryCapabilitiesArgs = {
  order?: InputMaybe<Array<CapabilitySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CapabilityFilterInput>;
};


export type QueryCapabilityArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCreateDemoSiteArgs = {
  demoSiteType: DemoSiteType;
};


export type QueryDayAheadPricesArgs = {
  where: DayAheadPricesInput;
};


export type QueryDeploymentRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeploymentRequestsArgs = {
  skip?: Scalars['Int']['input'];
  status?: InputMaybe<Array<DeploymentRequestStatus>>;
  take?: Scalars['Int']['input'];
};


export type QueryDeviceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceAttributeValueArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceAttributeValuesArgs = {
  order?: InputMaybe<Array<DeviceAttributeValueSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceAttributeValueFilterInput>;
};


export type QueryDeviceGroupedSensorDataByViewsArgs = {
  where?: InputMaybe<QueryGroupFiltersMultipleInput>;
};


export type QueryDeviceModelArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceModelAttributeSetArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceModelAttributeSetsArgs = {
  order?: InputMaybe<Array<DeviceModelAttributeSetSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceModelAttributeSetFilterInput>;
};


export type QueryDeviceModelCapabilitiesArgs = {
  order?: InputMaybe<Array<DeviceModelCapabilitySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceModelCapabilityFilterInput>;
};


export type QueryDeviceModelCapabilityArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceModelsArgs = {
  order?: InputMaybe<Array<DeviceModelSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceModelFilterInput>;
};


export type QueryDeviceTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeviceTypesArgs = {
  order?: InputMaybe<Array<DeviceTypeSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceTypeFilterInput>;
};


export type QueryDeviceWithAttributesArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDevicesArgs = {
  order?: InputMaybe<Array<DeviceSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeviceFilterInput>;
};


export type QueryDevicesByBuildingsArgs = {
  order?: InputMaybe<Array<DevicesByBuildingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DevicesByBuildingFilterInput>;
};


export type QueryEnergyContractArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEnergyContractsArgs = {
  where: WhereGetEnergyContractsInput;
};


export type QueryEnergyDataByTypeArgs = {
  where: EnergyDataByTypeInput;
};


export type QueryEnergyFlowsArgs = {
  where: EnergyFlowsInput;
};


export type QueryEnergyFlowsV2Args = {
  where: QueryEnergyMetersInput;
};


export type QueryEnergyMeterDataQueryArgs = {
  where: EnergyMeterDataInput;
};


export type QueryEnergyRegressionBySensorsArgs = {
  where: EnergyRegressionBySensorsInput;
};


export type QueryEnergyRegressionQueryArgs = {
  where: EnergyRegressionInput;
};


export type QueryEnergySummaryArgs = {
  where: EnergySummaryBySpaceInput;
};


export type QueryFindingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindingCommentsArgs = {
  input?: InputMaybe<FindingCommentsInput>;
};


export type QueryFindingTimelineArgs = {
  input?: InputMaybe<FindingTimelineInput>;
};


export type QueryFindingsByProblemCaseArgs = {
  problemCaseId: Scalars['ID']['input'];
};


export type QueryFindingsByRuleIdArgs = {
  ruleId: Scalars['ID']['input'];
};


export type QueryGatewayDeviceConnectionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGatewayDeviceConnectionsArgs = {
  order?: InputMaybe<Array<GatewayDeviceConnectionSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GatewayDeviceConnectionFilterInput>;
};


export type QueryGetDashboardArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetRuleIdsWithOpenFindingsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryImageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryImagesArgs = {
  order?: InputMaybe<Array<ImageSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageFilterInput>;
};


export type QueryIndoorClimateStandardsArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIndoorClimateStandardsBySpaceQueryArgs = {
  where: IndoorClimateStandardsBySpaceInput;
};


export type QueryIpNetworkDevicesArgs = {
  filter?: InputMaybe<NetDeviceFilterInput>;
  ipNetworkId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DeviceSortField>;
  sortDir?: InputMaybe<NetSortDirection>;
};


export type QueryLatestSensorDataArgs = {
  deviceId: Scalars['UUID']['input'];
  deviceModelCapabilityIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  limitPerCapability?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLatestTimeseriesDataArgs = {
  limitPerTimeseries?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TimeseriesQueryFiltersInput>;
};


export type QueryListDashboardsArgs = {
  type?: InputMaybe<DashboardType>;
};


export type QueryLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLocationsArgs = {
  order?: InputMaybe<Array<LocationSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationFilterInput>;
};


export type QueryMappingAttributeDeviceModelAttributeSetArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMappingAttributeDeviceModelAttributeSetsArgs = {
  order?: InputMaybe<Array<MappingAttributeDeviceModelAttributeSetSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MappingAttributeDeviceModelAttributeSetFilterInput>;
};


export type QueryMappingDeviceBuildingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMappingDeviceBuildingsArgs = {
  order?: InputMaybe<Array<MappingDeviceBuildingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MappingDeviceBuildingFilterInput>;
};


export type QueryMappingDeviceImageArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMappingDeviceImagesArgs = {
  order?: InputMaybe<Array<MappingDeviceImageSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MappingDeviceImageFilterInput>;
};


export type QueryMappingDeviceZoneArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMappingDeviceZonesArgs = {
  order?: InputMaybe<Array<MappingDeviceZoneSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MappingDeviceZoneFilterInput>;
};


export type QueryMultipleDeviceSensorDataByViewsArgs = {
  where?: InputMaybe<QueryFiltersMultipleInput>;
};


export type QueryMultipleDeviceSensorDataInfoArgs = {
  queryFilters?: InputMaybe<Array<InputMaybe<QueryFiltersMultipleDeviceAndCapabilityInput>>>;
};


export type QueryMultipleTimeseriesDataArgs = {
  where?: InputMaybe<QueryFiltersMultipleTimeseriesInput>;
};


export type QueryNmcsAutomationNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNmcsIpNetworkDevicesArgs = {
  ipNetworkId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNmcsRemoteAccessSessionsArgs = {
  filter?: InputMaybe<NmcsSessionFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scopeId: Scalars['ID']['input'];
  scopeType: NmcsSessionScopeType;
};


export type QueryNmcsSiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNmcsSitesArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNmcsTenantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodeParentsArgs = {
  where: QueryNodeParentsInput;
};


export type QueryNodeUriInfosArgs = {
  where: NodeUriInfosInput;
};


export type QueryNodesSystemTypeArgs = {
  where: QueryNodesSystemTypesInput;
};


export type QueryPlacementOfDeviceArgs = {
  deviceId: Scalars['UUID']['input'];
};


export type QueryPointsByParentUriArgs = {
  where: Scalars['String']['input'];
};


export type QueryPointsByTimeseriesIdArgs = {
  where: Array<Scalars['UUID']['input']>;
};


export type QueryPointsByUrisArgs = {
  where: QueryPointsByUrisInput;
};


export type QueryProblemCaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRemoteAccessSessionsArgs = {
  filter?: InputMaybe<SessionFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scopeId: Scalars['ID']['input'];
  scopeType: SessionScopeType;
};


export type QueryResolveAllTimeseriesIdsByScoreTypeArgs = {
  scoreType: ScoreType;
  standardId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResolveEnergyMeterTimeseriesArgs = {
  where: QuerySpaceMetersSummaryInput;
};


export type QueryResolveRulesArgs = {
  where: QueryRulesInput;
};


export type QueryResolveRulesByExternalUriArgs = {
  where: QueryRulesByExternalUriInput;
};


export type QueryResolveSpaceSensorTimeseriesArgs = {
  where: QuerySpaceSensorInput;
};


export type QueryResolveTimeseriesIdArgs = {
  externalId: Scalars['String']['input'];
  selector: SelectorInput;
  standardId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResolveTimeseriesIdsByScoreTypesArgs = {
  standardId?: InputMaybe<Scalars['Int']['input']>;
  where: QueryResolveTimeseriesInput;
};


export type QueryRoomPointSystemTypesArgs = {
  where: QueryRoomPointSystemTypesInput;
};


export type QueryRuleAlarmQueryArgs = {
  where: RuleAlarmsByIdInput;
};


export type QueryRuleAlarmsBySpaceQueryArgs = {
  where: RuleAlarmsBySpaceInput;
};


export type QueryRulesByIdsArgs = {
  where: QueryRulesByIdInput;
};


export type QueryScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySchedulesArgs = {
  type: ScheduleType;
};


export type QueryScoreAtRunningMeanOutsideAirTempBySpaceQueryArgs = {
  where: ScoreTimeseriesBySpaceInput;
};


export type QueryScoreThresholdSettingByScoreTypeArgs = {
  externalId: Scalars['String']['input'];
  selector: SelectorInput;
  standardId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScoreThresholdSettingByScoreTypesArgs = {
  standardId?: InputMaybe<Scalars['Int']['input']>;
  where: QueryResolveTimeseriesInput;
};


export type QueryScoreTimeseriesBySpaceArgs = {
  where: ScoreTimeseriesBySpaceInput;
};


export type QuerySensorDataByTypesArgs = {
  where: SensorDataByTypesInput;
};


export type QuerySensorMeasurementsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryFiltersInput>;
};


export type QuerySensorMeasurementsInfoArgs = {
  where?: InputMaybe<SensorInfoQueryFilterInput>;
};


export type QuerySensorStatisticInformationArgs = {
  where?: InputMaybe<SensorStatisticQueryFiltersInput>;
};


export type QuerySensorTimeseriesBySpaceAndTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
  where: SensorTimeseriesBySpaceInput;
};


export type QuerySensorsStatisticsArgs = {
  where: SensorsStatisticsInput;
};


export type QuerySensorsWithBuildingPathArgs = {
  where: QuerySpaceSensorsWithPathInput;
};


export type QuerySimCardsArgs = {
  automationNetworkId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySiteArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySiteAttributeArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySiteAttributesArgs = {
  activeAt?: InputMaybe<Scalars['Date']['input']>;
  dataType?: InputMaybe<AttributeDataType>;
  entityId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySitesArgs = {
  order?: InputMaybe<Array<SiteSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SiteFilterInput>;
};


export type QuerySpaceSensorTypesArgs = {
  where: QuerySpaceSensorTypesInput;
};


export type QuerySpaceSystemsArgs = {
  where: QuerySpaceSystemCategoriesInput;
};


export type QuerySpaceTreeArgs = {
  where?: InputMaybe<QuerySpaceTreeInput>;
};


export type QuerySpacesSensorsByTypeArgs = {
  where: QuerySpacesByTypeInput;
};


export type QuerySpacesStatisticsArgs = {
  where: SpacesStatisticsInput;
};


export type QueryStoreyArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryStoreysArgs = {
  order?: InputMaybe<Array<StoreySortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoreyFilterInput>;
};


export type QuerySubsystemInstallationPartsArgs = {
  where: QuerySubsystemInput;
};


export type QuerySystemOrSubsystemInstallationPartsArgs = {
  where: QuerySystemOrSubsystemInput;
};


export type QuerySystemOrSubsystemInstallationPartsScoresArgs = {
  where: SubsystemInstallationPartsScoresInput;
};


export type QuerySystemsOrSubsystemsScoreBySpaceArgs = {
  where: SystemsOrSubsystemsScoresBySpaceInput;
};


export type QuerySystemsOrSubsystemsScoreBySpaceDetailArgs = {
  where: SystemsOrSubsystemsScoresBySpaceInput;
};


export type QuerySystemsScoreBySpaceArgs = {
  where: SystemsScoresBySpaceInput;
};


export type QueryTenantArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTicketByProblemCaseArgs = {
  problemCaseId: Scalars['ID']['input'];
};


export type QueryUnitArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUnitsArgs = {
  order?: InputMaybe<Array<UnitSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UnitFilterInput>;
};


export type QueryValidateIccidArgs = {
  iccid: Scalars['String']['input'];
};


export type QueryVpnNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWeatherInfoByCoordinatesArgs = {
  where: QueryWeatherInput;
};


export type QueryZoneArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryZoneAndBuildingFilterTableArgs = {
  order?: InputMaybe<Array<PlacementFilterRowSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlacementFilterRowFilterInput>;
};


export type QueryZoneFilterTableArgs = {
  order?: InputMaybe<Array<PlacementFilterRowSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PlacementFilterRowFilterInput>;
};


export type QueryZonesArgs = {
  order?: InputMaybe<Array<ZoneSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ZoneFilterInput>;
};

export type QueryDayAheadPricesInput = {
  areaCode: Scalars['String']['input'];
  periodEnd: Scalars['DateTime']['input'];
  periodStart: Scalars['DateTime']['input'];
};

export type QueryEnergyMetersInput = {
  mediumType: EnergyMediumType;
  space: SpaceInput;
};

export type QueryFiltersInput = {
  deviceId: Scalars['UUID']['input'];
  deviceModelCapabilityIds: Array<Scalars['UUID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryFiltersMultipleDeviceAndCapabilityInput = {
  deviceId: Scalars['UUID']['input'];
  deviceModelCapabilityIds?: InputMaybe<Array<InputMaybe<DeviceModelCapabilityIdsInput>>>;
};

export type QueryFiltersMultipleInput = {
  aggregationIntervalTypeActive?: InputMaybe<AggregationIntervals>;
  aggregationType?: InputMaybe<AggregationTypes>;
  baselineYear?: InputMaybe<Scalars['Int']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
  queryFiltersMultipleDeviceAndCapability?: InputMaybe<Array<InputMaybe<QueryFiltersMultipleDeviceAndCapabilityInput>>>;
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilNow?: InputMaybe<Scalars['Boolean']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  timeSpan?: InputMaybe<TimeSpans>;
};

export type QueryFiltersMultipleTimeseriesInput = {
  aggregationIntervalTypeActive?: InputMaybe<AggregationIntervals>;
  aggregationType?: InputMaybe<AggregationTypes>;
  baselineYear?: InputMaybe<Scalars['Int']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
  latestValuesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilNow?: InputMaybe<Scalars['Boolean']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  timeSpan?: InputMaybe<TimeSpans>;
  timeseriesIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type QueryGroupFiltersMultipleInput = {
  aggregationIntervalTypeActive?: InputMaybe<AggregationIntervals>;
  aggregationType?: InputMaybe<AggregationTypes>;
  baselineYear?: InputMaybe<Scalars['Int']['input']>;
  comparisonType?: InputMaybe<ComparisonType>;
  deviceModelCapabilityId: Scalars['UUID']['input'];
  limit: Scalars['Int']['input'];
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilNow?: InputMaybe<Scalars['Boolean']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  timeSpan?: InputMaybe<TimeSpans>;
};

export type QueryNodeParentsInput = {
  uri: Scalars['String']['input'];
};

export type QueryNodesSystemTypesInput = {
  systemTypes: Array<SystemsType>;
  uris: Array<Scalars['String']['input']>;
};

export type QueryPointsByUrisInput = {
  uris: Array<Scalars['String']['input']>;
};

export type QueryResolveTimeseriesInput = {
  externalIdScoreTypes: Array<ExternalIdScoreTypesInput>;
};

export type QueryRoomPointSystemTypesInput = {
  uris: Array<Scalars['String']['input']>;
};

export type QueryRulesByExternalUriInput = {
  alarmTypes: Array<AlarmType>;
  externalUri?: InputMaybe<Scalars['String']['input']>;
  externalUris?: InputMaybe<Array<Scalars['String']['input']>>;
  prefix?: Scalars['Boolean']['input'];
  severities: Array<Severity>;
};

export type QueryRulesByIdInput = {
  ruleIds: Array<Scalars['String']['input']>;
};

export type QueryRulesInput = {
  alarmTypes: Array<AlarmType>;
  externalIds: Array<Scalars['String']['input']>;
  severities: Array<Severity>;
};

export type QuerySpaceMetersSummaryInput = {
  meterTypes: Array<MetersType>;
  space: SpaceInput;
};

export type QuerySpaceSensorInput = {
  resolutionType: ResolutionType;
  sensorType: PointsType;
  space: SpaceInput;
};

export type QuerySpaceSensorTypesInput = {
  space: SpaceInput;
};

export type QuerySpaceSensorsWithPathInput = {
  sensorTypes: Array<PointsType>;
  space: SpaceInput;
};

export type QuerySpaceSystemCategoriesInput = {
  space: SpaceInput;
  systemTypes: Array<SystemsType>;
};

export type QuerySpaceTreeInput = {
  maxTreeDepth?: InputMaybe<Scalars['Int']['input']>;
  space?: InputMaybe<SpaceInput>;
};

export type QuerySpacesByTypeInput = {
  sensorTypes: Array<PointsType>;
  space: SpaceInput;
  spaceType: SpaceType;
};

export type QuerySubsystemInput = {
  categories: Array<CategoryType>;
  subsystem: NodeInput;
};

export type QuerySystemOrSubsystemInput = {
  categories: Array<CategoryType>;
  subsystem?: InputMaybe<SubsystemInput>;
  system: SystemInput;
};

export type QueryWeatherInput = {
  language: Scalars['String']['input'];
  latitude: Scalars['String']['input'];
  longitude: Scalars['String']['input'];
};

export type RemoteAccessSession = {
  __typename?: 'RemoteAccessSession';
  date?: Maybe<Scalars['DateTime']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type RemoteAccessSessionPage = {
  __typename?: 'RemoteAccessSessionPage';
  items?: Maybe<Array<Maybe<RemoteAccessSession>>>;
  page?: Maybe<Scalars['Int']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Report Request object */
export type ReportRequestInput = {
  /** File converted as base64 string */
  data: Scalars['String']['input'];
  /** User's emails that should receive notification */
  emails: Array<Scalars['String']['input']>;
  /** Report name */
  reportName: Scalars['String']['input'];
};

export enum ResolutionType {
  TowardsLeaf = 'TOWARDS_LEAF',
  TowardsRoot = 'TOWARDS_ROOT',
  TowardsRootAndLeaf = 'TOWARDS_ROOT_AND_LEAF'
}

export type Reviewer = {
  __typename?: 'Reviewer';
  displayName: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  vote: Scalars['Int']['output'];
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type RoomPointSystem = {
  __typename?: 'RoomPointSystem';
  id: Scalars['String']['output'];
  systemId: Scalars['String']['output'];
};

export type Router = {
  __typename?: 'Router';
  automationNetworkId?: Maybe<Scalars['ID']['output']>;
  firmware?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ConnectionStatus>;
  type?: Maybe<NetworkType>;
  vpnServer?: Maybe<Scalars['String']['output']>;
};

export type Rule = {
  __typename?: 'Rule';
  alarmType: AlarmType;
  description: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logicType: RuleLogicType;
  name: Scalars['String']['output'];
  severity: Severity;
  timeseriesId: Scalars['UUID']['output'];
};

export type RuleAlarm = {
  __typename?: 'RuleAlarm';
  alarmType: AlarmType;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parents?: Maybe<NodeParents>;
  severity: Severity;
  space: Space;
  state: AlarmState;
  systemType: SystemsType;
};

export type RuleAlarmFiltersInput = {
  alarmState?: InputMaybe<AlarmState>;
  alarmTypes: Array<AlarmType>;
  severities: Array<Severity>;
  systemTypes: Array<SystemsType>;
};

export type RuleAlarmWithHistory = {
  __typename?: 'RuleAlarmWithHistory';
  alarmType: AlarmType;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  parents: NodeParents;
  severity: Severity;
  state: AlarmState;
  stateHistory: Array<AlarmStateHistoryItem>;
};

export type RuleAlarmsByIdInput = {
  dataFilters: DataQueryFiltersInput;
  ruleId: Scalars['String']['input'];
};

export type RuleAlarmsBySpaceInput = {
  dataFilters: DataQueryFiltersInput;
  pagination?: InputMaybe<PaginationInput>;
  ruleAlarmFilters: RuleAlarmFiltersInput;
  space: SpaceInput;
};

export type RuleAlarmsWithTotal = {
  __typename?: 'RuleAlarmsWithTotal';
  ruleAlarms: Array<RuleAlarm>;
  total: Scalars['Int']['output'];
};

export type RuleFindingCount = {
  __typename?: 'RuleFindingCount';
  activeFindingCount: Scalars['Int']['output'];
  ruleId: Scalars['ID']['output'];
};

export type RuleFindingCountInput = {
  /** Number of open findings for this rule */
  findingCount: Scalars['Int']['input'];
  /** Rule ID */
  ruleId: Scalars['UUID']['input'];
};

export type RuleId = {
  __typename?: 'RuleId';
  value: Scalars['UUID']['output'];
};

export type RuleIdInput = {
  id: Scalars['ID']['input'];
};

export enum RuleLogicCategoryType {
  Energy = 'ENERGY',
  IndoorClimate = 'INDOOR_CLIMATE',
  Installation = 'INSTALLATION'
}

export enum RuleLogicType {
  EnergyAnomaly = 'ENERGY_ANOMALY',
  EnergyConsumptionAnomaly = 'ENERGY_CONSUMPTION_ANOMALY',
  Malfunction = 'MALFUNCTION',
  Performance = 'PERFORMANCE',
  RoomAirQuality = 'ROOM_AIR_QUALITY',
  RoomHumidity = 'ROOM_HUMIDITY',
  RoomHumidityHigh = 'ROOM_HUMIDITY_HIGH',
  RoomHumidityLow = 'ROOM_HUMIDITY_LOW',
  RoomTemperature = 'ROOM_TEMPERATURE',
  RoomTemperatureHigh = 'ROOM_TEMPERATURE_HIGH',
  RoomTemperatureLow = 'ROOM_TEMPERATURE_LOW',
  Stability = 'STABILITY',
  Unknown = 'UNKNOWN'
}

export type SaveAncillaryFileInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  contentBase64: Scalars['String']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  force?: Scalars['Boolean']['input'];
  kind?: InputMaybe<AncillaryFileKind>;
  name: Scalars['String']['input'];
};

export type SaveAncillaryFilePayload = {
  __typename?: 'SaveAncillaryFilePayload';
  created: Scalars['Boolean']['output'];
  file: AncillaryFile;
  version: AncillaryFileVersionInfo;
};

export type SaveTenantGraphInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  force?: Scalars['Boolean']['input'];
};

export type SaveTenantGraphPayload = {
  __typename?: 'SaveTenantGraphPayload';
  created: Scalars['Boolean']['output'];
  version: GraphVersionInfo;
};

export type Schedule = {
  __typename?: 'Schedule';
  channels: Array<ScheduleChannel>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  params: Array<ScheduleParam>;
  setting?: Maybe<ScheduleSetting>;
  type: ScheduleType;
};

export type ScheduleChannel = {
  __typename?: 'ScheduleChannel';
  type: ScheduleChannelType;
  value: Scalars['String']['output'];
};

export type ScheduleChannelInput = {
  type: ScheduleChannelType;
  value: Scalars['String']['input'];
};

export enum ScheduleChannelType {
  Email = 'EMAIL'
}

export type ScheduleInput = {
  channels: Array<ScheduleChannelInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  params?: InputMaybe<Array<ScheduleParamInput>>;
  setting?: InputMaybe<ScheduleSettingInput>;
  type: ScheduleType;
};

export type ScheduleParam = {
  __typename?: 'ScheduleParam';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ScheduleParamInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ScheduleSetting = {
  __typename?: 'ScheduleSetting';
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  frequency: ScheduleSettingFrequency;
  time: Scalars['String']['output'];
};

export enum ScheduleSettingFrequency {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ScheduleSettingInput = {
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  frequency: ScheduleSettingFrequency;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleTimeRange = {
  __typename?: 'ScheduleTimeRange';
  dayOfWeek: DayOfWeek;
  fromTime: Scalars['TimeSpan']['output'];
  id: Scalars['UUID']['output'];
  siteAttribute: SiteAttribute;
  siteAttributeId: Scalars['UUID']['output'];
  toTime: Scalars['TimeSpan']['output'];
  value: Scalars['Decimal']['output'];
};

export type ScheduleTimeRangeInput = {
  dayOfWeek: DayOfWeek;
  fromTime: Scalars['String']['input'];
  toTime: Scalars['String']['input'];
  value: Scalars['Decimal']['input'];
};

export enum ScheduleType {
  Report = 'REPORT'
}

export type Score = {
  __typename?: 'Score';
  scoreType: ScoreType;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ScoreData = {
  __typename?: 'ScoreData';
  aggregatedDataScoreInfo?: Maybe<AggregatedDataScoreInfo>;
  average?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  scoreThresholdInfoSet?: Maybe<ScoreThresholdInfoSet>;
  scoreType: ScoreType;
};

export enum ScoreRangeSettingType {
  Custom = 'CUSTOM',
  Dynamic = 'DYNAMIC',
  None = 'NONE',
  Static = 'STATIC'
}

export type ScoreThreshold = {
  __typename?: 'ScoreThreshold';
  cypherCode: Scalars['String']['output'];
  end: Scalars['Float']['output'];
  endPercentage: Scalars['Float']['output'];
  hexColor: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  startPercentage: Scalars['Float']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type ScoreThresholdInfo = {
  __typename?: 'ScoreThresholdInfo';
  end: Scalars['Float']['output'];
  endPercentage: Scalars['Float']['output'];
  hexColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
  start: Scalars['Float']['output'];
  startPercentage: Scalars['Float']['output'];
};

export type ScoreThresholdInfoSet = {
  __typename?: 'ScoreThresholdInfoSet';
  displayUnit: Scalars['String']['output'];
  scoreThresholdInfos: Array<ScoreThresholdInfo>;
};

export type ScoreThresholdSetting = {
  __typename?: 'ScoreThresholdSetting';
  cypherCode: Scalars['String']['output'];
  displayUnit: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  scoreRangeSettingType: ScoreRangeSettingType;
  scoreThresholds: Array<ScoreThreshold>;
  scoreType: AggregationSchema_ScoreType;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

export type ScoreTimeseriesBySpaceInput = {
  aggregationScoreType: ScoreType;
  dataFilters: DataQueryFiltersInput;
  groupDataForHeatMap?: InputMaybe<Scalars['Boolean']['input']>;
  spaceId: Scalars['String']['input'];
  spaceType: SpaceType;
  standardId?: InputMaybe<Scalars['Int']['input']>;
};

export enum ScoreType {
  Accuracy = 'ACCURACY',
  Co2 = 'CO2',
  Co2Deviation = 'CO2_DEVIATION',
  Co2DeviationOccupied = 'CO2_DEVIATION_OCCUPIED',
  Co2DeviationOccupiedClassA = 'CO2_DEVIATION_OCCUPIED_CLASS_A',
  Co2DeviationOccupiedClassB = 'CO2_DEVIATION_OCCUPIED_CLASS_B',
  Co2DeviationOccupiedClassC = 'CO2_DEVIATION_OCCUPIED_CLASS_C',
  Co2DeviationReal = 'CO2_DEVIATION_REAL',
  Co2DeviationRealOccupied = 'CO2_DEVIATION_REAL_OCCUPIED',
  Co2DeviationRealUnoccupied = 'CO2_DEVIATION_REAL_UNOCCUPIED',
  Co2DeviationSetpt = 'CO2_DEVIATION_SETPT',
  Co2DeviationSetptOccupied = 'CO2_DEVIATION_SETPT_OCCUPIED',
  Co2DeviationSetptOccupiedClassH = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  Co2DeviationSetptOccupiedClassL = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  Co2DeviationSetptOccupiedClassM = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  Co2DeviationSetptReal = 'CO2_DEVIATION_SETPT_REAL',
  Co2DeviationSetptRealOccupied = 'CO2_DEVIATION_SETPT_REAL_OCCUPIED',
  Co2DeviationSetptRealUnoccupied = 'CO2_DEVIATION_SETPT_REAL_UNOCCUPIED',
  Co2DeviationSetptUnoccupied = 'CO2_DEVIATION_SETPT_UNOCCUPIED',
  Co2DeviationUnoccupied = 'CO2_DEVIATION_UNOCCUPIED',
  Co2Occupied = 'CO2_OCCUPIED',
  Co2Unoccupied = 'CO2_UNOCCUPIED',
  Humidity = 'HUMIDITY',
  HumidityDeviation = 'HUMIDITY_DEVIATION',
  HumidityDeviationOccupied = 'HUMIDITY_DEVIATION_OCCUPIED',
  HumidityDeviationOccupiedClassA = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_A',
  HumidityDeviationOccupiedClassB = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_B',
  HumidityDeviationOccupiedClassC = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_C',
  HumidityDeviationReal = 'HUMIDITY_DEVIATION_REAL',
  HumidityDeviationRealOccupied = 'HUMIDITY_DEVIATION_REAL_OCCUPIED',
  HumidityDeviationRealUnoccupied = 'HUMIDITY_DEVIATION_REAL_UNOCCUPIED',
  HumidityDeviationSetpt = 'HUMIDITY_DEVIATION_SETPT',
  HumidityDeviationSetptOccupied = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED',
  HumidityDeviationSetptOccupiedClassH = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  HumidityDeviationSetptOccupiedClassL = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  HumidityDeviationSetptOccupiedClassM = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  HumidityDeviationSetptReal = 'HUMIDITY_DEVIATION_SETPT_REAL',
  HumidityDeviationSetptRealOccupied = 'HUMIDITY_DEVIATION_SETPT_REAL_OCCUPIED',
  HumidityDeviationSetptRealUnoccupied = 'HUMIDITY_DEVIATION_SETPT_REAL_UNOCCUPIED',
  HumidityDeviationSetptUnoccupied = 'HUMIDITY_DEVIATION_SETPT_UNOCCUPIED',
  HumidityDeviationUnoccupied = 'HUMIDITY_DEVIATION_UNOCCUPIED',
  HumidityOccupied = 'HUMIDITY_OCCUPIED',
  HumidityUnoccupied = 'HUMIDITY_UNOCCUPIED',
  None = 'NONE',
  OnlineStatus = 'ONLINE_STATUS',
  OperatingHours = 'OPERATING_HOURS',
  OutsideAirTemperature = 'OUTSIDE_AIR_TEMPERATURE',
  OutsideAirTemperatureRmot = 'OUTSIDE_AIR_TEMPERATURE_RMOT',
  Stability = 'STABILITY',
  StartStopCount = 'START_STOP_COUNT',
  Temperature = 'TEMPERATURE',
  TemperatureDeviation = 'TEMPERATURE_DEVIATION',
  TemperatureDeviationOccupied = 'TEMPERATURE_DEVIATION_OCCUPIED',
  TemperatureDeviationOccupiedClassA = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_A',
  TemperatureDeviationOccupiedClassB = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_B',
  TemperatureDeviationOccupiedClassC = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_C',
  TemperatureDeviationReal = 'TEMPERATURE_DEVIATION_REAL',
  TemperatureDeviationRealOccupied = 'TEMPERATURE_DEVIATION_REAL_OCCUPIED',
  TemperatureDeviationRealUnoccupied = 'TEMPERATURE_DEVIATION_REAL_UNOCCUPIED',
  TemperatureDeviationSetpt = 'TEMPERATURE_DEVIATION_SETPT',
  TemperatureDeviationSetptOccupied = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED',
  TemperatureDeviationSetptOccupiedClassH = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  TemperatureDeviationSetptOccupiedClassL = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  TemperatureDeviationSetptOccupiedClassM = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  TemperatureDeviationSetptReal = 'TEMPERATURE_DEVIATION_SETPT_REAL',
  TemperatureDeviationSetptRealOccupied = 'TEMPERATURE_DEVIATION_SETPT_REAL_OCCUPIED',
  TemperatureDeviationSetptRealUnoccupied = 'TEMPERATURE_DEVIATION_SETPT_REAL_UNOCCUPIED',
  TemperatureDeviationSetptUnoccupied = 'TEMPERATURE_DEVIATION_SETPT_UNOCCUPIED',
  TemperatureDeviationUnoccupied = 'TEMPERATURE_DEVIATION_UNOCCUPIED',
  TemperatureOccupied = 'TEMPERATURE_OCCUPIED',
  TemperatureUnoccupied = 'TEMPERATURE_UNOCCUPIED'
}

export type ScoreTypeAggregationInput = {
  aggregationTypeOverride?: InputMaybe<AggregationTypes>;
  scoreType: ScoreType;
};

export enum Selector1 {
  Consumption = 'CONSUMPTION',
  Generation = 'GENERATION'
}

export enum Selector2 {
  BathWaterTemperatureSensor = 'BATH_WATER_TEMPERATURE_SENSOR',
  BoilerTemperatureSensor = 'BOILER_TEMPERATURE_SENSOR',
  BufferTemperatureSensorHigh = 'BUFFER_TEMPERATURE_SENSOR_HIGH',
  BufferTemperatureSensorLow = 'BUFFER_TEMPERATURE_SENSOR_LOW',
  CapacitySensor = 'CAPACITY_SENSOR',
  ChilledWaterUsageSensor = 'CHILLED_WATER_USAGE_SENSOR',
  CombinedRoomHumiditySensor = 'COMBINED_ROOM_HUMIDITY_SENSOR',
  CombinedRoomTemperatureSensor = 'COMBINED_ROOM_TEMPERATURE_SENSOR',
  CommunicationState = 'COMMUNICATION_STATE',
  CopSensor = 'COP_SENSOR',
  ElectricEnergySensor = 'ELECTRIC_ENERGY_SENSOR',
  EnteringWaterTemperatureSensor = 'ENTERING_WATER_TEMPERATURE_SENSOR',
  EnteringWaterTemperatureSensorCchePrimary = 'ENTERING_WATER_TEMPERATURE_SENSOR_CCHE_PRIMARY',
  EnteringWaterTemperatureSensorCcheSecondary = 'ENTERING_WATER_TEMPERATURE_SENSOR_CCHE_SECONDARY',
  EnteringWaterTemperatureSensorDomesticHotWater = 'ENTERING_WATER_TEMPERATURE_SENSOR_DOMESTIC_HOT_WATER',
  ExhaustAirCo2Sensor = 'EXHAUST_AIR_CO2_SENSOR',
  ExhaustAirFlowSensor = 'EXHAUST_AIR_FLOW_SENSOR',
  ExhaustAirHumiditySensor = 'EXHAUST_AIR_HUMIDITY_SENSOR',
  ExhaustAirPressureSensor = 'EXHAUST_AIR_PRESSURE_SENSOR',
  ExhaustAirTemperatureSensor = 'EXHAUST_AIR_TEMPERATURE_SENSOR',
  ExhaustAirTemperatureSensorAfterHeatRecovery = 'EXHAUST_AIR_TEMPERATURE_SENSOR_AFTER_HEAT_RECOVERY',
  FrostAlarmState = 'FROST_ALARM_STATE',
  HotWaterUsageSensor = 'HOT_WATER_USAGE_SENSOR',
  IlluminanceSensor = 'ILLUMINANCE_SENSOR',
  IndoorAirCo2Sensor = 'INDOOR_AIR_CO2_SENSOR',
  IndoorAirHumiditySensor = 'INDOOR_AIR_HUMIDITY_SENSOR',
  IndoorAirPressureSensor = 'INDOOR_AIR_PRESSURE_SENSOR',
  IndoorAirQualitySensor = 'INDOOR_AIR_QUALITY_SENSOR',
  IndoorAirTemperatureSensor = 'INDOOR_AIR_TEMPERATURE_SENSOR',
  IndoorAirVocSensor = 'INDOOR_AIR_VOC_SENSOR',
  IndoorIlluminanceSensor = 'INDOOR_ILLUMINANCE_SENSOR',
  LeavingWaterDewpointSensor = 'LEAVING_WATER_DEWPOINT_SENSOR',
  LeavingWaterDewpointState = 'LEAVING_WATER_DEWPOINT_STATE',
  LeavingWaterTemperatureSensor = 'LEAVING_WATER_TEMPERATURE_SENSOR',
  LeavingWaterTemperatureSensorCchePrimary = 'LEAVING_WATER_TEMPERATURE_SENSOR_CCHE_PRIMARY',
  LeavingWaterTemperatureSensorCcheSecondary = 'LEAVING_WATER_TEMPERATURE_SENSOR_CCHE_SECONDARY',
  LeavingWaterTemperatureSensorDomesticHotWater = 'LEAVING_WATER_TEMPERATURE_SENSOR_DOMESTIC_HOT_WATER',
  NaturalGasUsageSensor = 'NATURAL_GAS_USAGE_SENSOR',
  OccupancyState = 'OCCUPANCY_STATE',
  OutdoorAirTemperature = 'OUTDOOR_AIR_TEMPERATURE',
  OutsideAirCo2Sensor = 'OUTSIDE_AIR_CO2_SENSOR',
  OutsideAirHumiditySensor = 'OUTSIDE_AIR_HUMIDITY_SENSOR',
  OutsideAirTemperatureSensor = 'OUTSIDE_AIR_TEMPERATURE_SENSOR',
  OutsideExhaustAirTemperatureSensor = 'OUTSIDE_EXHAUST_AIR_TEMPERATURE_SENSOR',
  OutsideIlluminanceSensor = 'OUTSIDE_ILLUMINANCE_SENSOR',
  OutsideSupplyAirTemperatureSensor = 'OUTSIDE_SUPPLY_AIR_TEMPERATURE_SENSOR',
  PressureDifferenceCoolingSensor = 'PRESSURE_DIFFERENCE_COOLING_SENSOR',
  PressureDifferenceSensor = 'PRESSURE_DIFFERENCE_SENSOR',
  PressureDifferenceState = 'PRESSURE_DIFFERENCE_STATE',
  ReturnAirCo2Sensor = 'RETURN_AIR_CO2_SENSOR',
  RoomAirTemperatureSensor = 'ROOM_AIR_TEMPERATURE_SENSOR',
  SupplyAirCo2Sensor = 'SUPPLY_AIR_CO2_SENSOR',
  SupplyAirFlowSensor = 'SUPPLY_AIR_FLOW_SENSOR',
  SupplyAirHumiditySensor = 'SUPPLY_AIR_HUMIDITY_SENSOR',
  SupplyAirPressureSensor = 'SUPPLY_AIR_PRESSURE_SENSOR',
  SupplyAirTemperatureSensor = 'SUPPLY_AIR_TEMPERATURE_SENSOR',
  SupplyAirTemperatureSensorAfterHeatRecovery = 'SUPPLY_AIR_TEMPERATURE_SENSOR_AFTER_HEAT_RECOVERY',
  SupplyMixAirTemperatureSensor = 'SUPPLY_MIX_AIR_TEMPERATURE_SENSOR',
  SystemWaterPressureSensor = 'SYSTEM_WATER_PRESSURE_SENSOR',
  ThermalEnergySensor = 'THERMAL_ENERGY_SENSOR',
  WaterUsageSensor = 'WATER_USAGE_SENSOR',
  WindDirectionSensor = 'WIND_DIRECTION_SENSOR',
  WindSpeedSensor = 'WIND_SPEED_SENSOR'
}

export type SelectorInput = {
  scoreType: AggregationSchema_ScoreType;
};

export type Sensor = {
  __typename?: 'Sensor';
  customText?: Maybe<Scalars['String']['output']>;
  hasControlLoop: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: PointsType;
};

export type SensorDataByTypesInput = {
  dataFilters: DataQueryFiltersInput;
  sensorTypes: Array<PointsType>;
  space: SpaceInput;
};

export type SensorDataByTypesResult = {
  __typename?: 'SensorDataByTypesResult';
  aggregationIntervalActive: AggregationIntervals;
  aggregationIntervalsList: Array<AggregationIntervals>;
  sensors: Array<SensorWithData>;
};

export type SensorInfoQueryFilterInput = {
  deviceId: Scalars['UUID']['input'];
  deviceModelCapabilityId: Scalars['UUID']['input'];
};

export type SensorMeasurement = {
  __typename?: 'SensorMeasurement';
  device: Device;
  deviceId: Scalars['UUID']['output'];
  deviceModelCapability?: Maybe<DeviceModelCapability>;
  deviceModelCapabilityId: Scalars['UUID']['output'];
  ingestedAt?: Maybe<Scalars['DateTime']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  measuredAt?: Maybe<Scalars['DateTime']['output']>;
  measuredTimeZone?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  utcTimeMeasured: Scalars['DateTime']['output'];
  valueBool?: Maybe<Scalars['Boolean']['output']>;
  valueDate?: Maybe<Scalars['DateTime']['output']>;
  valueDateTime?: Maybe<Scalars['DateTime']['output']>;
  valueDecimal?: Maybe<Scalars['Decimal']['output']>;
  valueDouble?: Maybe<Scalars['Float']['output']>;
  valueFloat?: Maybe<Scalars['Float']['output']>;
  valueInteger?: Maybe<Scalars['Int']['output']>;
  valueString?: Maybe<Scalars['String']['output']>;
};

/** A segment of a collection. */
export type SensorMeasurementsCollectionSegment = {
  __typename?: 'SensorMeasurementsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SensorMeasurement>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SensorMeasurementsInfo = {
  __typename?: 'SensorMeasurementsInfo';
  count: Scalars['Int']['output'];
  maxUtcTimeMeasured: Scalars['DateTime']['output'];
  minUtcTimeMeasured: Scalars['DateTime']['output'];
};

export type SensorStatisticInformation = {
  __typename?: 'SensorStatisticInformation';
  count: Scalars['Int']['output'];
  mesagesPerMinute: Scalars['Float']['output'];
  seconds: Scalars['Float']['output'];
  tenantId: Scalars['UUID']['output'];
  timeseriesId: Scalars['UUID']['output'];
  timestampMax: Scalars['DateTime']['output'];
  timestampMin: Scalars['DateTime']['output'];
};

export type SensorStatisticQueryFiltersInput = {
  messagePerMinuteThreashold?: InputMaybe<Scalars['Float']['input']>;
  secondsThreashold?: InputMaybe<Scalars['Float']['input']>;
};

export type SensorTimeseriesBySpaceInput = {
  dataFilters: DataQueryFiltersInput;
  resolutionType: ResolutionType;
  sensorType: PointsType;
  spaceId: Scalars['String']['input'];
  spaceType: SpaceType;
};

export type SensorWithBuildingPath = {
  __typename?: 'SensorWithBuildingPath';
  buildingPath: SpaceTree;
  equipment?: Maybe<BuildingInformationSchema_Equipment>;
  sensor: BuildingInformationSchema_Point;
  subsystem?: Maybe<Subsystem>;
  system?: Maybe<SystemNode>;
};

export type SensorWithData = {
  __typename?: 'SensorWithData';
  buildingPath: SpaceTree;
  data: Array<AggregatedData>;
  equipment?: Maybe<Equipment>;
  sensor: Point;
  subsystem?: Maybe<Subsystem>;
  system?: Maybe<System>;
  timeseriesId: Scalars['UUID']['output'];
};

export type SensorsStatisticsInformation = {
  __typename?: 'SensorsStatisticsInformation';
  bmsAddress?: Maybe<Scalars['String']['output']>;
  count: Scalars['Float']['output'];
  mesagesPerMinute: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pointId?: Maybe<Scalars['String']['output']>;
  seconds: Scalars['Float']['output'];
  tenantId: Scalars['UUID']['output'];
  timeseriesId: Scalars['UUID']['output'];
  timestampMax: Scalars['DateTime']['output'];
  timestampMin: Scalars['DateTime']['output'];
  type?: Maybe<PointsType>;
};

export type SensorsStatisticsInput = {
  messagePerMinuteThreashold?: InputMaybe<Scalars['Float']['input']>;
  secondsThreashold?: InputMaybe<Scalars['Float']['input']>;
};

export type ServiceInfo = {
  __typename?: 'ServiceInfo';
  dateTimeNow: Scalars['DateTime']['output'];
  daylightSavingTimeName?: Maybe<Scalars['String']['output']>;
  env?: Maybe<Scalars['String']['output']>;
  utcNow: Scalars['DateTime']['output'];
};

export type SessionFilterInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum SessionScopeType {
  AutomationNetwork = 'AUTOMATION_NETWORK',
  VpnNetwork = 'VPN_NETWORK'
}

export type Setting = {
  __typename?: 'Setting';
  id: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  settingType: SettingType;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type SettingInput = {
  id: Scalars['String']['input'];
  propertyName: Scalars['String']['input'];
  settingType: SettingType;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum SettingType {
  Fixed = 'FIXED',
  Global = 'GLOBAL',
  Local = 'LOCAL'
}

export enum Severity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type SharedAccessSignatureData = {
  __typename?: 'SharedAccessSignatureData';
  sharedAccessSignature: Scalars['String']['output'];
  sharedAccessSignatureExpiry: Scalars['DateTime']['output'];
};

export type SimCard = {
  __typename?: 'SimCard';
  automationNetworkId?: Maybe<Scalars['ID']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  iccid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<SimStatus>;
};

export enum SimStatus {
  Activating = 'ACTIVATING',
  ActivationFailed = 'ACTIVATION_FAILED',
  Active = 'ACTIVE',
  Deactivating = 'DEACTIVATING',
  DeactivationFailed = 'DEACTIVATION_FAILED',
  Inactive = 'INACTIVE'
}

/** I am a generated type! */
export type Site = {
  __typename?: 'Site';
  buildings: Array<Building>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['UUID']['output']>;
  inverseParentSite: Array<Site>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['UUID']['output']>;
  name: Scalars['String']['output'];
  parentSite?: Maybe<Site>;
  parentSiteId?: Maybe<Scalars['UUID']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


/** I am a generated type! */
export type SiteBuildingsArgs = {
  order?: InputMaybe<Array<BuildingSortInput>>;
  where?: InputMaybe<BuildingFilterInput>;
};


/** I am a generated type! */
export type SiteInverseParentSiteArgs = {
  order?: InputMaybe<Array<SiteSortInput>>;
  where?: InputMaybe<SiteFilterInput>;
};

export type SiteAttribute = {
  __typename?: 'SiteAttribute';
  dataType: AttributeDataType;
  entityId: Scalars['String']['output'];
  fromDate: Scalars['Date']['output'];
  id: Scalars['UUID']['output'];
  schedule: Array<ScheduleTimeRange>;
  tenantId: Scalars['UUID']['output'];
  timeseriesId: Scalars['UUID']['output'];
  toDate?: Maybe<Scalars['Date']['output']>;
};

export type SiteCreateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  parentSiteId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SiteFileChange = {
  __typename?: 'SiteFileChange';
  added: Scalars['Int']['output'];
  changed: Scalars['Boolean']['output'];
  flatModelCsv?: Maybe<Scalars['String']['output']>;
  isNew: Scalars['Boolean']['output'];
  newContent?: Maybe<Scalars['String']['output']>;
  removed: Scalars['Int']['output'];
  repoPath: Scalars['String']['output'];
  siteIris: Array<Scalars['String']['output']>;
  tripleCountAfter: Scalars['Int']['output'];
  tripleCountBefore: Scalars['Int']['output'];
};

export type SiteFilterInput = {
  and?: InputMaybe<Array<SiteFilterInput>>;
  buildings?: InputMaybe<ListFilterInputTypeOfBuildingFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  inverseParentSite?: InputMaybe<ListFilterInputTypeOfSiteFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<LocationFilterInput>;
  locationId?: InputMaybe<UuidOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteFilterInput>>;
  parentSite?: InputMaybe<SiteFilterInput>;
  parentSiteId?: InputMaybe<UuidOperationFilterInput>;
  siteId?: InputMaybe<UuidOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
};

export type SiteSetNullInputType = {
  buildings?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['Boolean']['input']>;
  inverseParentSite?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  parentSite?: InputMaybe<Scalars['Boolean']['input']>;
  parentSiteId?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SiteSortInput = {
  description?: InputMaybe<SortEnumType>;
  image?: InputMaybe<ImageSortInput>;
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  location?: InputMaybe<LocationSortInput>;
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentSite?: InputMaybe<SiteSortInput>;
  parentSiteId?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type SiteUpdateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  locationId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  parentSiteId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A segment of a collection. */
export type SitesCollectionSegment = {
  __typename?: 'SitesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Site>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum SortDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortInput = {
  direction?: InputMaybe<SortDirection>;
};

export enum SourceType {
  FeedIn = 'FEED_IN',
  Generated = 'GENERATED',
  SelfUsed = 'SELF_USED',
  Sourced = 'SOURCED'
}

export type Space = {
  __typename?: 'Space';
  id: Scalars['String']['output'];
  location?: Maybe<SpaceLocation>;
  name: Scalars['String']['output'];
  standards?: Maybe<Array<IndoorClimateStandardInfo>>;
  type: SpaceType;
};

export type SpaceAlarmCount = {
  __typename?: 'SpaceAlarmCount';
  activeCount: Scalars['Int']['output'];
  spaceId: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type SpaceEnergyMeterTimeseries = {
  __typename?: 'SpaceEnergyMeterTimeseries';
  artificialDatapoints?: Maybe<Array<PointsType>>;
  flowDirection: FlowDirection;
  meter: BuildingInformationSchema_Meter;
  sensor: EnergySensor;
  space: BuildingInformationSchema_Space;
  spaceTree?: Maybe<SpaceTree>;
  subsystem?: Maybe<Subsystem>;
  system?: Maybe<SystemNode>;
  timeseriesId: Scalars['UUID']['output'];
};

export type SpaceInput = {
  id: Scalars['String']['input'];
  type: SpaceType;
};

export type SpaceLocation = {
  __typename?: 'SpaceLocation';
  coordinates?: Maybe<Coordinates>;
};

export type SpaceNode = {
  __typename?: 'SpaceNode';
  id: Scalars['String']['output'];
  location?: Maybe<SpaceLocation>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  type: SpaceType;
};

export type SpaceSensorTimeseries = {
  __typename?: 'SpaceSensorTimeseries';
  sensorType: PointsType;
  space: BuildingInformationSchema_Space;
  /** @deprecated Use the `space` field instead */
  spaceId: Scalars['String']['output'];
  /** @deprecated Use the `space` field instead */
  spaceName: Scalars['String']['output'];
  /** @deprecated Use the `space` field instead */
  spaceType: SpaceType;
  timeseriesId: Scalars['UUID']['output'];
};

export type SpaceSensorTypeCount = {
  __typename?: 'SpaceSensorTypeCount';
  count: Scalars['Int']['output'];
  sensorType: PointsType;
};

export type SpaceSensorsWithParents = {
  __typename?: 'SpaceSensorsWithParents';
  parents: Array<BuildingInformationSchema_Space>;
  sensors: Array<BuildingInformationSchema_Point>;
  space: BuildingInformationSchema_Space;
};

export type SpaceTimeseriesInfo = {
  __typename?: 'SpaceTimeseriesInfo';
  data: Array<AggregatedData>;
  space: Space;
  /** @deprecated Use the `space` field instead */
  spaceId: Scalars['String']['output'];
  /** @deprecated Use the `space` field instead */
  spaceName: Scalars['String']['output'];
  /** @deprecated Use the `space` field instead */
  spaceType: SpaceType;
  timeseriesId: Scalars['UUID']['output'];
};

export type SpaceTree = {
  __typename?: 'SpaceTree';
  building?: Maybe<BuildingInformationSchema_Space>;
  level?: Maybe<BuildingInformationSchema_Space>;
  room?: Maybe<BuildingInformationSchema_Space>;
  site?: Maybe<BuildingInformationSchema_Space>;
  space: BuildingInformationSchema_Space;
  subBuilding?: Maybe<BuildingInformationSchema_Space>;
};

export enum SpaceType {
  Building = 'BUILDING',
  Level = 'LEVEL',
  Room = 'ROOM',
  Site = 'SITE',
  Space = 'SPACE',
  SubBuilding = 'SUB_BUILDING'
}

export type SpacesStatistics = {
  __typename?: 'SpacesStatistics';
  scoreData: Array<ScoreData>;
  space: Space;
  spaces: Array<Space>;
};

export type SpacesStatisticsInput = {
  dataFilters: DataQueryFiltersInput;
  scoreTypes: Array<ScoreType>;
  space: SpaceInput;
  spaceType: SpaceType;
  standardId?: InputMaybe<Scalars['Int']['input']>;
};

export enum SplitByType {
  Building = 'BUILDING',
  Level = 'LEVEL',
  Medium = 'MEDIUM',
  Meter = 'METER',
  None = 'NONE',
  Room = 'ROOM',
  Site = 'SITE',
  SubBuilding = 'SUB_BUILDING',
  Usage = 'USAGE'
}

/** I am a generated type! */
export type Storey = {
  __typename?: 'Storey';
  building: Building;
  buildingId: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['UUID']['output']>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  zones: Array<Zone>;
};


/** I am a generated type! */
export type StoreyZonesArgs = {
  order?: InputMaybe<Array<ZoneSortInput>>;
  where?: InputMaybe<ZoneFilterInput>;
};

export type StoreyCreateType = {
  buildingId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
};

export type StoreyFilterInput = {
  and?: InputMaybe<Array<StoreyFilterInput>>;
  building?: InputMaybe<BuildingFilterInput>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StoreyFilterInput>>;
  storeyId?: InputMaybe<UuidOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  zones?: InputMaybe<ListFilterInputTypeOfZoneFilterInput>;
};

export type StoreySetNullInputType = {
  building?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  zones?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoreySortInput = {
  building?: InputMaybe<BuildingSortInput>;
  buildingId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  image?: InputMaybe<ImageSortInput>;
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  storeyId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
};

export type StoreyUpdateType = {
  buildingId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type StoreysCollectionSegment = {
  __typename?: 'StoreysCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Storey>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  commissioningStatusChanged?: Maybe<Gateway_Gateway_Gateway>;
  /** Subscription providing updates when a device's connection state is changed. */
  deviceStateChanged: DeviceMessage;
};


export type SubscriptionCommissioningStatusChangedArgs = {
  gatewayIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type SubscriptionDeviceStateChangedArgs = {
  deviceId: Scalars['UUID']['input'];
};

export type Subsystem = {
  __typename?: 'Subsystem';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: SubsystemsType;
};

export type SubsystemInput = {
  id: Scalars['String']['input'];
  type: SubsystemsType;
};

export type SubsystemInstallationPartsScoresInput = {
  categoryScores: Array<CategoryScoresInput>;
  dataFilters: DataQueryFiltersInput;
  subsystem?: InputMaybe<SubsystemInput>;
  system: SystemInput;
};

export enum SubsystemsType {
  AfterheatersGroup = 'AFTERHEATERS_GROUP',
  AggregatedMetering = 'AGGREGATED_METERING',
  AirHandlingGroup = 'AIR_HANDLING_GROUP',
  AirHandlingUnit = 'AIR_HANDLING_UNIT',
  BiomassBoilerSystem = 'BIOMASS_BOILER_SYSTEM',
  BlindGroup = 'BLIND_GROUP',
  ChillerSystem = 'CHILLER_SYSTEM',
  ColdDistributionAftercoolers = 'COLD_DISTRIBUTION_AFTERCOOLERS',
  ConvectorGroup = 'CONVECTOR_GROUP',
  CoolerGroup = 'COOLER_GROUP',
  DistrictHeatingSystem = 'DISTRICT_HEATING_SYSTEM',
  DomesticHotWaterSystem = 'DOMESTIC_HOT_WATER_SYSTEM',
  ExhaustVentilationSystem = 'EXHAUST_VENTILATION_SYSTEM',
  FanCoilUnitGroup = 'FAN_COIL_UNIT_GROUP',
  FireDetectionSystem = 'FIRE_DETECTION_SYSTEM',
  GasBoilerSystem = 'GAS_BOILER_SYSTEM',
  GroundSourceGroup = 'GROUND_SOURCE_GROUP',
  HeaterGroup = 'HEATER_GROUP',
  HeatPumpSystem = 'HEAT_PUMP_SYSTEM',
  IndividualInstallationsMiscParts = 'INDIVIDUAL_INSTALLATIONS_MISC_PARTS',
  InductionUnitsGroup = 'INDUCTION_UNITS_GROUP',
  PhotovoltaicSystem = 'PHOTOVOLTAIC_SYSTEM',
  PoolGroup = 'POOL_GROUP',
  RadiantUnderfloorHeatingGroup = 'RADIANT_UNDERFLOOR_HEATING_GROUP',
  RadiatorGroup = 'RADIATOR_GROUP',
  SprinklerSystem = 'SPRINKLER_SYSTEM',
  SupplyVentilationSystem = 'SUPPLY_VENTILATION_SYSTEM',
  SwitchCabinetMiscParts = 'SWITCH_CABINET_MISC_PARTS',
  Unknown = 'UNKNOWN'
}

export type SummaryEnergyData = {
  __typename?: 'SummaryEnergyData';
  data: Array<SummaryEnergyDataByMedium>;
};

export type SummaryEnergyDataByChannel = {
  __typename?: 'SummaryEnergyDataByChannel';
  channel: ChannelType;
  total: Scalars['Float']['output'];
};

export type SummaryEnergyDataByMedium = {
  __typename?: 'SummaryEnergyDataByMedium';
  channelData: Array<SummaryEnergyDataByChannel>;
  medium: MediumType;
  unit: CombinedUnit;
};

export type System = {
  __typename?: 'System';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: SystemsType;
};

export type SystemEnergyNode = EnergyNode & {
  __typename?: 'SystemEnergyNode';
  dataSources?: Maybe<Array<EnergyNodeDataSource>>;
  id: Scalars['String']['output'];
  systemType?: Maybe<SubsystemsType>;
  type: EnergyNodeType;
};

export type SystemInput = {
  id: Scalars['String']['input'];
  type: SystemsType;
};

export type SystemNode = {
  __typename?: 'SystemNode';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: SystemsType;
};

export type SystemOrSubsystemsScore = {
  __typename?: 'SystemOrSubsystemsScore';
  alarms: AlarmsCount;
  score?: Maybe<Scalars['Float']['output']>;
  spaces: Array<Space>;
  subsystem?: Maybe<Subsystem>;
  system: System;
  systemType: SystemsType;
};

export type SystemOrSubsystemsScoreWithDetail = {
  __typename?: 'SystemOrSubsystemsScoreWithDetail';
  alarms: AlarmsCount;
  detail: Array<CategorizedInstallationPartsScores>;
  score?: Maybe<Scalars['Float']['output']>;
  spaces: Array<Space>;
  subsystem?: Maybe<Subsystem>;
  system: System;
  systemType: SystemsType;
};

export type SystemsOrSubsystemsScoresBySpaceInput = {
  dataFilters: DataQueryFiltersInput;
  space: SpaceInput;
  systemTypes: Array<SystemsType>;
};

export type SystemsScoresBySpaceInput = {
  dataFilters: DataQueryFiltersInput;
  space: SpaceInput;
};

export enum SystemsType {
  AirConditioning = 'AIR_CONDITIONING',
  ColdDistribution = 'COLD_DISTRIBUTION',
  ColdGeneration = 'COLD_GENERATION',
  DomesticHotWaterInstallation = 'DOMESTIC_HOT_WATER_INSTALLATION',
  ElectricalEnergyConsumption = 'ELECTRICAL_ENERGY_CONSUMPTION',
  ElectricalEnergyGeneration = 'ELECTRICAL_ENERGY_GENERATION',
  FireProtectionSystem = 'FIRE_PROTECTION_SYSTEM',
  HeatColdDistribution = 'HEAT_COLD_DISTRIBUTION',
  HeatColdGeneration = 'HEAT_COLD_GENERATION',
  HeatDistribution = 'HEAT_DISTRIBUTION',
  HeatGeneration = 'HEAT_GENERATION',
  IndividualInstallations = 'INDIVIDUAL_INSTALLATIONS',
  RoomControl = 'ROOM_CONTROL',
  SwitchCabinet = 'SWITCH_CABINET',
  Unknown = 'UNKNOWN'
}

export type TelemetryRecord = {
  __typename?: 'TelemetryRecord';
  utcTimeMeasured: Scalars['DateTime']['output'];
  valueCount: Scalars['Float']['output'];
  valueDouble: Scalars['Float']['output'];
  valueMax: Scalars['Float']['output'];
  valueMin: Scalars['Float']['output'];
  valueString?: Maybe<Scalars['String']['output']>;
};

export type Temperature = {
  __typename?: 'Temperature';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Tenant = {
  __typename?: 'Tenant';
  branchCode?: Maybe<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TenantGraph = {
  __typename?: 'TenantGraph';
  ancillaryFile?: Maybe<AncillaryFile>;
  ancillaryFiles: Array<AncillaryFile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  latestVersion?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['UUID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<GraphVersion>;
  versions: Array<GraphVersionInfo>;
};


export type TenantGraphAncillaryFileArgs = {
  name: Scalars['String']['input'];
};


export type TenantGraphAncillaryFilesArgs = {
  kind?: InputMaybe<AncillaryFileKind>;
  namePrefix?: InputMaybe<Scalars['String']['input']>;
  skip?: Scalars['Int']['input'];
  take?: Scalars['Int']['input'];
};


export type TenantGraphVersionArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type TenantGraphVersionsArgs = {
  skip?: Scalars['Int']['input'];
  source?: InputMaybe<GraphSource>;
  take?: Scalars['Int']['input'];
};

export type TenantId = {
  __typename?: 'TenantId';
  value: Scalars['UUID']['output'];
};

export type TenantInformation = {
  __typename?: 'TenantInformation';
  createdAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TestError = {
  __typename?: 'TestError';
  errorCode: Scalars['String']['output'];
};

export type ThresholdSettingWithScoreType = {
  __typename?: 'ThresholdSettingWithScoreType';
  externalId: Scalars['String']['output'];
  scoreThresholdSetting?: Maybe<ScoreThresholdSetting>;
  scoreType: AggregationSchema_ScoreType;
};

export type Ticket = {
  __typename?: 'Ticket';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  problemCaseId: Scalars['ID']['output'];
  status: TicketStatusType;
  statusForFindings?: Maybe<TicketStatusForFindingsType>;
  updatedAt: Scalars['String']['output'];
};

export type TicketInput = {
  status: TicketStatusType;
};

export enum TicketStatusForFindingsType {
  NoFindings = 'NO_FINDINGS',
  WithFindings = 'WITH_FINDINGS'
}

export enum TicketStatusType {
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export type TimeAndAggregationParameter = {
  __typename?: 'TimeAndAggregationParameter';
  aggregationIntervalActive: AggregationIntervals;
  aggregationIntervalDefault: AggregationIntervals;
  aggregationIntervalsList?: Maybe<Array<AggregationIntervals>>;
  aggregationType?: Maybe<AggregationTypes>;
  deviceAndCapabilityInfos?: Maybe<Array<Maybe<DeviceAndCapabilityInfo>>>;
};

export enum TimeSpans {
  Last_7Days = 'LAST_7_DAYS',
  Last_24Hour = 'LAST_24_HOUR',
  Last_30Days = 'LAST_30_DAYS',
  Last_366Days = 'LAST_366_DAYS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  LastYear = 'LAST_YEAR',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type TimeWindow = {
  __typename?: 'TimeWindow';
  cypherCode: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  minutes: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  useGapFill: Scalars['Boolean']['output'];
  windowType: TimeWindowType;
};

export enum TimeWindowType {
  Sliding = 'SLIDING',
  Tumbeling = 'TUMBELING'
}

export type TimelineJob = {
  __typename?: 'TimelineJob';
  finishTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  state: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TimelineStatisticsResult = {
  __typename?: 'TimelineStatisticsResult';
  statistics: Array<AlarmStatisticsData>;
  totalActiveDurationMinutes: Scalars['Float']['output'];
  totalAlertCount: Scalars['Int']['output'];
};

export type TimeseriesDataBySpaceAndSensorResult = {
  __typename?: 'TimeseriesDataBySpaceAndSensorResult';
  aggregationIntervalActive?: Maybe<AggregationIntervals>;
  spaceTimeseriesInfos: Array<SpaceTimeseriesInfo>;
};

export type TimeseriesDataBySpaceResult = {
  __typename?: 'TimeseriesDataBySpaceResult';
  aggregationIntervalActive: AggregationIntervals;
  timeseriesInfos: Array<TimeseriesInfo>;
};

export type TimeseriesDataPoint = {
  __typename?: 'TimeseriesDataPoint';
  mostAccurateTime: Scalars['DateTime']['output'];
  tenantId: Scalars['UUID']['output'];
  timeseriesId: Scalars['UUID']['output'];
  value: Scalars['Float']['output'];
};

export type TimeseriesIdScoreType = {
  __typename?: 'TimeseriesIdScoreType';
  externalId: Scalars['String']['output'];
  scoreType: AggregationSchema_ScoreType;
  timeseriesId: Scalars['UUID']['output'];
};

export type TimeseriesInfo = {
  __typename?: 'TimeseriesInfo';
  data: Array<AggregatedData>;
  scoreThresholdInfoSet: ScoreThresholdInfoSet;
  timeseriesId: Scalars['UUID']['output'];
};

export type TimeseriesQueryFiltersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  readFromUtc?: InputMaybe<Scalars['DateTime']['input']>;
  readUntilUtc?: InputMaybe<Scalars['DateTime']['input']>;
  timeseriesIds: Array<Scalars['UUID']['input']>;
};

export type TimeseriesRmotDataBySpaceResult = {
  __typename?: 'TimeseriesRmotDataBySpaceResult';
  aggregationIntervalActive: AggregationIntervals;
  timeseriesInfos: Array<TimeseriesRmotInfo>;
};

export type TimeseriesRmotInfo = {
  __typename?: 'TimeseriesRmotInfo';
  data: Array<AggregatedRmotData>;
  scoreThresholdInfoSet: ScoreThresholdInfoSet;
  timeseriesId: Scalars['UUID']['output'];
};

export type TimeseriesTelemetryRecord = {
  __typename?: 'TimeseriesTelemetryRecord';
  average: Scalars['Float']['output'];
  maxTimestamp?: Maybe<Scalars['DateTime']['output']>;
  minTimestamp?: Maybe<Scalars['DateTime']['output']>;
  sum: Scalars['Float']['output'];
  timestamp: Scalars['DateTime']['output'];
  /** @deprecated Use Average or Sum instead */
  value: Scalars['Float']['output'];
  valueCount: Scalars['Float']['output'];
  valueMax: Scalars['Float']['output'];
  valueMin: Scalars['Float']['output'];
};

export type TimeseriesTimeAndAggregationParameter = {
  __typename?: 'TimeseriesTimeAndAggregationParameter';
  aggregationIntervalActive: AggregationIntervals;
  aggregationIntervalDefault: AggregationIntervals;
  aggregationIntervalsList?: Maybe<Array<AggregationIntervals>>;
  aggregationType?: Maybe<AggregationTypes>;
  comparisonDateFrom?: Maybe<Scalars['DateTime']['output']>;
  comparisonDateUntil?: Maybe<Scalars['DateTime']['output']>;
  dateFrom: Scalars['DateTime']['output'];
  dateUntil: Scalars['DateTime']['output'];
  timeseriesInfos?: Maybe<Array<Maybe<DataSchema_TimeseriesInfo>>>;
};

export type Unit = {
  __typename?: 'Unit';
  deviceModelCapabilities: Array<DeviceModelCapability>;
  id: Scalars['UUID']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  unitSymbol?: Maybe<Scalars['String']['output']>;
  uris?: Maybe<Array<Scalars['String']['output']>>;
};


export type UnitDeviceModelCapabilitiesArgs = {
  order?: InputMaybe<Array<DeviceModelCapabilitySortInput>>;
  where?: InputMaybe<DeviceModelCapabilityFilterInput>;
};

export type UnitCreateType = {
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  /** MinLength=0, MaxLength=250 */
  unitSymbol?: InputMaybe<Scalars['String']['input']>;
  uris?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UnitFilterInput = {
  and?: InputMaybe<Array<UnitFilterInput>>;
  deviceModelCapabilities?: InputMaybe<ListFilterInputTypeOfDeviceModelCapabilityFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UnitFilterInput>>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  unitId?: InputMaybe<UuidOperationFilterInput>;
  unitSymbol?: InputMaybe<StringOperationFilterInput>;
  uris?: InputMaybe<ListStringOperationFilterInput>;
};

export type UnitSetNullInputType = {
  deviceModelCapabilities?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
  unitSymbol?: InputMaybe<Scalars['Boolean']['input']>;
  uris?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UnitSortInput = {
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  unitId?: InputMaybe<SortEnumType>;
  unitSymbol?: InputMaybe<SortEnumType>;
};

export type UnitUpdateType = {
  id: Scalars['UUID']['input'];
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=250 */
  unitSymbol?: InputMaybe<Scalars['String']['input']>;
  uris?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A segment of a collection. */
export type UnitsCollectionSegment = {
  __typename?: 'UnitsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Unit>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateEnergyContractInput = {
  factors?: InputMaybe<Array<EnergyContractFactorInput>>;
  flowDirection?: InputMaybe<FlowDirection>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  meterEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  utility?: InputMaybe<Utility>;
};

export type UpdateFindingCommentInput = {
  findingCommentId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type UpdateFindingInput = {
  analysis?: InputMaybe<Scalars['String']['input']>;
  findingState?: InputMaybe<FindingStateType>;
  followUpActions?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notification?: InputMaybe<Notification>;
  notifiedGroups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateSiteAttributeInput = {
  dataType?: InputMaybe<AttributeDataType>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  schedule?: InputMaybe<Array<ScheduleTimeRangeInput>>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateTicketInput = {
  status?: InputMaybe<TicketStatusType>;
  statusForFindings?: InputMaybe<TicketStatusForFindingsType>;
};

export type UsedIndoorClimateStandard = {
  __typename?: 'UsedIndoorClimateStandard';
  standards: Array<IndoorClimateStandard>;
  uri: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  businessPhones: Array<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
};

export type UserBaseInput = {
  /** Email address of the person */
  email: Scalars['String']['input'];
  /** Full name of the person */
  fullName: Scalars['String']['input'];
};

export enum Utility {
  Cooling = 'COOLING',
  ElectricalEnergy = 'ELECTRICAL_ENERGY',
  Gas = 'GAS',
  Heating = 'HEATING'
}

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValueEntity = {
  __typename?: 'ValueEntity';
  value?: Maybe<Scalars['String']['output']>;
};

export type ValueEntityFilterInput = {
  and?: InputMaybe<Array<ValueEntityFilterInput>>;
  or?: InputMaybe<Array<ValueEntityFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type Variable = {
  __typename?: 'Variable';
  cypherCode: Scalars['String']['output'];
  endiMatch: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  objectClassType: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
  variableType: VariableType;
  windowType: TimeWindowType;
};

export enum VariableType {
  Cache = 'CACHE',
  CacheHistory = 'CACHE_HISTORY',
  Stream = 'STREAM',
  StreamGroupWindow = 'STREAM_GROUP_WINDOW',
  StreamWindow = 'STREAM_WINDOW'
}

export type VpnNetwork = {
  __typename?: 'VpnNetwork';
  automationNetworks?: Maybe<Array<Maybe<AutomationNetwork>>>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRemoteAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  remoteAccessEnabled?: Maybe<Scalars['Boolean']['output']>;
  remoteSessions?: Maybe<Array<Maybe<RemoteAccessSession>>>;
  routersOnlineCount?: Maybe<Scalars['Int']['output']>;
  routersTotalCount?: Maybe<Scalars['Int']['output']>;
  salesManager?: Maybe<Scalars['String']['output']>;
  source?: Maybe<ManagementSource>;
  status?: Maybe<AggregatedStatus>;
  vpnServer?: Maybe<Scalars['String']['output']>;
};

/** Weather information for building location */
export type Weather = {
  __typename?: 'Weather';
  building?: Maybe<Building>;
  buildingId: Scalars['UUID']['output'];
  iceProbability: Scalars['Int']['output'];
  iconCode: Scalars['Int']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  phrase: Scalars['String']['output'];
  rainProbability: Scalars['Int']['output'];
  snowProbability: Scalars['Int']['output'];
  temperatureUnit: Scalars['String']['output'];
  temperatureValue: Scalars['Float']['output'];
  weatherId: Scalars['UUID']['output'];
};

export type WeatherAdjustment = {
  __typename?: 'WeatherAdjustment';
  applied: Scalars['Boolean']['output'];
  distanceKm?: Maybe<Scalars['Float']['output']>;
  months: Array<WeatherAdjustmentMonth>;
  referencePeriod?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<Scalars['String']['output']>;
  stationId?: Maybe<Scalars['String']['output']>;
};

export type WeatherAdjustmentMonth = {
  __typename?: 'WeatherAdjustmentMonth';
  actualDegreeDays: Scalars['Float']['output'];
  daysInRange: Scalars['Int']['output'];
  daysUsed: Scalars['Int']['output'];
  factor?: Maybe<Scalars['Float']['output']>;
  month: Scalars['Int']['output'];
  referenceDegreeDays: Scalars['Float']['output'];
  status: WeatherAdjustmentStatus;
  year: Scalars['Int']['output'];
};

export enum WeatherAdjustmentStatus {
  Adjusted = 'ADJUSTED',
  AdjustedPartialCoverage = 'ADJUSTED_PARTIAL_COVERAGE',
  NotAdjustedInsufficientDegreeDays = 'NOT_ADJUSTED_INSUFFICIENT_DEGREE_DAYS',
  NotAdjustedNoData = 'NOT_ADJUSTED_NO_DATA'
}

export type WeatherFilterInput = {
  and?: InputMaybe<Array<WeatherFilterInput>>;
  building?: InputMaybe<BuildingFilterInput>;
  buildingId?: InputMaybe<UuidOperationFilterInput>;
  iceProbability?: InputMaybe<IntOperationFilterInput>;
  iconCode?: InputMaybe<IntOperationFilterInput>;
  lastUpdated?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WeatherFilterInput>>;
  phrase?: InputMaybe<StringOperationFilterInput>;
  rainProbability?: InputMaybe<IntOperationFilterInput>;
  snowProbability?: InputMaybe<IntOperationFilterInput>;
  temperatureUnit?: InputMaybe<StringOperationFilterInput>;
  temperatureValue?: InputMaybe<FloatOperationFilterInput>;
  weatherId?: InputMaybe<UuidOperationFilterInput>;
};

export type WeatherSortInput = {
  building?: InputMaybe<BuildingSortInput>;
  buildingId?: InputMaybe<SortEnumType>;
  iceProbability?: InputMaybe<SortEnumType>;
  iconCode?: InputMaybe<SortEnumType>;
  lastUpdated?: InputMaybe<SortEnumType>;
  phrase?: InputMaybe<SortEnumType>;
  rainProbability?: InputMaybe<SortEnumType>;
  snowProbability?: InputMaybe<SortEnumType>;
  temperatureUnit?: InputMaybe<SortEnumType>;
  temperatureValue?: InputMaybe<SortEnumType>;
  weatherId?: InputMaybe<SortEnumType>;
};

export type WhereGetEnergyContractsInput = {
  activeAt?: InputMaybe<Scalars['Date']['input']>;
  meterEntityId?: InputMaybe<Scalars['String']['input']>;
  utility?: InputMaybe<Utility>;
};

export type Widget = {
  __typename?: 'Widget';
  configuration?: Maybe<DashboardWidgetConfiguration>;
  id: Scalars['String']['output'];
  position: Position;
  /** @deprecated Use configuration */
  settings: Array<Setting>;
  type: WidgetType;
};

export type WidgetInput = {
  configuration?: InputMaybe<DashboardWidgetConfigurationInput>;
  id: Scalars['String']['input'];
  position: PositionInput;
  settings?: InputMaybe<Array<SettingInput>>;
  type: WidgetType;
};

export enum WidgetType {
  AlarmOverview = 'ALARM_OVERVIEW',
  CommonText = 'COMMON_TEXT',
  CommonWeather = 'COMMON_WEATHER',
  EnergyAnalysis = 'ENERGY_ANALYSIS',
  EnergyConsumption = 'ENERGY_CONSUMPTION',
  EnergyConsumptionProfile = 'ENERGY_CONSUMPTION_PROFILE',
  EnergyDynamicPricing = 'ENERGY_DYNAMIC_PRICING',
  EnergyEmission = 'ENERGY_EMISSION',
  EnergyEvaluation = 'ENERGY_EVALUATION',
  EnergyMeterReadings = 'ENERGY_METER_READINGS',
  EnergyRegression = 'ENERGY_REGRESSION',
  EnergySpending = 'ENERGY_SPENDING',
  EnergySummary = 'ENERGY_SUMMARY',
  IndoorClimateCorrelation = 'INDOOR_CLIMATE_CORRELATION',
  IndoorClimateOverview = 'INDOOR_CLIMATE_OVERVIEW',
  IndoorClimateScore = 'INDOOR_CLIMATE_SCORE',
  InstallationCategoryScore = 'INSTALLATION_CATEGORY_SCORE',
  InstallationPerformance = 'INSTALLATION_PERFORMANCE',
  InstallationSensorValues = 'INSTALLATION_SENSOR_VALUES'
}

/** I am a generated type! */
export type Zone = {
  __typename?: 'Zone';
  description?: Maybe<Scalars['String']['output']>;
  dimension?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['UUID']['output']>;
  inverseParentZone: Array<Zone>;
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  mappingDeviceZones: Array<MappingDeviceZone>;
  name: Scalars['String']['output'];
  parentZone?: Maybe<Zone>;
  parentZoneId?: Maybe<Scalars['UUID']['output']>;
  storey: Storey;
  storeyId: Scalars['UUID']['output'];
  tenantId?: Maybe<Scalars['UUID']['output']>;
};


/** I am a generated type! */
export type ZoneInverseParentZoneArgs = {
  order?: InputMaybe<Array<ZoneSortInput>>;
  where?: InputMaybe<ZoneFilterInput>;
};


/** I am a generated type! */
export type ZoneMappingDeviceZonesArgs = {
  order?: InputMaybe<Array<MappingDeviceZoneSortInput>>;
  where?: InputMaybe<MappingDeviceZoneFilterInput>;
};

/** A segment of a collection. */
export type ZoneAndBuildingFilterTableCollectionSegment = {
  __typename?: 'ZoneAndBuildingFilterTableCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PlacementFilterRow>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ZoneCreateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  dimension?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name: Scalars['String']['input'];
  parentZoneId?: InputMaybe<Scalars['UUID']['input']>;
  storeyId: Scalars['UUID']['input'];
};

export type ZoneFilterInput = {
  and?: InputMaybe<Array<ZoneFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  dimension?: InputMaybe<StringOperationFilterInput>;
  image?: InputMaybe<ImageFilterInput>;
  imageId?: InputMaybe<UuidOperationFilterInput>;
  inverseParentZone?: InputMaybe<ListFilterInputTypeOfZoneFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  mappingDeviceZones?: InputMaybe<ListFilterInputTypeOfMappingDeviceZoneFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ZoneFilterInput>>;
  parentZone?: InputMaybe<ZoneFilterInput>;
  parentZoneId?: InputMaybe<UuidOperationFilterInput>;
  storey?: InputMaybe<StoreyFilterInput>;
  storeyId?: InputMaybe<UuidOperationFilterInput>;
  tenantId?: InputMaybe<UuidOperationFilterInput>;
  zoneId?: InputMaybe<UuidOperationFilterInput>;
};

/** A segment of a collection. */
export type ZoneFilterTableCollectionSegment = {
  __typename?: 'ZoneFilterTableCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PlacementFilterRow>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ZoneSetNullInputType = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dimension?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['Boolean']['input']>;
  imageId?: InputMaybe<Scalars['Boolean']['input']>;
  inverseParentZone?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  mappingDeviceZones?: InputMaybe<Scalars['Boolean']['input']>;
  parentZone?: InputMaybe<Scalars['Boolean']['input']>;
  parentZoneId?: InputMaybe<Scalars['Boolean']['input']>;
  storey?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZoneSortInput = {
  description?: InputMaybe<SortEnumType>;
  dimension?: InputMaybe<SortEnumType>;
  image?: InputMaybe<ImageSortInput>;
  imageId?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentZone?: InputMaybe<ZoneSortInput>;
  parentZoneId?: InputMaybe<SortEnumType>;
  storey?: InputMaybe<StoreySortInput>;
  storeyId?: InputMaybe<SortEnumType>;
  tenantId?: InputMaybe<SortEnumType>;
  zoneId?: InputMaybe<SortEnumType>;
};

export type ZoneUpdateType = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** MinLength=0, MaxLength=100 */
  dimension?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  imageId?: InputMaybe<Scalars['UUID']['input']>;
  /** MinLength=0, MaxLength=250 */
  name?: InputMaybe<Scalars['String']['input']>;
  parentZoneId?: InputMaybe<Scalars['UUID']['input']>;
  storeyId?: InputMaybe<Scalars['UUID']['input']>;
};

/** A segment of a collection. */
export type ZonesCollectionSegment = {
  __typename?: 'ZonesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Zone>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum AggregationSchema_ScoreType {
  Accuracy = 'ACCURACY',
  Co2 = 'CO2',
  Co2Deviation = 'CO2_DEVIATION',
  Co2DeviationOccupied = 'CO2_DEVIATION_OCCUPIED',
  Co2DeviationOccupiedClassA = 'CO2_DEVIATION_OCCUPIED_CLASS_A',
  Co2DeviationOccupiedClassB = 'CO2_DEVIATION_OCCUPIED_CLASS_B',
  Co2DeviationOccupiedClassC = 'CO2_DEVIATION_OCCUPIED_CLASS_C',
  Co2DeviationReal = 'CO2_DEVIATION_REAL',
  Co2DeviationRealOccupied = 'CO2_DEVIATION_REAL_OCCUPIED',
  Co2DeviationRealUnoccupied = 'CO2_DEVIATION_REAL_UNOCCUPIED',
  Co2DeviationSetpt = 'CO2_DEVIATION_SETPT',
  Co2DeviationSetptOccupied = 'CO2_DEVIATION_SETPT_OCCUPIED',
  Co2DeviationSetptOccupiedClassH = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  Co2DeviationSetptOccupiedClassL = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  Co2DeviationSetptOccupiedClassM = 'CO2_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  Co2DeviationSetptReal = 'CO2_DEVIATION_SETPT_REAL',
  Co2DeviationSetptRealOccupied = 'CO2_DEVIATION_SETPT_REAL_OCCUPIED',
  Co2DeviationSetptRealUnoccupied = 'CO2_DEVIATION_SETPT_REAL_UNOCCUPIED',
  Co2DeviationSetptUnoccupied = 'CO2_DEVIATION_SETPT_UNOCCUPIED',
  Co2DeviationUnoccupied = 'CO2_DEVIATION_UNOCCUPIED',
  Co2Occupied = 'CO2_OCCUPIED',
  Co2Unoccupied = 'CO2_UNOCCUPIED',
  EnergyMeterConsumption = 'ENERGY_METER_CONSUMPTION',
  EnergyMeterCosts = 'ENERGY_METER_COSTS',
  EnergyMeterEmissionsCo2 = 'ENERGY_METER_EMISSIONS_CO2',
  EnergyMeterFactorCo2 = 'ENERGY_METER_FACTOR_CO2',
  EnergyMeterFactorCosts = 'ENERGY_METER_FACTOR_COSTS',
  Humidity = 'HUMIDITY',
  HumidityDeviation = 'HUMIDITY_DEVIATION',
  HumidityDeviationOccupied = 'HUMIDITY_DEVIATION_OCCUPIED',
  HumidityDeviationOccupiedClassA = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_A',
  HumidityDeviationOccupiedClassB = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_B',
  HumidityDeviationOccupiedClassC = 'HUMIDITY_DEVIATION_OCCUPIED_CLASS_C',
  HumidityDeviationReal = 'HUMIDITY_DEVIATION_REAL',
  HumidityDeviationRealOccupied = 'HUMIDITY_DEVIATION_REAL_OCCUPIED',
  HumidityDeviationRealUnoccupied = 'HUMIDITY_DEVIATION_REAL_UNOCCUPIED',
  HumidityDeviationSetpt = 'HUMIDITY_DEVIATION_SETPT',
  HumidityDeviationSetptOccupied = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED',
  HumidityDeviationSetptOccupiedClassH = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  HumidityDeviationSetptOccupiedClassL = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  HumidityDeviationSetptOccupiedClassM = 'HUMIDITY_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  HumidityDeviationSetptReal = 'HUMIDITY_DEVIATION_SETPT_REAL',
  HumidityDeviationSetptRealOccupied = 'HUMIDITY_DEVIATION_SETPT_REAL_OCCUPIED',
  HumidityDeviationSetptRealUnoccupied = 'HUMIDITY_DEVIATION_SETPT_REAL_UNOCCUPIED',
  HumidityDeviationSetptUnoccupied = 'HUMIDITY_DEVIATION_SETPT_UNOCCUPIED',
  HumidityDeviationUnoccupied = 'HUMIDITY_DEVIATION_UNOCCUPIED',
  HumidityOccupied = 'HUMIDITY_OCCUPIED',
  HumidityUnoccupied = 'HUMIDITY_UNOCCUPIED',
  None = 'NONE',
  OnlineStatus = 'ONLINE_STATUS',
  OperatingHours = 'OPERATING_HOURS',
  OutsideAirTemperature = 'OUTSIDE_AIR_TEMPERATURE',
  OutsideAirTemperatureRmot = 'OUTSIDE_AIR_TEMPERATURE_RMOT',
  Stability = 'STABILITY',
  StartStopCount = 'START_STOP_COUNT',
  Temperature = 'TEMPERATURE',
  TemperatureDeviation = 'TEMPERATURE_DEVIATION',
  TemperatureDeviationOccupied = 'TEMPERATURE_DEVIATION_OCCUPIED',
  TemperatureDeviationOccupiedClassA = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_A',
  TemperatureDeviationOccupiedClassB = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_B',
  TemperatureDeviationOccupiedClassC = 'TEMPERATURE_DEVIATION_OCCUPIED_CLASS_C',
  TemperatureDeviationReal = 'TEMPERATURE_DEVIATION_REAL',
  TemperatureDeviationRealOccupied = 'TEMPERATURE_DEVIATION_REAL_OCCUPIED',
  TemperatureDeviationRealUnoccupied = 'TEMPERATURE_DEVIATION_REAL_UNOCCUPIED',
  TemperatureDeviationSetpt = 'TEMPERATURE_DEVIATION_SETPT',
  TemperatureDeviationSetptOccupied = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED',
  TemperatureDeviationSetptOccupiedClassH = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_H',
  TemperatureDeviationSetptOccupiedClassL = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_L',
  TemperatureDeviationSetptOccupiedClassM = 'TEMPERATURE_DEVIATION_SETPT_OCCUPIED_CLASS_M',
  TemperatureDeviationSetptReal = 'TEMPERATURE_DEVIATION_SETPT_REAL',
  TemperatureDeviationSetptRealOccupied = 'TEMPERATURE_DEVIATION_SETPT_REAL_OCCUPIED',
  TemperatureDeviationSetptRealUnoccupied = 'TEMPERATURE_DEVIATION_SETPT_REAL_UNOCCUPIED',
  TemperatureDeviationSetptUnoccupied = 'TEMPERATURE_DEVIATION_SETPT_UNOCCUPIED',
  TemperatureDeviationUnoccupied = 'TEMPERATURE_DEVIATION_UNOCCUPIED',
  TemperatureOccupied = 'TEMPERATURE_OCCUPIED',
  TemperatureUnoccupied = 'TEMPERATURE_UNOCCUPIED'
}

export type AlarmSchema_AlarmCountResult = {
  __typename?: 'alarmSchema_AlarmCountResult';
  /** Total count of active alarms */
  activeCount: Scalars['Int']['output'];
  /** Total count of open findings for active alarms */
  activeFindings: Scalars['Int']['output'];
  /** Total count of inactive alarms that have open findings */
  inactiveCount: Scalars['Int']['output'];
  /** Total count of open findings for inactive alarms */
  inactiveFindings: Scalars['Int']['output'];
};

export type BuildingInformationSchema_EnergyFlows = {
  __typename?: 'buildingInformationSchema_EnergyFlows';
  energyFlowEdges: Array<EnergyFlow>;
  energyNodes: Array<EnergyNode>;
};

export type BuildingInformationSchema_Equipment = {
  __typename?: 'buildingInformationSchema_Equipment';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  points: Array<BuildingInformationSchema_Point>;
  type: EquipmentType;
};

export type BuildingInformationSchema_InstallationPartControlLoop = BuildingInformationSchema_InstallationPartTyped & {
  __typename?: 'buildingInformationSchema_InstallationPartControlLoop';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  points: Array<BuildingInformationSchema_InstallationPartPoint>;
};

export type BuildingInformationSchema_InstallationPartEquipment = BuildingInformationSchema_InstallationPartTyped & {
  __typename?: 'buildingInformationSchema_InstallationPartEquipment';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  points: Array<BuildingInformationSchema_InstallationPartPoint>;
  type: EquipmentType;
};

export type BuildingInformationSchema_InstallationPartPoint = BuildingInformationSchema_InstallationPartTyped & {
  __typename?: 'buildingInformationSchema_InstallationPartPoint';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Array<Metadata>>;
  name: Scalars['String']['output'];
  timeseriesId: Scalars['String']['output'];
  type: PointsType;
};

export type BuildingInformationSchema_InstallationPartTyped = {
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type BuildingInformationSchema_Meter = {
  __typename?: 'buildingInformationSchema_Meter';
  customText?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<MeterDataType>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: MetersType;
};

export type BuildingInformationSchema_NodeParents = {
  __typename?: 'buildingInformationSchema_NodeParents';
  equipment?: Maybe<BuildingInformationSchema_Equipment>;
  nodeId?: Maybe<Scalars['String']['output']>;
  sensor?: Maybe<Sensor>;
  spaces: Array<BuildingInformationSchema_Space>;
  subsystem?: Maybe<Subsystem>;
  system?: Maybe<SystemNode>;
};

export type BuildingInformationSchema_Point = {
  __typename?: 'buildingInformationSchema_Point';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  timeseriesId: Scalars['UUID']['output'];
  type: PointsType;
};

export type BuildingInformationSchema_Space = {
  __typename?: 'buildingInformationSchema_Space';
  id: Scalars['String']['output'];
  location?: Maybe<SpaceLocation>;
  name: Scalars['String']['output'];
  type: SpaceType;
};

export type BuildingInformationSchema_System = {
  __typename?: 'buildingInformationSchema_System';
  customText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  spaces: Array<BuildingInformationSchema_Space>;
  subsystems: Array<Subsystem>;
  type: SystemsType;
};

export type DataSchema_TimeseriesInfo = {
  __typename?: 'dataSchema_TimeseriesInfo';
  gap: Scalars['Int']['output'];
  telemetryRecords?: Maybe<Array<Maybe<TimeseriesTelemetryRecord>>>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  timeseriesId: Scalars['UUID']['output'];
};
